"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3376],{

/***/ 13704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ HorDefault_AppFixedFooter; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@common/utility/AppContextProvider/LayoutContextProvider.js
var LayoutContextProvider = __webpack_require__(38638);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(32245);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(94581);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(12307);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/@common/core/AppLayout/HorDefault/AppFixedFooter/FooterWrapper.js








var FooterWrapper = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        sx: {
            position: "fixed",
            left: 0,
            bottom: 0,
            width: "100%",
            zIndex: 1102,
            boxShadow: "none",
            border: "1px solid #e8e5dd",
            backgroundColor: function(theme) {
                return theme.palette.background.paper;
            },
            backgroundImage: function(theme) {
                return "linear-gradient(".concat((0,colorManipulator/* alpha */.Fq)(theme.palette.common.white, 0.05), ", ").concat((0,colorManipulator/* alpha */.Fq)(theme.palette.common.white, 0.05), ")");
            },
            color: function(theme) {
                return theme.palette.text.primary;
            },
            margin: "0",
            "& .footerContainer": {
                alignItems: "center",
                flexDirection: "row",
                display: "flex",
                padding: {
                    xs: "5px 20px",
                    md: "5px 32px",
                    xl: "10px 32px"
                }
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var AppFixedFooter_FooterWrapper = (FooterWrapper);
FooterWrapper.propTypes = {
    children: (prop_types_default()).node,
    sidebarHeaderColor: (prop_types_default()).string
};

// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(90087);
;// CONCATENATED MODULE: ./src/@common/core/AppLayout/HorDefault/AppFixedFooter/FooterNotFixedWrapper.js








var FooterNotFixedWrapper = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            style: {
                position: "relative",
                background: "#C7262E url(/assets/images/footer.png) center top no-repeat",
                paddingTop: "30px",
                fontSize: "13px"
            },
            sx: {
                // marginBottom: '-58px',
                width: "100%",
                boxShadow: "none",
                border: "1px solid #e8e5dd",
                backgroundColor: function(theme) {
                    return theme.palette.secondary.mauExtension;
                },
                backgroundImage: function(theme) {
                    return "linear-gradient(".concat((0,colorManipulator/* alpha */.Fq)(theme.palette.common.white, 0.05), ", ").concat((0,colorManipulator/* alpha */.Fq)(theme.palette.common.white, 0.05), ")");
                },
                color: function(theme) {
                    return theme.palette.grey["50"];
                },
                "& .footerContainer": {
                    alignItems: "center",
                    flexDirection: "row",
                    display: "flex",
                    padding: {
                        xs: "5px 10px",
                        md: "5px 32px",
                        xl: "10px 0px"
                    }
                },
                mx: "auto"
            }
        }, rest), {
            children: children
        }))
    });
};
/* harmony default export */ var AppFixedFooter_FooterNotFixedWrapper = (FooterNotFixedWrapper);
FooterNotFixedWrapper.propTypes = {
    children: (prop_types_default()).node,
    sidebarHeaderColor: (prop_types_default()).string
};

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/redux/actions/Customer.js + 1 modules
var Customer = __webpack_require__(10988);
// EXTERNAL MODULE: ./node_modules/@mui/material/Hidden/Hidden.js + 4 modules
var Hidden = __webpack_require__(57999);
// EXTERNAL MODULE: ./src/shared/constants/AppEnums.js
var AppEnums = __webpack_require__(92446);
// EXTERNAL MODULE: ./src/@common/core/AppMuiImage/index.js + 1 modules
var AppMuiImage = __webpack_require__(29220);
;// CONCATENATED MODULE: ./src/@common/core/AppLayout/HorDefault/AppFixedFooter/index.js














var AppFixedFooter = function() {
    var ref = (0,LayoutContextProvider/* useLayoutContext */.l5)(), footer = ref.footer, footerType = ref.footerType;
    var dispatch = (0,es/* useDispatch */.I0)();
    var dataFooter = (0,es/* useSelector */.v9)(function(param) {
        var customerApp = param.customerApp;
        return customerApp.dataFooter;
    });
    var layoutClient = (0,es/* useSelector */.v9)(function(param) {
        var layoutClientApp = param.layoutClientApp;
        return layoutClientApp.layoutClientList;
    });
    (0,react.useEffect)(function() {
        dispatch((0,Customer/* onGetDataFooter */.Yw)());
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: footer && footerType === "fixed" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AppFixedFooter_FooterWrapper, {
            className: "footer fixed-footer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "footerContainer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    children: "Copy right @3si 2022"
                })
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AppFixedFooter_FooterNotFixedWrapper, {
            className: "footer not-fixed-footer",
            id: "footerNotFix",
            sx: {
                filter: Array.isArray(layoutClient) && layoutClient.length > 0 && layoutClient.filter(function(x) {
                    return x.sectionName === AppEnums/* ElementSection.GRAYBACKGROUND */.Pw.GRAYBACKGROUND && x.isDisplay;
                }).length > 0 ? "grayscale(100%)" : "none"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "footerContainer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        container: true,
                        sx: {
                            mx: "auto",
                            maxWidth: {
                                lg: 1140,
                                xl: 1140
                            },
                            alignItems: {
                                lg: "center",
                                xs: "baseline"
                            },
                            filter: Array.isArray(layoutClient) && layoutClient.length > 0 && layoutClient.filter(function(x) {
                                return x.sectionName === AppEnums/* ElementSection.GRAYBACKGROUND */.Pw.GRAYBACKGROUND && x.isDisplay;
                            }).length > 0 ? "grayscale(100%)" : "unset"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hidden/* default */.Z, {
                                lgDown: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        md: 1,
                                        xs: 0,
                                        item: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            sx: {
                                                px: 0
                                            },
                                            children: dataFooter && dataFooter.logoFilePath ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AppMuiImage/* default */.Z, {
                                                src: dataFooter.logoFilePath,
                                                sx: {
                                                    height: 170,
                                                    width: 200
                                                }
                                            }) : null
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        md: 6,
                                        xs: 6,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                            sx: {
                                                px: {
                                                    lg: 2,
                                                    xs: 0
                                                },
                                                color: "white"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "h5",
                                                    children: dataFooter.tieuDe
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "body2",
                                                    children: dataFooter.donVi
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "body2",
                                                    children: dataFooter.giayPhep
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "body2",
                                                    children: dataFooter.banQuyen
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "body2",
                                                    children: dataFooter.luuY
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                        md: 5,
                                        xs: 5,
                                        display: {
                                            lg: "flex",
                                            xs: "block"
                                        },
                                        justifyContent: "flex-end",
                                        pr: {
                                            lg: 7,
                                            xs: 1
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                sx: {
                                                    color: "white"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                        variant: "h5",
                                                        children: [
                                                            "Đường d\xe2y n\xf3ng: ",
                                                            dataFooter.duongDayNong
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                        variant: "body2",
                                                        children: [
                                                            "Trực ban: ",
                                                            dataFooter.trucBan
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                        variant: "body2",
                                                        children: [
                                                            "Fax: ",
                                                            dataFooter.fax
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                        variant: "body2",
                                                        children: [
                                                            "Email: ",
                                                            dataFooter.email
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                        variant: "body2",
                                                        children: [
                                                            "Phi\xean bản: ",
                                                            "91bc1c69"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "https://tinnhiemmang.vn/danh-ba-tin-nhiem/conganthuathienhuegovvn-1698810899",
                                                        title: "Chung nhan Tin Nhiem Mang",
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/assets/images/tinnhiemmang.png",
                                                            width: "130px",
                                                            height: "auto",
                                                            alt: "Chung nhan Tin Nhiem Mang",
                                                            style: {
                                                                paddingTop: 8
                                                            }
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                                                lgUp: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    sx: {
                                                        px: 2
                                                    },
                                                    children: dataFooter && dataFooter.logoFilePath ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "grid-1",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppMuiImage/* default */.Z, {
                                                            src: dataFooter.logoFilePath,
                                                            height: 160,
                                                            width: 160,
                                                            style: {
                                                                margin: "0 auto"
                                                            }
                                                        })
                                                    }) : null
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                                lgUp: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    container: true,
                                    spacing: 3,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            md: 12,
                                            xs: 12,
                                            item: true,
                                            sx: {
                                                textAlign: "center"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            md: 12,
                                            xs: 12,
                                            item: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                sx: {
                                                    display: "flex",
                                                    flexDirection: "column"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        sx: {
                                                            fontSize: 12,
                                                            fontWeight: AppEnums/* Fonts.BOLD */.F3.BOLD
                                                        },
                                                        children: dataFooter.tieuDe
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        sx: {
                                                            fontSize: 10,
                                                            fontWeight: AppEnums/* Fonts.LIGHT */.F3.LIGHT
                                                        },
                                                        color: "grey.300",
                                                        children: dataFooter.donVi
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        sx: {
                                                            fontSize: 10,
                                                            fontWeight: AppEnums/* Fonts.LIGHT */.F3.LIGHT
                                                        },
                                                        color: "grey.300",
                                                        children: dataFooter.giayPhep
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        sx: {
                                                            fontSize: 10,
                                                            fontWeight: AppEnums/* Fonts.LIGHT */.F3.LIGHT
                                                        },
                                                        color: "grey.300",
                                                        children: dataFooter.banQuyen
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        sx: {
                                                            fontSize: 10,
                                                            fontWeight: AppEnums/* Fonts.LIGHT */.F3.LIGHT
                                                        },
                                                        color: "grey.300",
                                                        children: dataFooter.luuY
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                            md: 12,
                                            xs: 12,
                                            item: true,
                                            sx: {
                                                display: "flex",
                                                alignContent: "center",
                                                justifyContent: "center",
                                                alignItems: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                    sx: {
                                                        px: {
                                                            lg: 2,
                                                            xs: 0
                                                        },
                                                        display: "flex",
                                                        flexDirection: "column"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                            sx: {
                                                                fontSize: 12,
                                                                fontWeight: AppEnums/* Fonts.BOLD */.F3.BOLD
                                                            },
                                                            children: [
                                                                "Đường d\xe2y n\xf3ng: ",
                                                                dataFooter.duongDayNong
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                            sx: {
                                                                fontSize: 10,
                                                                fontWeight: AppEnums/* Fonts.LIGHT */.F3.LIGHT
                                                            },
                                                            color: "grey.300",
                                                            children: [
                                                                "Trực ban: ",
                                                                dataFooter.trucBan
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                            sx: {
                                                                fontSize: 10,
                                                                fontWeight: AppEnums/* Fonts.LIGHT */.F3.LIGHT
                                                            },
                                                            color: "grey.300",
                                                            children: [
                                                                "Fax: ",
                                                                dataFooter.fax
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                            sx: {
                                                                fontSize: 10,
                                                                fontWeight: AppEnums/* Fonts.LIGHT */.F3.LIGHT
                                                            },
                                                            color: "grey.300",
                                                            children: [
                                                                "Email: ",
                                                                dataFooter.email
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                            sx: {
                                                                fontSize: 10,
                                                                fontWeight: AppEnums/* Fonts.LIGHT */.F3.LIGHT
                                                            },
                                                            color: "grey.300",
                                                            children: [
                                                                "Phi\xean bản: ",
                                                                "91bc1c69"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "https://tinnhiemmang.vn/danh-ba-tin-nhiem/conganthuathienhuegovvn-1698810899",
                                                            title: "Chung nhan Tin Nhiem Mang",
                                                            target: "_blank",
                                                            rel: "noreferrer",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: "https://tinnhiemmang.vn/handle_cert?id=congan.thuathienhue.gov.vn",
                                                                width: "130px",
                                                                height: "auto",
                                                                alt: "Chung nhan Tin Nhiem Mang",
                                                                style: {
                                                                    paddingTop: 8
                                                                }
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    sx: {
                                                        mx: "auto"
                                                    },
                                                    children: dataFooter && dataFooter.logoFilePath ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AppMuiImage/* default */.Z, {
                                                        src: dataFooter.logoFilePath,
                                                        width: 100,
                                                        height: 100,
                                                        fit: "contain"
                                                    }) : null
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                ]
            })
        })
    });
};
/* harmony default export */ var HorDefault_AppFixedFooter = (AppFixedFooter);


/***/ }),

/***/ 84175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AppLayout_Layouts; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/@common/core/AppContentView/index.js + 18 modules
var AppContentView = __webpack_require__(5267);
// EXTERNAL MODULE: ./src/@common/utility/AppContextProvider/LayoutContextProvider.js
var LayoutContextProvider = __webpack_require__(38638);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(32245);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box_Box = __webpack_require__(12307);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/@common/core/AppLayout/DefaultLayout/AppFixedFooter/FooterWrapper.js







var FooterWrapper = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            position: "fixed",
            left: 0,
            bottom: 0,
            width: "100%",
            zIndex: 1102,
            boxShadow: "none",
            border: "1px solid #e8e5dd",
            // backgroundColor: (theme) => theme.palette.background.paper,
            // backgroundImage: (theme) =>
            //   `linear-gradient(${alpha(theme.palette.common.white, 0.05)}, ${alpha(
            //     theme.palette.common.white,
            //     0.05,
            //   )})`,
            color: function(theme) {
                return theme.palette.text.primary;
            },
            margin: "0",
            "& .footerContainer": {
                alignItems: "center",
                flexDirection: "row",
                display: "flex",
                padding: {
                    xs: "5px 20px",
                    md: "5px 32px",
                    xl: "10px 32px"
                }
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var AppFixedFooter_FooterWrapper = (FooterWrapper);
FooterWrapper.propTypes = {
    children: (prop_types_default()).node,
    sidebarHeaderColor: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/DefaultLayout/AppFixedFooter/index.js





var AppFixedFooter = function() {
    var ref = (0,LayoutContextProvider/* useLayoutContext */.l5)(), footer = ref.footer, footerType = ref.footerType;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: footer && footerType === "fixed" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AppFixedFooter_FooterWrapper, {
            className: "footer fixed-footer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "footerContainer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    children: "Copy right @3si 2022"
                })
            })
        }) : null
    });
};
/* harmony default export */ var DefaultLayout_AppFixedFooter = (AppFixedFooter);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@mui/material/AppBar/AppBar.js + 1 modules
var AppBar = __webpack_require__(37495);
// EXTERNAL MODULE: ./node_modules/@mui/material/Toolbar/Toolbar.js + 1 modules
var Toolbar = __webpack_require__(30644);
// EXTERNAL MODULE: ./src/@common/core/AppLngSwitcher/index.js + 1 modules
var AppLngSwitcher = __webpack_require__(85277);
// EXTERNAL MODULE: ./src/@common/core/AppSearchBar/index.js + 1 modules
var AppSearchBar = __webpack_require__(62160);
// EXTERNAL MODULE: ./node_modules/@mui/material/Hidden/Hidden.js + 4 modules
var Hidden = __webpack_require__(57999);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js
var IconButton_IconButton = __webpack_require__(77063);
// EXTERNAL MODULE: ./src/redux/actions/index.js + 2 modules
var actions = __webpack_require__(84595);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Menu.js
var Menu = __webpack_require__(50960);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/@common/core/AppMessages/index.js + 3 modules
var AppMessages = __webpack_require__(39802);
// EXTERNAL MODULE: ./src/@common/core/AppNotifications/index.js + 2 modules
var AppNotifications = __webpack_require__(19998);
// EXTERNAL MODULE: ./node_modules/@mui/material/Menu/Menu.js + 4 modules
var Menu_Menu = __webpack_require__(56759);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 1 modules
var MenuItem_MenuItem = __webpack_require__(25252);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/MoreVert.js
var MoreVert = __webpack_require__(19685);
// EXTERNAL MODULE: ./src/@common/core/AppTooltip/index.js
var AppTooltip = __webpack_require__(56111);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(94581);
// EXTERNAL MODULE: ./src/@common/core/AppLayout/components/AppLogo/index.js
var AppLogo = __webpack_require__(59500);
;// CONCATENATED MODULE: ./src/@common/core/AppLayout/DefaultLayout/AppHeader/index.js





















var AppHeader = function() {
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), anchorEl = ref[0], setAnchorEl = ref[1];
    var handleClick = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBar/* default */.Z, {
        position: "relative",
        color: "inherit",
        sx: {
            boxShadow: "none",
            borderBottom: function(theme) {
                return "solid 1px ".concat(theme.palette.divider);
            },
            backgroundColor: "background.paper",
            width: {
                xs: "100%"
            }
        },
        className: "app-bar",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Toolbar/* default */.Z, {
            sx: {
                boxSizing: "border-box",
                minHeight: {
                    xs: 56,
                    sm: 70
                },
                paddingLeft: {
                    xs: 5
                },
                paddingRight: {
                    xs: 5,
                    md: 7.5,
                    xl: 12.5
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLogo/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                    lgUp: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                        sx: {
                            color: "text.secondary"
                        },
                        edge: "start",
                        className: "menu-btn",
                        color: "inherit",
                        "aria-label": "open drawer",
                        onClick: function() {
                            return dispatch((0,actions/* toggleNavCollapsed */.xd)());
                        },
                        size: "large",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                            sx: {
                                width: 35,
                                height: 35
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AppSearchBar/* default */.Z, {
                    iconPosition: "right",
                    placeholder: "Search…"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        flexGrow: 1
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLngSwitcher/* default */.Z, {
                    iconOnly: true,
                    tooltipPosition: "bottom"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    sx: {
                        ml: 4
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                            smDown: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                sx: {
                                    position: "relative",
                                    display: "flex",
                                    alignItems: "center",
                                    marginLeft: -2,
                                    marginRight: -2
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        sx: {
                                            px: 1.85
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppNotifications/* default */.Z, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        sx: {
                                            px: 1.85
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppMessages/* default */.Z, {})
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                            smUp: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    position: "relative",
                                    display: "flex",
                                    alignItems: "center",
                                    marginLeft: -2,
                                    marginRight: -2
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                    sx: {
                                        px: 1.85
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppTooltip/* default */.Z, {
                                        title: "More",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                                            sx: {
                                                borderRadius: "50%",
                                                width: 40,
                                                height: 40,
                                                color: function(theme) {
                                                    return theme.palette.text.secondary;
                                                },
                                                backgroundColor: function(theme) {
                                                    return theme.palette.background.default;
                                                },
                                                border: 1,
                                                borderColor: "transparent",
                                                "&:hover, &:focus": {
                                                    color: function(theme) {
                                                        return theme.palette.text.primary;
                                                    },
                                                    backgroundColor: function(theme) {
                                                        return (0,colorManipulator/* alpha */.Fq)(theme.palette.background.default, 0.9);
                                                    },
                                                    borderColor: function(theme) {
                                                        return (0,colorManipulator/* alpha */.Fq)(theme.palette.text.secondary, 0.25);
                                                    }
                                                }
                                            },
                                            onClick: handleClick,
                                            size: "large",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreVert/* default */.Z, {})
                                        })
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu_Menu/* default */.Z, {
                            id: "simple-menu",
                            anchorEl: anchorEl,
                            keepMounted: true,
                            open: Boolean(anchorEl),
                            onClose: handleClose,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppNotifications/* default */.Z, {
                                        isMenu: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppMessages/* default */.Z, {
                                        isMenu: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                    children: "Setting"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var DefaultLayout_AppHeader = (AppHeader);

// EXTERNAL MODULE: ./src/@common/utility/IntlMessages.js + 1 modules
var utility_IntlMessages = __webpack_require__(39625);
// EXTERNAL MODULE: ./src/shared/constants/AppEnums.js
var AppEnums = __webpack_require__(92446);
// EXTERNAL MODULE: ./src/@common/core/AppScrollbar/index.js
var core_AppScrollbar = __webpack_require__(24203);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(81209);
// EXTERNAL MODULE: ./node_modules/@mui/material/ToggleButton/ToggleButton.js + 1 modules
var ToggleButton = __webpack_require__(87295);
;// CONCATENATED MODULE: ./src/@common/core/AppThemeSetting/index.style.js




var index_style_CustomizerItemWrapper = (0,styled/* default */.ZP)(Box_Box/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        "&:not(:last-of-type)": (0,_define_property/* default */.Z)({
            borderBottom: [
                "1px solid ".concat(theme.palette.divider)
            ],
            paddingBottom: 20,
            marginBottom: 20
        }, theme.breakpoints.up("xl"), {
            paddingBottom: 30,
            marginBottom: 30
        })
    };
});
var index_style_StyledToggleButton = (0,styled/* default */.ZP)(ToggleButton/* default */.Z)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        height: 36,
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
        "&:not(:first-of-type)": {
            borderLeft: "1px solid ".concat(theme.palette.primary.main, " !important")
        }
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("xl"), {
        height: 44,
        minWidth: 96
    }), (0,_define_property/* default */.Z)(_obj, "&:hover,&:focus", {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.primary.main
    }), (0,_define_property/* default */.Z)(_obj, "&.active", {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        "&:hover,&:focus": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText
        }
    }), _obj;
});

// EXTERNAL MODULE: ./src/@common/utility/AppContextProvider/defaultConfig.js
var defaultConfig = __webpack_require__(77683);
;// CONCATENATED MODULE: ./src/shared/constants/ColorSets.js

var colorSet = [
    {
        mode: "light",
        primary: {
            main: "#0A8FDC"
        },
        secondary: {
            main: "#F04F47"
        },
        background: defaultConfig/* backgroundLight */.x,
        text: defaultConfig/* textLight */.tY,
        title: "Light"
    },
    {
        mode: "dark",
        primary: {
            main: "#0A8FDC"
        },
        secondary: {
            main: "#F04F47"
        },
        background: defaultConfig/* backgroundDark */.T6,
        text: defaultConfig/* textDark */.Gv,
        title: "Dark"
    },
    {
        mode: "light",
        primary: {
            main: "#2196F2"
        },
        secondary: {
            main: "#FF4981"
        },
        background: defaultConfig/* backgroundLight */.x,
        text: defaultConfig/* textLight */.tY,
        title: "Light-1"
    },
    {
        mode: "light",
        primary: {
            main: "#6E3A4B"
        },
        secondary: {
            main: "#D38C48"
        },
        background: {
            paper: "#FFFFFF",
            default: "#FCF8F5"
        },
        text: defaultConfig/* textLight */.tY,
        title: "Light-2"
    },
    {
        mode: "light",
        primary: {
            main: "#079CE9"
        },
        secondary: {
            main: "#232EC0"
        },
        background: defaultConfig/* backgroundLight */.x,
        text: defaultConfig/* textLight */.tY,
        title: "Light-3"
    },
    {
        mode: "light",
        primary: {
            main: "#1B9E85"
        },
        secondary: {
            main: "#FF916E"
        },
        background: {
            paper: "#FFFFFF",
            default: "#FFFFFF"
        },
        text: defaultConfig/* textLight */.tY,
        title: "Light-4"
    },
    {
        mode: "light",
        primary: {
            main: "#905EAE"
        },
        secondary: {
            main: "#2D755A"
        },
        background: defaultConfig/* backgroundLight */.x,
        text: defaultConfig/* textLight */.tY,
        title: "Light-5"
    },
    {
        mode: "light",
        primary: {
            main: "#266BB0"
        },
        secondary: {
            main: "#587527"
        },
        background: defaultConfig/* backgroundLight */.x,
        text: defaultConfig/* textLight */.tY,
        title: "Light-6"
    },
    {
        mode: "light",
        primary: {
            main: "#F0464D"
        },
        secondary: {
            main: "#00B6EF"
        },
        background: defaultConfig/* backgroundLight */.x,
        text: defaultConfig/* textLight */.tY,
        title: "Light-7"
    },
    {
        mode: "light",
        primary: {
            main: "#639F52"
        },
        secondary: {
            main: "#7C4D30"
        },
        background: defaultConfig/* backgroundLight */.x,
        text: defaultConfig/* textLight */.tY,
        title: "Light-8"
    },
    {
        mode: "light",
        primary: {
            main: "#FFD955"
        },
        secondary: {
            main: "#C4476D"
        },
        background: defaultConfig/* backgroundLight */.x,
        text: defaultConfig/* textLight */.tY,
        title: "Light-9"
    },
    {
        mode: "light",
        primary: {
            main: "#FD933A"
        },
        secondary: {
            main: "#5A63C8"
        },
        background: defaultConfig/* backgroundLight */.x,
        text: defaultConfig/* textLight */.tY,
        title: "Light-10"
    },
    {
        mode: "light",
        primary: {
            main: "#03A9F4"
        },
        secondary: {
            main: "#FFC107"
        },
        background: defaultConfig/* backgroundLight */.x,
        text: defaultConfig/* textLight */.tY,
        title: "Light-11"
    },
    {
        mode: "light",
        primary: {
            main: "#03A9F4"
        },
        secondary: {
            main: "#FF80AB"
        },
        background: defaultConfig/* backgroundLight */.x,
        text: defaultConfig/* textLight */.tY,
        title: "Light-12"
    },
    {
        mode: "light",
        primary: {
            main: "#3F51B5"
        },
        secondary: {
            main: "#2196F3"
        },
        background: defaultConfig/* backgroundLight */.x,
        text: defaultConfig/* textLight */.tY,
        title: "Light-13"
    },
    {
        mode: "light",
        primary: {
            main: "#9C27B0"
        },
        secondary: {
            main: "#FFCA28"
        },
        background: defaultConfig/* backgroundLight */.x,
        text: defaultConfig/* textLight */.tY,
        title: "Light-14"
    },
    {
        mode: "light",
        primary: {
            main: "#673AB7"
        },
        secondary: {
            main: "#2196F3"
        },
        background: defaultConfig/* backgroundLight */.x,
        text: defaultConfig/* textLight */.tY,
        title: "Light-15"
    },
    {
        mode: "dark",
        primary: {
            main: "#0A8FDC"
        },
        secondary: {
            main: "#F04F47"
        },
        background: defaultConfig/* backgroundDark */.T6,
        text: defaultConfig/* textDark */.Gv,
        title: "Dark-1"
    },
    {
        mode: "dark",
        primary: {
            main: "#6E3A4B"
        },
        secondary: {
            main: "#D38C48"
        },
        background: defaultConfig/* backgroundDark */.T6,
        text: defaultConfig/* textDark */.Gv,
        title: "Dark-2"
    },
    {
        mode: "dark",
        primary: {
            main: "#079CE9"
        },
        secondary: {
            main: "#232EC0"
        },
        background: defaultConfig/* backgroundDark */.T6,
        text: defaultConfig/* textDark */.Gv,
        title: "Dark-3"
    },
    {
        mode: "dark",
        primary: {
            main: "#1B9E85"
        },
        secondary: {
            main: "#FF916E"
        },
        background: defaultConfig/* backgroundDark */.T6,
        text: defaultConfig/* textDark */.Gv,
        title: "Dark-4"
    },
    {
        mode: "dark",
        primary: {
            main: "#905EAE"
        },
        secondary: {
            main: "#2D755A"
        },
        background: defaultConfig/* backgroundDark */.T6,
        text: defaultConfig/* textDark */.Gv,
        title: "Dark-5"
    },
    {
        mode: "dark",
        primary: {
            main: "#266BB0"
        },
        secondary: {
            main: "#587527"
        },
        background: defaultConfig/* backgroundDark */.T6,
        text: defaultConfig/* textDark */.Gv,
        title: "Dark-6"
    },
    {
        mode: "dark",
        primary: {
            main: "#F0464D"
        },
        secondary: {
            main: "#00B6EF"
        },
        background: defaultConfig/* backgroundDark */.T6,
        text: defaultConfig/* textDark */.Gv,
        title: "Dark-7"
    },
    {
        mode: "dark",
        primary: {
            main: "#639F52"
        },
        secondary: {
            main: "#7C4D30"
        },
        background: defaultConfig/* backgroundDark */.T6,
        text: defaultConfig/* textDark */.Gv,
        title: "Dark-8"
    },
    {
        mode: "dark",
        primary: {
            main: "#FFD955"
        },
        secondary: {
            main: "#C4476D"
        },
        background: defaultConfig/* backgroundDark */.T6,
        text: defaultConfig/* textDark */.Gv,
        title: "Dark-9"
    },
    {
        mode: "dark",
        primary: {
            main: "#FD933A"
        },
        secondary: {
            main: "#5A63C8"
        },
        background: defaultConfig/* backgroundDark */.T6,
        text: defaultConfig/* textDark */.Gv,
        title: "Dark-10"
    },
    {
        mode: "dark",
        primary: {
            main: "#03A9F4"
        },
        secondary: {
            main: "#FFC107"
        },
        background: defaultConfig/* backgroundDark */.T6,
        text: defaultConfig/* textDark */.Gv,
        title: "Dark-11"
    },
    {
        mode: "dark",
        primary: {
            main: "#03A9F4"
        },
        secondary: {
            main: "#FF80AB"
        },
        background: defaultConfig/* backgroundDark */.T6,
        text: defaultConfig/* textDark */.Gv,
        title: "Dark-12"
    },
    {
        mode: "dark",
        primary: {
            main: "#3F51B5"
        },
        secondary: {
            main: "#2196F3"
        },
        background: defaultConfig/* backgroundDark */.T6,
        text: defaultConfig/* textDark */.Gv,
        title: "Dark-13"
    },
    {
        mode: "dark",
        primary: {
            main: "#9C27B0"
        },
        secondary: {
            main: "#FFCA28"
        },
        background: defaultConfig/* backgroundDark */.T6,
        text: defaultConfig/* textDark */.Gv,
        title: "Dark-14"
    },
    {
        mode: "dark",
        primary: {
            main: "#673AB7"
        },
        secondary: {
            main: "#2196F3"
        },
        background: defaultConfig/* backgroundDark */.T6,
        text: defaultConfig/* textDark */.Gv,
        title: "Dark-15"
    }, 
];
/* harmony default export */ var ColorSets = ((/* unused pure expression or super */ null && (colorSet)));

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Check.js
var Check = __webpack_require__(65430);
// EXTERNAL MODULE: ./src/@common/utility/AppContextProvider/ThemeContextProvider.js
var ThemeContextProvider = __webpack_require__(87345);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/AddOutlined.js
var AddOutlined = __webpack_require__(80443);
;// CONCATENATED MODULE: ./src/@common/core/AppThemeSetting/CustomColorCell.js








var CustomColorCell_CustomColorCell = function(param) {
    var themeColorSet = param.themeColorSet, updateThemeColors = param.updateThemeColors;
    var theme = (0,ThemeContextProvider/* useThemeContext */.TC)().theme;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        onClick: function() {
            updateThemeColors(themeColorSet);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    width: "100%",
                    borderRadius: 1,
                    position: "relative",
                    overflow: "hidden",
                    cursor: "pointer"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        sx: {
                            px: 2.5,
                            py: 2,
                            position: "relative",
                            display: "flex",
                            alignItems: "center",
                            backgroundColor: themeColorSet.primary.main,
                            color: function(theme) {
                                return theme.palette.common.white;
                            }
                        },
                        children: [
                            "Primary",
                            theme.palette.primary.main === themeColorSet.primary.main && theme.palette.secondary.main === themeColorSet.secondary.main && theme.palette.mode === themeColorSet.mode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    ml: "auto",
                                    width: 20,
                                    height: 20,
                                    borderRadius: "50%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    overflow: "hidden",
                                    backgroundColor: "#fff",
                                    color: theme.palette.primary.main
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {
                                    sx: {
                                        fontSize: 16
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utility_IntlMessages/* default */.Z, {
                                        id: "customizer.checked"
                                    })
                                })
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        sx: {
                            p: 2.5,
                            backgroundColor: themeColorSet.background.default,
                            color: themeColorSet.text.primary
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                sx: {
                                    height: 80,
                                    py: 1.5,
                                    px: 2.5,
                                    mb: 2.5,
                                    boxShadow: "rgba(0, 0, 0, 0.2) 0px 2px 1px -1px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px",
                                    borderRadius: 1,
                                    backgroundColor: themeColorSet.background.paper,
                                    color: themeColorSet.text.primary,
                                    display: "flex",
                                    flexDirection: "column"
                                },
                                children: [
                                    "Paper",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        sx: {
                                            width: 30,
                                            height: 30,
                                            borderRadius: "50%",
                                            p: 1,
                                            backgroundColor: themeColorSet.secondary.main,
                                            color: function(theme) {
                                                return theme.palette.common.white;
                                            },
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            mt: "auto",
                                            ml: "auto",
                                            "& svg": {
                                                fontSize: 20
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddOutlined/* default */.Z, {})
                                    })
                                ]
                            }),
                            "Background"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    pt: 2,
                    px: 3,
                    pb: 3
                },
                children: themeColorSet.title
            })
        ]
    });
};
/* harmony default export */ var AppThemeSetting_CustomColorCell = ((/* unused pure expression or super */ null && (CustomColorCell_CustomColorCell)));
CustomColorCell_CustomColorCell.propTypes = {
    themeColorSet: (prop_types_default()).object,
    updateThemeColors: (prop_types_default()).func
};

// EXTERNAL MODULE: ./src/@common/core/AppGrid/index.js + 2 modules
var core_AppGrid = __webpack_require__(24178);
;// CONCATENATED MODULE: ./src/@common/core/AppThemeSetting/ThemeColors/index.js










var ThemeColors_ThemeColors = function() {
    var theme = useThemeContext().theme;
    var updateTheme = useThemeActionsContext().updateTheme;
    var updateThemeColors = function(colorSet) {
        theme.palette.primary.main = colorSet.primary.main;
        theme.palette.secondary.main = colorSet.secondary.main;
        theme.palette.background = colorSet.background;
        theme.palette.mode = colorSet.mode;
        theme.palette.text = colorSet.text;
        updateTheme(_object_spread({}, theme));
    };
    return /*#__PURE__*/ _jsxs(CustomizerItemWrapper, {
        children: [
            /*#__PURE__*/ _jsx(Box, {
                component: "h4",
                sx: {
                    mb: 2
                },
                children: /*#__PURE__*/ _jsx(IntlMessages, {
                    id: "customizer.themeColors"
                })
            }),
            /*#__PURE__*/ _jsx(Box, {
                mt: 4,
                children: /*#__PURE__*/ _jsx(AppGrid, {
                    data: themeColorSets,
                    itemPadding: 5,
                    responsive: {
                        xs: 1,
                        sm: 2
                    },
                    renderRow: function(colorSet, index) {
                        return /*#__PURE__*/ _jsx(CustomColorCell, {
                            updateThemeColors: updateThemeColors,
                            themeColorSet: colorSet
                        }, index);
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var AppThemeSetting_ThemeColors = ((/* unused pure expression or super */ null && (ThemeColors_ThemeColors)));

;// CONCATENATED MODULE: ./src/@common/core/AppThemeSetting/ThemeFooter/index.js











var ThemeFooter_ThemeFooter = function() {
    var footer = useLayoutContext().footer;
    var setFooter = useLayoutActionsContext().setFooter;
    var footerType = useLayoutContext().footerType;
    var setFooterType = useLayoutActionsContext().setFooterType;
    return /*#__PURE__*/ _jsxs(CustomizerItemWrapper, {
        children: [
            /*#__PURE__*/ _jsxs(Box, {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    mb: 4
                },
                children: [
                    /*#__PURE__*/ _jsx(Box, {
                        component: "h4",
                        children: "Footer"
                    }),
                    /*#__PURE__*/ _jsx(Box, {
                        component: "span",
                        ml: "auto",
                        children: /*#__PURE__*/ _jsx(Switch, {
                            checked: footer,
                            onChange: function() {
                                return setFooter(!footer);
                            },
                            value: "checkedA",
                            inputProps: {
                                "aria-label": "secondary checkbox"
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(FormControl, {
                variant: "outlined",
                sx: {
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ _jsx(InputLabel, {
                        id: "select-footer",
                        children: "Footer Type"
                    }),
                    /*#__PURE__*/ _jsxs(Select, {
                        sx: {
                            "& .MuiOutlinedInput-input": {
                                padding: "12px 32px 12px 14px"
                            }
                        },
                        labelId: "select-footer",
                        label: "Footer Type",
                        value: footerType,
                        onChange: function(e) {
                            return setFooterType(e.target.value);
                        },
                        children: [
                            /*#__PURE__*/ _jsx(MenuItem, {
                                value: FooterType.FIXED,
                                children: "Fixed"
                            }),
                            /*#__PURE__*/ _jsx(MenuItem, {
                                value: FooterType.FLUID,
                                children: "Fluid"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var AppThemeSetting_ThemeFooter = ((/* unused pure expression or super */ null && (ThemeFooter_ThemeFooter)));

// EXTERNAL MODULE: ./src/@common/utility/AppContextProvider/SidebarContextProvider.js
var SidebarContextProvider = __webpack_require__(88748);
;// CONCATENATED MODULE: ./src/@common/core/AppThemeSetting/ThemeModes/index.js











var ThemeModes_ThemeModes = function() {
    var updateThemeMode = useThemeActionsContext().updateThemeMode;
    var updateSidebarColorSet = useSidebarActionsContext().updateSidebarColorSet;
    var ref = useThemeContext(), themeMode = ref.themeMode, theme = ref.theme;
    var onModeChange = function(event, themeMode) {
        if (themeMode) {
            updateThemeMode(themeMode);
            if (themeMode === ThemeMode.LIGHT) {
                updateSidebarColorSet({
                    sidebarBgColor: LightSidebar.sidebarBgColor,
                    sidebarTextColor: LightSidebar.sidebarTextColor,
                    sidebarMenuSelectedBgColor: LightSidebar.sidebarMenuSelectedBgColor,
                    sidebarMenuSelectedTextColor: LightSidebar.sidebarMenuSelectedTextColor,
                    sidebarHeaderColor: LightSidebar.sidebarHeaderColor
                });
            } else {
                updateSidebarColorSet({
                    sidebarBgColor: DarkSidebar.sidebarBgColor,
                    sidebarTextColor: DarkSidebar.sidebarTextColor,
                    sidebarMenuSelectedBgColor: DarkSidebar.sidebarMenuSelectedBgColor,
                    sidebarMenuSelectedTextColor: DarkSidebar.sidebarMenuSelectedTextColor,
                    sidebarHeaderColor: DarkSidebar.sidebarHeaderColor
                });
            }
        }
    };
    return /*#__PURE__*/ _jsxs(CustomizerItemWrapper, {
        children: [
            /*#__PURE__*/ _jsx(Box, {
                component: "h4",
                sx: {
                    mb: 2
                },
                children: /*#__PURE__*/ _jsx(IntlMessages, {
                    id: "customizer.themeMode"
                })
            }),
            /*#__PURE__*/ _jsxs(ToggleButtonGroup, {
                value: themeMode,
                exclusive: true,
                onChange: onModeChange,
                "aria-label": "text alignment",
                children: [
                    /*#__PURE__*/ _jsx(StyledToggleButton, {
                        value: ThemeMode.LIGHT,
                        className: clsx({
                            active: themeMode === ThemeMode.LIGHT
                        }),
                        "aria-label": "left aligned",
                        children: /*#__PURE__*/ _jsx(IntlMessages, {
                            id: "customizer.light"
                        })
                    }),
                    /*#__PURE__*/ _jsx(StyledToggleButton, {
                        value: ThemeMode.DARK,
                        className: clsx({
                            active: themeMode === ThemeMode.DARK || theme.palette.type === ThemeMode.DARK
                        }),
                        "aria-label": "centered",
                        children: /*#__PURE__*/ _jsx(IntlMessages, {
                            id: "customizer.dark"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var AppThemeSetting_ThemeModes = ((/* unused pure expression or super */ null && (ThemeModes_ThemeModes)));

;// CONCATENATED MODULE: ./src/@common/core/AppThemeSetting/ThemeDirection/index.js









var ThemeDirection_ThemeDirection = function() {
    var theme = useThemeContext().theme;
    var updateTheme = useThemeActionsContext().updateTheme;
    var onChangeRtlSetting = function(event) {
        theme.direction = event.target.checked ? LayoutDirection.RTL : LayoutDirection.LTR, updateTheme(_object_spread({}, theme));
    };
    return /*#__PURE__*/ _jsx(CustomizerItemWrapper, {
        children: /*#__PURE__*/ _jsxs(Box, {
            display: "flex",
            alignItems: "center",
            children: [
                /*#__PURE__*/ _jsx(Box, {
                    component: "h4",
                    children: /*#__PURE__*/ _jsx(IntlMessages, {
                        id: "customizer.rtlSupport"
                    })
                }),
                /*#__PURE__*/ _jsx(Box, {
                    component: "span",
                    ml: "auto",
                    children: /*#__PURE__*/ _jsx(Switch, {
                        checked: theme.direction === LayoutDirection.RTL,
                        onChange: onChangeRtlSetting,
                        value: "checkedA",
                        inputProps: {
                            "aria-label": "secondary checkbox"
                        }
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var AppThemeSetting_ThemeDirection = ((/* unused pure expression or super */ null && (ThemeDirection_ThemeDirection)));

;// CONCATENATED MODULE: ./src/@common/services/db/navigationStyle.js

var navigationStyle_navStyles = [
    {
        id: 1,
        alias: AppEnums/* NavStyle.DEFAULT */.Dt.DEFAULT,
        image: "/assets/images/navigationStyle/default.svg"
    },
    {
        id: 2,
        alias: AppEnums/* NavStyle.BIT_BUCKET */.Dt.BIT_BUCKET,
        image: "/assets/images/navigationStyle/bit_bucket.svg"
    },
    {
        id: 3,
        alias: AppEnums/* NavStyle.STANDARD */.Dt.STANDARD,
        image: "/assets/images/navigationStyle/standard.svg"
    },
    {
        id: 4,
        alias: AppEnums/* NavStyle.DRAWER */.Dt.DRAWER,
        image: "/assets/images/navigationStyle/drawer.svg"
    },
    {
        id: 5,
        alias: AppEnums/* NavStyle.MINI */.Dt.MINI,
        image: "/assets/images/navigationStyle/mini.svg"
    },
    {
        id: 6,
        alias: AppEnums/* NavStyle.MINI_SIDEBAR_TOGGLE */.Dt.MINI_SIDEBAR_TOGGLE,
        image: "/assets/images/navigationStyle/mini-sidebar-toggle.svg"
    },
    {
        id: 7,
        alias: AppEnums/* NavStyle.HEADER_USER */.Dt.HEADER_USER,
        image: "/assets/images/navigationStyle/user-header.svg"
    },
    {
        id: 8,
        alias: AppEnums/* NavStyle.HEADER_USER_MINI */.Dt.HEADER_USER_MINI,
        image: "/assets/images/navigationStyle/user-mini-header.svg"
    },
    {
        id: 9,
        alias: AppEnums/* NavStyle.H_DEFAULT */.Dt.H_DEFAULT,
        image: "/assets/images/navigationStyle/hor-header-fixed.svg"
    },
    {
        id: 10,
        alias: AppEnums/* NavStyle.HOR_HEADER_FIXED */.Dt.HOR_HEADER_FIXED,
        image: "/assets/images/navigationStyle/h-default.svg"
    },
    {
        id: 11,
        alias: AppEnums/* NavStyle.HOR_DARK_LAYOUT */.Dt.HOR_DARK_LAYOUT,
        image: "/assets/images/navigationStyle/hor-dark-layout.svg"
    }, 
];
var navigationStyle_sidebarBgImages = [
    {
        id: 1,
        image: "/assets/images/sidebar/thumb/1.png"
    },
    {
        id: 2,
        image: "/assets/images/sidebar/thumb/2.png"
    },
    {
        id: 3,
        image: "/assets/images/sidebar/thumb/3.png"
    },
    {
        id: 4,
        image: "/assets/images/sidebar/thumb/4.png"
    },
    {
        id: 5,
        image: "/assets/images/sidebar/thumb/5.png"
    },
    {
        id: 6,
        image: "/assets/images/sidebar/thumb/6.png"
    }, 
];
var navigationStyle_menuStyles = [
    {
        id: 1,
        alias: AppEnums/* MenuStyle.DEFAULT */.gA.DEFAULT,
        image: "/assets/images/sidebar/menu/1.svg"
    },
    {
        id: 2,
        alias: AppEnums/* MenuStyle.STANDARD */.gA.STANDARD,
        image: "/assets/images/sidebar/menu/2.svg"
    },
    {
        id: 3,
        alias: AppEnums/* MenuStyle.ROUNDED */.gA.ROUNDED,
        image: "/assets/images/sidebar/menu/3.svg"
    },
    {
        id: 4,
        alias: AppEnums/* MenuStyle.ROUNDED_REVERSE */.gA.ROUNDED_REVERSE,
        image: "/assets/images/sidebar/menu/4.svg"
    },
    {
        id: 5,
        alias: AppEnums/* MenuStyle.CURVED_MENU */.gA.CURVED_MENU,
        image: "/assets/images/sidebar/menu/5.svg"
    }, 
];
var sidebarBgColors = [
    {
        id: 0,
        color: "#313541"
    },
    {
        id: 1,
        color: "#7C4D30"
    },
    {
        id: 2,
        color: "#905EAE"
    },
    {
        id: 3,
        color: "#639F52"
    },
    {
        id: 4,
        color: "#5A63C8"
    },
    {
        id: 5,
        color: "#9C27B0"
    },
    {
        id: 6,
        color: "#673AB7"
    }, 
];
var navigationStyle_sidebarColors = [
    {
        id: 0,
        sidebarBgColor: "#f6f8f9",
        sidebarTextColor: "rgba(0, 0, 0, 0.60)",
        sidebarHeaderColor: "#f6f8f9",
        sidebarMenuSelectedBgColor: "#00905F",
        sidebarMenuSelectedTextColor: "rgba(255, 255, 255, 0.87)",
        mode: AppEnums/* ThemeMode.LIGHT */.hY.LIGHT
    },
    {
        id: 1,
        sidebarBgColor: "#313541",
        sidebarHeaderColor: "#313541",
        sidebarTextColor: "#fff",
        sidebarMenuSelectedBgColor: "#F4F7FE",
        sidebarMenuSelectedTextColor: "rgba(0, 0, 0, 0.87)",
        mode: AppEnums/* ThemeMode.DARK */.hY.DARK
    },
    {
        id: 2,
        sidebarBgColor: "#313541",
        sidebarTextColor: "#fff",
        sidebarHeaderColor: "#639F52",
        sidebarMenuSelectedBgColor: "#639F52",
        sidebarMenuSelectedTextColor: "#fff",
        mode: AppEnums/* ThemeMode.DARK */.hY.DARK
    },
    {
        id: 3,
        sidebarBgColor: "#fff",
        sidebarTextColor: "rgba(0, 0, 0, 0.87)",
        sidebarHeaderColor: "#fff",
        sidebarMenuSelectedBgColor: "#F4F7FE",
        sidebarMenuSelectedTextColor: "rgba(0, 0, 0, 0.87)",
        mode: AppEnums/* ThemeMode.LIGHT */.hY.LIGHT
    },
    {
        id: 4,
        sidebarBgColor: "#fff",
        sidebarTextColor: "rgba(0, 0, 0, 0.87)",
        sidebarHeaderColor: "#fff",
        sidebarMenuSelectedBgColor: "#313541",
        sidebarMenuSelectedTextColor: "#fff",
        mode: AppEnums/* ThemeMode.LIGHT */.hY.LIGHT
    },
    {
        id: 5,
        sidebarBgColor: "#fff",
        sidebarTextColor: "rgba(0, 0, 0, 0.87)",
        sidebarHeaderColor: "#fff",
        sidebarMenuSelectedBgColor: "#079CE9",
        sidebarMenuSelectedTextColor: "#fff",
        mode: AppEnums/* ThemeMode.LIGHT */.hY.LIGHT
    },
    {
        id: 6,
        sidebarBgColor: "#313541",
        sidebarHeaderColor: "#313541",
        sidebarTextColor: "#fff",
        sidebarMenuSelectedBgColor: "#FD933A",
        sidebarMenuSelectedTextColor: "rgba(0, 0, 0, 0.87)",
        mode: AppEnums/* ThemeMode.DARK */.hY.DARK
    },
    {
        id: 7,
        sidebarBgColor: "#079CE9",
        sidebarHeaderColor: "#313541",
        sidebarTextColor: "#fff",
        sidebarMenuSelectedBgColor: "#313541",
        sidebarMenuSelectedTextColor: "#fff",
        mode: AppEnums/* ThemeMode.DARK */.hY.DARK
    },
    {
        id: 8,
        sidebarBgColor: "#1B9E85",
        sidebarHeaderColor: "#313541",
        sidebarTextColor: "#fff",
        sidebarMenuSelectedBgColor: "#F4F7FE",
        sidebarMenuSelectedTextColor: "rgba(0, 0, 0, 0.87)",
        mode: AppEnums/* ThemeMode.DARK */.hY.DARK
    },
    {
        id: 9,
        sidebarBgColor: "#FD933A",
        sidebarHeaderColor: "#313541",
        sidebarTextColor: "#fff",
        sidebarMenuSelectedBgColor: "#F4F7FE",
        sidebarMenuSelectedTextColor: "rgba(0, 0, 0, 0.87)",
        mode: AppEnums/* ThemeMode.DARK */.hY.DARK
    },
    {
        id: 10,
        sidebarBgColor: "#F0464D",
        sidebarHeaderColor: "#313541",
        sidebarTextColor: "#fff",
        sidebarMenuSelectedBgColor: "#F4F7FE",
        sidebarMenuSelectedTextColor: "rgba(0, 0, 0, 0.87)",
        mode: AppEnums/* ThemeMode.DARK */.hY.DARK
    },
    {
        id: 11,
        sidebarBgColor: "#313541",
        sidebarTextColor: "#fff",
        sidebarHeaderColor: "#313541",
        sidebarMenuSelectedBgColor: "#639F52",
        sidebarMenuSelectedTextColor: "#fff",
        mode: AppEnums/* ThemeMode.DARK */.hY.DARK
    },
    {
        id: 12,
        sidebarBgColor: "#7C4D30",
        sidebarTextColor: "#fff",
        sidebarHeaderColor: "#313541",
        sidebarMenuSelectedBgColor: "#F4F7FE",
        sidebarMenuSelectedTextColor: "rgba(0, 0, 0, 0.87)",
        mode: AppEnums/* ThemeMode.DARK */.hY.DARK
    },
    {
        id: 14,
        sidebarBgColor: "#639F52",
        sidebarTextColor: "#fff",
        sidebarHeaderColor: "#313541",
        sidebarMenuSelectedBgColor: "#F4F7FE",
        sidebarMenuSelectedTextColor: "rgba(0, 0, 0, 0.87)",
        mode: AppEnums/* ThemeMode.DARK */.hY.DARK
    },
    {
        id: 15,
        sidebarBgColor: "#5A63C8",
        sidebarTextColor: "#fff",
        sidebarHeaderColor: "#313541",
        sidebarMenuSelectedBgColor: "#F4F7FE",
        sidebarMenuSelectedTextColor: "rgba(0, 0, 0, 0.87)",
        mode: AppEnums/* ThemeMode.DARK */.hY.DARK
    },
    {
        id: 16,
        sidebarBgColor: "#9C27B0",
        sidebarTextColor: "#fff",
        sidebarHeaderColor: "#313541",
        sidebarMenuSelectedBgColor: "#F4F7FE",
        sidebarMenuSelectedTextColor: "rgba(0, 0, 0, 0.87)",
        mode: AppEnums/* ThemeMode.DARK */.hY.DARK
    },
    {
        id: 17,
        sidebarBgColor: "#673AB7",
        sidebarTextColor: "#fff",
        sidebarHeaderColor: "#313541",
        sidebarMenuSelectedBgColor: "#F4F7FE",
        sidebarMenuSelectedTextColor: "rgba(0, 0, 0, 0.87)",
        mode: AppEnums/* ThemeMode.DARK */.hY.DARK
    },
    {
        id: 18,
        sidebarBgColor: "#079CE9",
        sidebarHeaderColor: "#313541",
        sidebarTextColor: "#fff",
        sidebarMenuSelectedBgColor: "#F4F7FE",
        sidebarMenuSelectedTextColor: "rgba(0, 0, 0, 0.87)",
        mode: AppEnums/* ThemeMode.DARK */.hY.DARK
    },
    {
        id: 19,
        sidebarBgColor: "#1B9E85",
        sidebarHeaderColor: "#313541",
        sidebarTextColor: "#fff",
        sidebarMenuSelectedBgColor: "#313541",
        sidebarMenuSelectedTextColor: "#fff",
        mode: AppEnums/* ThemeMode.DARK */.hY.DARK
    },
    {
        id: 20,
        sidebarBgColor: "#FD933A",
        sidebarHeaderColor: "#313541",
        sidebarTextColor: "#fff",
        sidebarMenuSelectedBgColor: "#313541",
        sidebarMenuSelectedTextColor: "#fff",
        mode: AppEnums/* ThemeMode.DARK */.hY.DARK
    },
    {
        id: 21,
        sidebarBgColor: "#F0464D",
        sidebarHeaderColor: "#313541",
        sidebarTextColor: "#fff",
        sidebarMenuSelectedBgColor: "#313541",
        sidebarMenuSelectedTextColor: "#fff",
        mode: AppEnums/* ThemeMode.DARK */.hY.DARK
    }, 
];
var sidebarHeaderBgColors = [
    {
        id: 0,
        color: "#313541"
    },
    {
        id: 1,
        color: "#7C4D30"
    },
    {
        id: 2,
        color: "#905EAE"
    },
    {
        id: 3,
        color: "#639F52"
    },
    {
        id: 4,
        color: "#5A63C8"
    },
    {
        id: 5,
        color: "#9C27B0"
    },
    {
        id: 6,
        color: "#673AB7"
    }, 
];
var sidebarSelectedMenuBgColors = [
    {
        id: 0,
        color: "#F4F7FE"
    },
    {
        id: 1,
        color: "#7C4D30"
    },
    {
        id: 2,
        color: "#905EAE"
    },
    {
        id: 3,
        color: "#639F52"
    },
    {
        id: 4,
        color: "#5A63C8"
    },
    {
        id: 5,
        color: "#9C27B0"
    },
    {
        id: 6,
        color: "#673AB7"
    }, 
];
var sidebarMenuSelectedTextColors = [
    {
        id: 0,
        color: "rgba(0, 0, 0, 0.87)"
    },
    {
        id: 1,
        color: "#FFFFFF"
    }, 
];
var navigationStyle_layoutTypes = [
    {
        id: 1,
        alias: AppEnums/* LayoutType.FULL_WIDTH */.ms.FULL_WIDTH,
        image: "/assets/images/layouts/full-width.svg"
    },
    {
        id: 2,
        alias: AppEnums/* LayoutType.BOXED */.ms.BOXED,
        image: "/assets/images/layouts/boxed.svg"
    },
    {
        id: 3,
        alias: AppEnums/* LayoutType.FRAMED */.ms.FRAMED,
        image: "/assets/images/layouts/framed.svg"
    }, 
];

;// CONCATENATED MODULE: ./src/@common/core/AppSelectedIcon/index.js








var AppSelectedIcon_AppSelectedIcon = function(param) {
    var backgroundColor = param.backgroundColor, _isCenter = param.isCenter, isCenter = _isCenter === void 0 ? true : _isCenter, color = param.color;
    var centerStyle = isCenter ? {
        position: "absolute",
        left: "50%",
        top: "50%",
        zIndex: 1,
        transform: "translate(-50%, -50%)"
    } : {
        position: "absolute",
        right: 10,
        top: 10,
        zIndex: 1
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        sx: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            width: 20,
            height: 20,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
            backgroundColor: backgroundColor || "primary.main",
            color: color || "primary.contrastText"
        }, centerStyle), {
            "& svg": {
                fontSize: 16
            }
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utility_IntlMessages/* default */.Z, {
                id: "customizer.checked"
            })
        })
    });
};
/* harmony default export */ var core_AppSelectedIcon = (AppSelectedIcon_AppSelectedIcon);
AppSelectedIcon_AppSelectedIcon.propTypes = {
    backgroundColor: (prop_types_default()).string,
    color: (prop_types_default()).string,
    isCenter: (prop_types_default()).bool
};

;// CONCATENATED MODULE: ./src/@common/core/AppThemeSetting/SidebarSettings/NavMenuStyle/index.js







var NavMenuStyle_NavMenuStyle = function() {
    var menuStyle = useSidebarContext().menuStyle;
    var updateMenuStyle = useSidebarActionsContext().updateMenuStyle;
    var onMenuStyleChange = function(menuStyle) {
        updateMenuStyle(menuStyle);
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Box, {
                component: "h4",
                sx: {
                    mb: 3
                },
                children: /*#__PURE__*/ _jsx(IntlMessages, {
                    id: "customizer.sidebarMenuStyle"
                })
            }),
            /*#__PURE__*/ _jsx(Box, {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                    marginLeft: "-10px",
                    marginRight: "-10px"
                },
                children: menuStyles.map(function(menu) {
                    return /*#__PURE__*/ _jsx(Box, {
                        sx: {
                            paddingLeft: 2.5,
                            paddingRight: 2.5,
                            marginBottom: 5
                        },
                        children: /*#__PURE__*/ _jsxs(Box, {
                            sx: {
                                position: "relative",
                                cursor: "pointer"
                            },
                            onClick: function() {
                                return onMenuStyleChange(menu.alias);
                            },
                            children: [
                                /*#__PURE__*/ _jsx("img", {
                                    src: menu.image,
                                    alt: "nav"
                                }),
                                menuStyle === menu.alias ? /*#__PURE__*/ _jsx(AppSelectedIcon, {}) : null
                            ]
                        })
                    }, menu.id);
                })
            })
        ]
    });
};
/* harmony default export */ var SidebarSettings_NavMenuStyle = ((/* unused pure expression or super */ null && (NavMenuStyle_NavMenuStyle)));

;// CONCATENATED MODULE: ./src/@common/core/AppThemeSetting/SidebarSettings/MenuColorCell.js










var MenuColorCell_MenuColorCell = function(param) {
    var sidebarColors = param.sidebarColors;
    var ref = (0,SidebarContextProvider/* useSidebarContext */.Sz)(), sidebarBgColor = ref.sidebarBgColor, sidebarTextColor = ref.sidebarTextColor, sidebarMenuSelectedBgColor = ref.sidebarMenuSelectedBgColor, sidebarMenuSelectedTextColor = ref.sidebarMenuSelectedTextColor, menuStyle = ref.menuStyle;
    var updateSidebarColorSet = (0,SidebarContextProvider/* useSidebarActionsContext */.Lf)().updateSidebarColorSet;
    var navStyle = (0,LayoutContextProvider/* useLayoutContext */.l5)().navStyle;
    var theme = (0,ThemeContextProvider/* useThemeContext */.TC)().theme;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        sx: {
            border: function(theme) {
                return sidebarColors.mode === AppEnums/* ThemeMode.LIGHT */.hY.LIGHT ? "solid 2px ".concat(theme.palette.text.disabled) : "solid 2px ".concat(sidebarColors.sidebarBgColor);
            },
            borderRadius: 2,
            cursor: "pointer",
            overflow: "hidden",
            position: "relative"
        },
        onClick: function() {
            return updateSidebarColorSet(sidebarColors);
        },
        children: [
            navStyle === AppEnums/* NavStyle.DEFAULT */.Dt.DEFAULT ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    width: "100%",
                    height: 60,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: sidebarColors.sidebarHeaderColor,
                    borderBottom: "solid 1px ".concat(sidebarColors.sidebarTextColor)
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            width: 30,
                            height: 30,
                            border: "solid 1px ".concat(sidebarColors.sidebarTextColor),
                            borderRadius: "50%"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            width: 50,
                            height: 4,
                            marginTop: 2,
                            backgroundColor: sidebarColors.sidebarTextColor
                        }
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    maxWidth: 200,
                    backgroundColor: sidebarColors.sidebarBgColor
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            width: "100%",
                            minHeight: 40,
                            padding: 2.5,
                            py: 2.5,
                            px: 4.5,
                            color: sidebarColors.sidebarTextColor,
                            fontSize: {
                                xs: 12,
                                md: 14
                            },
                            whiteSpace: "nowrap"
                        },
                        children: "Menu-1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            width: "100%",
                            minHeight: 40,
                            py: 2.5,
                            px: 4.5,
                            color: sidebarColors.sidebarTextColor,
                            fontSize: {
                                xs: 12,
                                md: 14
                            },
                            whiteSpace: "nowrap"
                        },
                        children: "Menu-2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        className: (0,clsx_m["default"])({
                            "rounded-menu": menuStyle === AppEnums/* MenuStyle.ROUNDED */.gA.ROUNDED,
                            "rounded-menu-reverse": menuStyle === AppEnums/* MenuStyle.ROUNDED_REVERSE */.gA.ROUNDED_REVERSE,
                            "standard-menu": menuStyle === AppEnums/* MenuStyle.STANDARD */.gA.STANDARD
                        }),
                        sx: {
                            width: "calc(100% - 16px)",
                            minHeight: 40,
                            py: 2.5,
                            px: 2.5,
                            mx: 2,
                            borderRadius: 1,
                            backgroundColor: sidebarColors.sidebarMenuSelectedBgColor,
                            color: sidebarColors.sidebarMenuSelectedTextColor,
                            position: "relative",
                            transition: "all 0.4s ease",
                            fontSize: {
                                xs: 12,
                                md: 14
                            },
                            whiteSpace: "nowrap",
                            "&.rounded-menu": {
                                mr: 2,
                                ml: 0,
                                width: "calc(100% - 8px)",
                                pl: 4.5,
                                pr: 2.5,
                                borderRadius: "0 30px 30px 0"
                            },
                            "&.rounded-menu-reverse": {
                                ml: 2,
                                mr: 0,
                                width: "calc(100% - 8px)",
                                pl: 2.5,
                                pr: 2.5,
                                borderRadius: "30px 0 0 30px",
                                "&.active:after": {
                                    display: "none"
                                }
                            },
                            "&.standard-menu": {
                                mx: 0,
                                width: "100%",
                                pl: 4.5,
                                pr: 2.5,
                                borderRadius: 0,
                                "&:after": {
                                    content: '""',
                                    position: "absolute",
                                    right: 0,
                                    top: 0,
                                    height: "100%",
                                    width: 4,
                                    backgroundColor: function(theme) {
                                        return theme.palette.primary.main;
                                    }
                                }
                            }
                        },
                        children: "Selected Menu"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            width: "100%",
                            minHeight: 40,
                            py: 2.5,
                            px: 4.5,
                            color: sidebarColors.sidebarTextColor
                        },
                        children: "Menu-4"
                    })
                ]
            }),
            sidebarColors.sidebarBgColor === sidebarBgColor && sidebarColors.sidebarTextColor === sidebarTextColor && sidebarColors.sidebarMenuSelectedBgColor === sidebarMenuSelectedBgColor && sidebarColors.sidebarMenuSelectedTextColor === sidebarMenuSelectedTextColor ? /*#__PURE__*/ (0,jsx_runtime.jsx)(core_AppSelectedIcon, {
                isCenter: false,
                backgroundColor: sidebarColors.mode === AppEnums/* ThemeMode.LIGHT */.hY.LIGHT ? theme.palette.text.primary : theme.palette.background.default,
                color: sidebarColors.mode === AppEnums/* ThemeMode.LIGHT */.hY.LIGHT ? theme.palette.background.default : theme.palette.text.primary
            }) : null
        ]
    });
};
/* harmony default export */ var SidebarSettings_MenuColorCell = ((/* unused pure expression or super */ null && (MenuColorCell_MenuColorCell)));
MenuColorCell_MenuColorCell.propTypes = {
    sidebarColors: (prop_types_default()).object
};

;// CONCATENATED MODULE: ./src/@common/core/AppThemeSetting/SidebarSettings/index.js











var SidebarSettings_SidebarSettings = function() {
    var ref = useSidebarContext(), sidebarBgImage = ref.sidebarBgImage, isSidebarBgImage = ref.isSidebarBgImage;
    var ref1 = useSidebarActionsContext(), updateSidebarBgImage = ref1.updateSidebarBgImage, setSidebarBgImage = ref1.setSidebarBgImage;
    var onToggleSidebarImage = function() {
        setSidebarBgImage(!isSidebarBgImage);
    };
    return /*#__PURE__*/ _jsxs(CustomizerItemWrapper, {
        children: [
            /*#__PURE__*/ _jsx(NavMenuStyle, {}),
            /*#__PURE__*/ _jsxs(Box, {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 2.5
                },
                children: [
                    /*#__PURE__*/ _jsx(Box, {
                        component: "h4",
                        children: "Sidebar Images"
                    }),
                    /*#__PURE__*/ _jsx(Box, {
                        component: "span",
                        sx: {
                            ml: "auto"
                        },
                        children: /*#__PURE__*/ _jsx(Switch, {
                            className: "customize-switch",
                            checked: isSidebarBgImage,
                            onChange: onToggleSidebarImage,
                            value: "checkedA"
                        })
                    })
                ]
            }),
            isSidebarBgImage ? /*#__PURE__*/ _jsx(Box, {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                    marginLeft: -2.5,
                    marginRight: -2.5,
                    mt: 5
                },
                children: sidebarBgImages.map(function(imagesObj) {
                    return /*#__PURE__*/ _jsx(Box, {
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            pl: 2.5,
                            pr: 2.5,
                            mb: 5
                        },
                        children: /*#__PURE__*/ _jsxs(Box, {
                            sx: {
                                position: "relative",
                                cursor: "pointer",
                                " & .layout-img": {
                                    width: 82
                                }
                            },
                            onClick: function() {
                                return updateSidebarBgImage(imagesObj.id);
                            },
                            children: [
                                /*#__PURE__*/ _jsx("img", {
                                    src: imagesObj.image,
                                    alt: "nav"
                                }),
                                sidebarBgImage === imagesObj.id ? /*#__PURE__*/ _jsx(Box, {
                                    sx: {
                                        position: "absolute",
                                        left: "50%",
                                        top: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: 25,
                                        height: 25,
                                        borderRadius: "50%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        overflow: "hidden",
                                        backgroundColor: "primary.main"
                                    },
                                    children: /*#__PURE__*/ _jsx(CheckIcon, {
                                        sx: {
                                            color: "white",
                                            fontSize: 22
                                        }
                                    })
                                }) : null
                            ]
                        })
                    }, imagesObj.id);
                })
            }) : null,
            /*#__PURE__*/ _jsx(Box, {
                component: "h4",
                sx: {
                    mb: 3
                },
                children: "Sidebar Colors"
            }),
            /*#__PURE__*/ _jsx(AppGrid, {
                data: sidebarColors,
                column: 2,
                itemPadding: 5,
                renderRow: function(colorSet, index) {
                    return /*#__PURE__*/ _jsx(MenuColorCell, {
                        sidebarColors: colorSet
                    }, index);
                }
            })
        ]
    });
};
/* harmony default export */ var AppThemeSetting_SidebarSettings = ((/* unused pure expression or super */ null && (SidebarSettings_SidebarSettings)));

;// CONCATENATED MODULE: ./src/@common/core/AppThemeSetting/NavStyles/index.js








var NavStyles_NavStyles = function() {
    var updateNavStyle = useLayoutActionsContext().updateNavStyle;
    var navStyle = useLayoutContext().navStyle;
    var onNavStyleChange = function(navStyle) {
        updateNavStyle(navStyle);
    };
    return /*#__PURE__*/ _jsxs(CustomizerItemWrapper, {
        sx: {
            pb: 1
        },
        children: [
            /*#__PURE__*/ _jsx(Box, {
                component: "h4",
                sx: {
                    mb: 3
                },
                children: /*#__PURE__*/ _jsx(IntlMessages, {
                    id: "customizer.navigationStyles"
                })
            }),
            /*#__PURE__*/ _jsx(Box, {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                    mx: -1.25
                },
                children: navStyles.map(function(navLayout) {
                    return /*#__PURE__*/ _jsx(Box, {
                        sx: {
                            px: 1.25,
                            mb: 1.25
                        },
                        children: /*#__PURE__*/ _jsxs(Box, {
                            sx: {
                                position: "relative",
                                cursor: "pointer"
                            },
                            onClick: function() {
                                return onNavStyleChange(navLayout.alias);
                            },
                            children: [
                                /*#__PURE__*/ _jsx("img", {
                                    src: navLayout.image,
                                    alt: "nav"
                                }),
                                navStyle === navLayout.alias ? /*#__PURE__*/ _jsx(AppSelectedIcon, {}) : null
                            ]
                        })
                    }, navLayout.id);
                })
            })
        ]
    });
};
/* harmony default export */ var AppThemeSetting_NavStyles = ((/* unused pure expression or super */ null && (NavStyles_NavStyles)));

;// CONCATENATED MODULE: ./src/@common/core/AppThemeSetting/LayoutTypes/index.js








var LayoutTypes_LayoutTypes = function() {
    var updateLayoutType = useLayoutActionsContext().updateLayoutType;
    var layoutType = useLayoutContext().layoutType;
    var onLayoutChange = function(layoutType) {
        updateLayoutType(layoutType);
    };
    return /*#__PURE__*/ _jsxs(CustomizerItemWrapper, {
        pb: 1,
        children: [
            /*#__PURE__*/ _jsx(Box, {
                component: "h4",
                sx: {
                    mb: 3
                },
                children: /*#__PURE__*/ _jsx(IntlMessages, {
                    id: "customizer.layoutTypes"
                })
            }),
            /*#__PURE__*/ _jsx(Box, {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                    marginLeft: "-10px",
                    marginRight: "-10px"
                },
                children: layoutTypes.map(function(layout) {
                    return /*#__PURE__*/ _jsx(Box, {
                        sx: {
                            paddingLeft: 2.5,
                            paddingRight: 2.5,
                            minWidth: 84,
                            maxHeight: 48
                        },
                        children: /*#__PURE__*/ _jsxs(Box, {
                            sx: {
                                position: "relative",
                                cursor: "pointer"
                            },
                            onClick: function() {
                                return onLayoutChange(layout.alias);
                            },
                            children: [
                                /*#__PURE__*/ _jsx("img", {
                                    src: layout.image,
                                    alt: "nav"
                                }),
                                layoutType === layout.alias ? /*#__PURE__*/ _jsx(AppSelectedIcon, {}) : null
                            ]
                        })
                    }, layout.id);
                })
            })
        ]
    });
};
/* harmony default export */ var AppThemeSetting_LayoutTypes = ((/* unused pure expression or super */ null && (LayoutTypes_LayoutTypes)));

;// CONCATENATED MODULE: ./src/@common/core/AppThemeSetting/ThemeHeader/index.js











var ThemeHeader_ThemeHeader = function() {
    var header = useLayoutContext().header;
    var setHeader = useLayoutActionsContext().setHeader;
    var headerType = useLayoutContext().headerType;
    var setHeaderType = useLayoutActionsContext().setHeaderType;
    return /*#__PURE__*/ _jsxs(CustomizerItemWrapper, {
        children: [
            /*#__PURE__*/ _jsxs(Box, {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    mb: 4
                },
                children: [
                    /*#__PURE__*/ _jsx(Box, {
                        component: "h4",
                        children: "Header"
                    }),
                    /*#__PURE__*/ _jsx(Box, {
                        component: "span",
                        ml: "auto",
                        children: /*#__PURE__*/ _jsx(Switch, {
                            checked: header,
                            onChange: function() {
                                return setHeader(!header);
                            },
                            value: "checkedA",
                            inputProps: {
                                "aria-label": "secondary checkbox"
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(FormControl, {
                variant: "outlined",
                sx: {
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ _jsx(InputLabel, {
                        id: "select-header",
                        children: "Header Type"
                    }),
                    /*#__PURE__*/ _jsx(Select, {
                        sx: {
                            "& .MuiOutlinedInput-input": {
                                padding: "12px 32px 12px 14px"
                            }
                        },
                        labelId: "select-header",
                        label: "Header Type",
                        value: headerType,
                        onChange: function(e) {
                            return setHeaderType(e.target.value);
                        },
                        children: /*#__PURE__*/ _jsx(MenuItem, {
                            value: HeaderType.FIXED,
                            children: "Fixed"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var AppThemeSetting_ThemeHeader = ((/* unused pure expression or super */ null && (ThemeHeader_ThemeHeader)));

;// CONCATENATED MODULE: ./src/@common/core/AppThemeSetting/index.js




















var AppThemeSetting = function() {
    var ref = useState(false), isSettingOpen = ref[0], setSettingOpen = ref[1];
    var ref1 = useState(false), isColorSettingOpen = ref1[0], setColorSettingOpen = ref1[1];
    var layoutType = useLayoutContext().layoutType;
    return /*#__PURE__*/ _jsxs(Box, {
        sx: {
            position: "fixed",
            right: 0,
            top: {
                xs: 85,
                xl: 125
            },
            zIndex: 1110
        },
        className: "customizerOption",
        children: [
            /*#__PURE__*/ _jsx(Box, {
                sx: {
                    borderRadius: "30px 0 0 30px",
                    mb: 1,
                    backgroundColor: orange[500],
                    "&:hover": {
                        backgroundColor: orange[700]
                    },
                    "& button": {
                        borderRadius: "30px 0 0 30px",
                        "&:focus": {
                            borderRadius: "30px 0 0 30px"
                        }
                    }
                },
                children: /*#__PURE__*/ _jsx(IconButton, {
                    onClick: function() {
                        return setSettingOpen(!isSettingOpen);
                    },
                    children: /*#__PURE__*/ _jsx(SettingsOutlinedIcon, {
                        sx: {
                            animation: "rotation 2s infinite linear",
                            color: "white"
                        }
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Box, {
                sx: {
                    borderRadius: "30px 0 0 30px",
                    backgroundColor: orange[500],
                    "&:hover": {
                        backgroundColor: orange[700]
                    },
                    "& button": {
                        borderRadius: "30px 0 0 30px",
                        "&:focus": {
                            borderRadius: "30px 0 0 30px"
                        }
                    }
                },
                children: /*#__PURE__*/ _jsx(IconButton, {
                    onClick: function() {
                        return setColorSettingOpen(!isSettingOpen);
                    },
                    children: /*#__PURE__*/ _jsx(ColorLensIcon, {
                        sx: {
                            color: "white"
                        }
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Drawer, {
                anchor: "right",
                sx: {
                    "& .MuiBackdrop-root": {
                        background: "transparent"
                    }
                },
                className: layoutType === LayoutType.BOXED ? "boxed-drawer" : "",
                open: isSettingOpen,
                onClose: function() {
                    return setSettingOpen(false);
                },
                children: /*#__PURE__*/ _jsxs(AppScrollbar, {
                    sx: {
                        width: {
                            xs: 300,
                            md: 360,
                            xl: 400
                        }
                    },
                    children: [
                        /*#__PURE__*/ _jsxs(Box, {
                            sx: {
                                padding: {
                                    xs: "20px",
                                    xl: "28px 22px"
                                },
                                borderBottom: function(theme) {
                                    return "1px solid ".concat(theme.palette.divider);
                                }
                            },
                            children: [
                                /*#__PURE__*/ _jsx(Box, {
                                    component: "h3",
                                    mb: 0.5,
                                    fontSize: 18,
                                    children: /*#__PURE__*/ _jsx(IntlMessages, {
                                        id: "customizer.customiseSidebar"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Box, {
                                    component: "p",
                                    mb: 0,
                                    color: "text.secondary",
                                    children: /*#__PURE__*/ _jsx(IntlMessages, {
                                        id: "customizer.customiseSidebarText"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(Box, {
                            sx: {
                                padding: {
                                    xs: "20px",
                                    xl: "28px 22px"
                                }
                            },
                            children: [
                                /*#__PURE__*/ _jsx(NavStyles, {}),
                                /*#__PURE__*/ _jsx(LayoutTypes, {}),
                                /*#__PURE__*/ _jsx(ThemeDirection, {}),
                                /*#__PURE__*/ _jsx(ThemeHeader, {}),
                                /*#__PURE__*/ _jsx(ThemeFooter, {}),
                                /*#__PURE__*/ _jsx(SidebarSettings, {})
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Drawer, {
                anchor: "right",
                open: isColorSettingOpen,
                onClose: function() {
                    return setColorSettingOpen(false);
                },
                sx: {
                    "& .MuiBackdrop-root": {
                        background: "transparent"
                    }
                },
                className: layoutType === LayoutType.BOXED ? "boxed-drawer" : "",
                children: /*#__PURE__*/ _jsxs(AppScrollbar, {
                    sx: {
                        width: {
                            xs: 300,
                            md: 360,
                            xl: 400
                        }
                    },
                    children: [
                        /*#__PURE__*/ _jsxs(Box, {
                            sx: {
                                padding: {
                                    xs: "20px",
                                    xl: "28px 22px"
                                },
                                borderBottom: function(theme) {
                                    return "1px solid ".concat(theme.palette.divider);
                                }
                            },
                            children: [
                                /*#__PURE__*/ _jsx(Box, {
                                    component: "h3",
                                    mb: 0.5,
                                    fontSize: 18,
                                    children: /*#__PURE__*/ _jsx(IntlMessages, {
                                        id: "customizer.customiseTheme"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Box, {
                                    component: "p",
                                    mb: 0,
                                    color: "text.secondary",
                                    children: /*#__PURE__*/ _jsx(IntlMessages, {
                                        id: "customizer.customiseText"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(Box, {
                            sx: {
                                padding: {
                                    xs: "20px",
                                    xl: "28px 22px"
                                }
                            },
                            children: [
                                /*#__PURE__*/ _jsx(ThemeModes, {}),
                                /*#__PURE__*/ _jsx(ThemeColors, {})
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var core_AppThemeSetting = ((/* unused pure expression or super */ null && (AppThemeSetting)));

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/DefaultLayout/DefaultLayoutWrapper.js







var DefaultLayoutWrapper = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            flex: 1,
            display: "flex",
            flexDirection: "row",
            position: "relative",
            backgroundColor: function(theme) {
                return theme.palette.background.default;
            },
            "&.appMainFixedFooter": {
                pb: {
                    xs: 12,
                    xl: 14.5
                }
            },
            "&.appMainFixedHeader": {
                pt: {
                    xs: 14,
                    sm: 17.5
                },
                "& .app-bar": {
                    position: "fixed",
                    top: 0,
                    right: 0,
                    zIndex: 9,
                    width: {
                        xs: "100%",
                        lg: "calc(100% - 280px)"
                    }
                }
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var DefaultLayout_DefaultLayoutWrapper = (DefaultLayoutWrapper);
DefaultLayoutWrapper.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/DefaultLayout/MainContent.js







var MainContent = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            flex: 1,
            display: "flex",
            ml: {
                lg: "280px"
            },
            width: {
                xs: "100%",
                lg: "calc(100% - 280px)"
            },
            flexDirection: "column",
            position: "relative",
            transition: "all 0.5s ease"
        },
        className: "mainContent"
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var DefaultLayout_MainContent = (MainContent);
MainContent.propTypes = {
    children: (prop_types_default()).node
};

// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js
var Drawer_Drawer = __webpack_require__(77739);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/List.js + 1 modules
var List = __webpack_require__(73679);
// EXTERNAL MODULE: ./node_modules/react-icons/bi/index.esm.js
var index_esm = __webpack_require__(47516);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var md_index_esm = __webpack_require__(5434);
;// CONCATENATED MODULE: ./src/modules/routesConfig.js




var routesConfig = [
    {
        id: "system",
        title: "System",
        messageId: "sidebar.systems",
        type: "group",
        children: [
            {
                id: "thong-tin-chung",
                title: "General Infomation",
                messageId: "sidebar.generalinfomation",
                type: "collapse",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdOutlineSettingsApplications */.LQY, {}),
                children: [
                    {
                        id: "cong-an-tinh",
                        title: "Customer",
                        messageId: "sidebar.generalinfomation.customer",
                        type: "item",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiAlignLeft */.YSr, {}),
                        url: "/admin/cong-an-tinh"
                    },
                    {
                        id: "bo-cuc",
                        title: "Layout",
                        messageId: "sidebar.generalinfomation.layout",
                        type: "item",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiAlignLeft */.YSr, {}),
                        url: "/admin/bo-cuc"
                    },
                    {
                        id: "hoat-dong-noi-bat-cua-lanh-dao",
                        title: "Leader Activity",
                        messageId: "sidebar.generalinfomation.leaderActivity",
                        type: "item",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiAlignLeft */.YSr, {}),
                        url: "/admin/hoat-dong-noi-bat-cua-lanh-dao"
                    },
                    {
                        id: "email-server",
                        title: "Email Server",
                        messageId: "sidebar.generalinfomation.emailServer",
                        type: "item",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiAlignLeft */.YSr, {}),
                        url: "/admin/email-server"
                    }, 
                ]
            },
            {
                id: "category",
                title: "Category",
                messageId: "sidebar.category",
                type: "collapse",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdOutlineDns */.STt, {}),
                children: [
                    {
                        id: "cau-hinh",
                        title: "Configuration",
                        messageId: "sidebar.category.configuration",
                        type: "item",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiAlignLeft */.YSr, {}),
                        url: "/admin/cau-hinh"
                    },
                    {
                        id: "banner",
                        title: "Banner",
                        messageId: "sidebar.category.banner",
                        type: "item",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiAlignLeft */.YSr, {}),
                        url: "/admin/banner"
                    },
                    {
                        id: "slogan",
                        title: "Slogan",
                        messageId: "sidebar.category.slogan",
                        type: "item",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiAlignLeft */.YSr, {}),
                        url: "/admin/slogan"
                    },
                    {
                        id: "lanh-dao-cong-an-tinh",
                        title: "Lead Cadres",
                        messageId: "sidebar.category.leadcadres",
                        type: "item",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiAlignLeft */.YSr, {}),
                        url: "/admin/lanh-dao-cong-an-tinh"
                    },
                    {
                        id: "danh-ba",
                        title: "Contact",
                        messageId: "sidebar.category.contact",
                        type: "item",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiAlignLeft */.YSr, {}),
                        url: "/admin/danh-ba"
                    },
                    {
                        id: "danh-muc",
                        title: "Category",
                        messageId: "sidebar.category.category",
                        type: "item",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiAlignLeft */.YSr, {}),
                        url: "/admin/danh-muc"
                    },
                    {
                        id: "lien-ket",
                        title: "Link",
                        messageId: "sidebar.category.link",
                        type: "item",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiAlignLeft */.YSr, {}),
                        url: "/admin/lien-ket"
                    },
                    {
                        id: "don-vi-dia-phuong-va-don-vi-truc-thuoc",
                        title: "Unit",
                        messageId: "sidebar.category.unit",
                        type: "item",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiAlignLeft */.YSr, {}),
                        url: "/admin/don-vi-dia-phuong-va-don-vi-truc-thuoc"
                    },
                    {
                        id: "chinh-sach-dam-bao-atttcn",
                        title: "Security",
                        messageId: "sidebar.category.security",
                        type: "item",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiAlignLeft */.YSr, {}),
                        url: "/admin/chinh-sach-dam-bao-atttcn"
                    }, 
                ]
            },
            {
                id: "media",
                title: "Media Library",
                messageId: "sidebar.media",
                type: "collapse",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdPermMedia */.SnS, {}),
                children: [
                    {
                        id: "quan-ly-media",
                        title: "Thư viện",
                        messageId: "sidebar.media.library",
                        type: "item",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiAlignLeft */.YSr, {}),
                        url: "/admin/quan-ly-media"
                    }, 
                ]
            },
            // {
            //   id: 'administrative_procedure',
            //   title: 'Administrative Formalities',
            //   messageId: 'sidebar.administrative',
            //   type: 'collapse',
            //   icon: <MdOutlineHistoryEdu />,
            //   children: [
            //     {
            //       id: 'administrative_list',
            //       title: 'Danh sách thủ tục hành chính',
            //       messageId: 'sidebar.administrative.list',
            //       type: 'item',
            //       icon: <BiAlignLeft />,
            //       url: '/admin/tthc/thu-tuc-hanh-chinh',
            //     },
            //     {
            //       id: 'tin-bai-tthc',
            //       title: 'ArticleProcedure',
            //       messageId: 'sidebar.administrative.articleprocedure',
            //       type: 'item',
            //       icon: <BiAlignLeft />,
            //       url: '/admin/tin-bai-tthc',
            //     },
            //   ],
            // },
            {
                id: "user",
                title: "User management",
                messageId: "sidebar.user",
                type: "collapse",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdOutlineManageAccounts */.h24, {}),
                children: [
                    {
                        id: "nguoi-dung",
                        title: "Danh s\xe1ch người d\xf9ng",
                        messageId: "sidebar.user.list",
                        type: "item",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiAlignLeft */.YSr, {}),
                        url: "/admin/nguoi-dung"
                    },
                    {
                        id: "quyen-nguoi-dung",
                        title: "Danh s\xe1ch quyền",
                        messageId: "sidebar.user.role",
                        type: "item",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiAlignLeft */.YSr, {}),
                        url: "/admin/quyen-nguoi-dung"
                    },
                    {
                        id: "thong-tin-tai-khoan",
                        title: "PersonalInformation",
                        messageId: "sidebar.personalinfo",
                        type: "item",
                        hidden: true,
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiAlignLeft */.YSr, {}),
                        url: "/admin/thong-tin-tai-khoan"
                    }, 
                ]
            },
            {
                id: "reflectRequest",
                title: "Reflect Request",
                messageId: "sidebar.reflect",
                type: "collapse",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdMoveToInbox */.il_, {}),
                permission: AppEnums/* PermissionCode.READ */.nn.READ,
                children: [
                    {
                        id: "phan-anh-kien-nghi-cau-hinh",
                        title: "Cấu h\xecnh",
                        messageId: "sidebar.reflect.config",
                        type: "item",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiAlignLeft */.YSr, {}),
                        url: "/admin/phan-anh-kien-nghi-cau-hinh"
                    },
                    {
                        id: "linh-vuc-phan-anh",
                        title: "Danh mục lĩnh vực",
                        messageId: "sidebar.reflect.field",
                        type: "item",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiAlignLeft */.YSr, {}),
                        url: "/admin/linh-vuc-phan-anh"
                    }, 
                ]
            },
            {
                id: "lawDissemination",
                title: "Law Dissemination",
                messageId: "sidebar.lawdissemination",
                type: "collapse",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdLibraryBooks */.dBs, {}),
                children: [
                    {
                        id: "quan-ly-van-ban",
                        title: "Quản l\xfd văn bản",
                        messageId: "sidebar.lawdissemination.document",
                        type: "item",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiAlignLeft */.YSr, {}),
                        url: "/admin/quan-ly-van-ban"
                    },
                    {
                        id: "loai-van-ban",
                        title: "Loại văn bản",
                        messageId: "sidebar.lawdissemination.documenttype",
                        type: "item",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiAlignLeft */.YSr, {}),
                        url: "/admin/loai-van-ban"
                    },
                    {
                        id: "co-quan-ban-hanh",
                        title: "Cơ quan ban h\xe0nh",
                        messageId: "sidebar.lawdissemination.agencyissued",
                        type: "item",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiAlignLeft */.YSr, {}),
                        url: "/admin/co-quan-ban-hanh"
                    }, 
                ]
            },
            {
                id: "manage-evaluation-category",
                title: "Manage Evaluation",
                messageId: "sidebar.categoryEvaluation",
                type: "collapse",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdFeaturedPlayList */.tSu, {}),
                children: [
                    {
                        id: "qr-danh-gia",
                        title: "Quản l\xfd QR đ\xe1nh gi\xe1",
                        messageId: "sidebar.manageEvaluation.qr",
                        type: "item",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiAlignLeft */.YSr, {}),
                        url: "/admin/qr-danh-gia"
                    },
                    {
                        id: "tieu-chi-danh-gia",
                        title: "Quản l\xfd Ti\xeau ch\xed đ\xe1nh gi\xe1",
                        messageId: "sidebar.manageEvaluation.criteria",
                        type: "item",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiAlignLeft */.YSr, {}),
                        url: "/admin/tieu-chi-danh-gia"
                    },
                    {
                        id: "muc-do-danh-gia",
                        title: "Mức độ",
                        messageId: "sidebar.manageEvaluation.level",
                        type: "item",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiAlignLeft */.YSr, {}),
                        url: "/admin/muc-do-danh-gia"
                    },
                    // {
                    //   id: 'thiet-bi-danh-gia',
                    //   title: 'Thiết bị',
                    //   messageId: 'sidebar.manageEvaluation.device',
                    //   type: 'item',
                    //   icon: <BiAlignLeft />,
                    //   url: '/admin/thiet-bi-danh-gia',
                    // },
                    {
                        id: "don-vi-tthc",
                        title: "Đơn vị h\xe0nh ch\xednh c\xf4ng",
                        messageId: "sidebar.manageEvaluation.unit",
                        type: "item",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiAlignLeft */.YSr, {}),
                        url: "/admin/don-vi-tthc"
                    },
                    {
                        id: "doi-tthc",
                        title: "Đội h\xe0nh ch\xednh c\xf4ng",
                        messageId: "sidebar.manageEvaluation.team",
                        type: "item",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiAlignLeft */.YSr, {}),
                        url: "/admin/doi-tthc"
                    }, 
                ]
            },
            {
                id: "manage-evaluation",
                title: "Manage Evaluation",
                messageId: "sidebar.manageEvaluation",
                type: "collapse",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdOutlineHistoryEdu */.FvL, {}),
                children: [
                    {
                        id: "quan-ly-danh-gia",
                        title: "Quản l\xfd đ\xe1nh gi\xe1",
                        messageId: "sidebar.manageEvaluation.manage",
                        type: "item",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiAlignLeft */.YSr, {}),
                        url: "/admin/quan-ly-danh-gia"
                    },
                    {
                        id: "thong-ke-theo-don-vi",
                        title: "Thống k\xea theo đơn vị",
                        messageId: "sidebar.manageEvaluation.reportByUnit",
                        type: "item",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiAlignLeft */.YSr, {}),
                        url: "/admin/thong-ke-theo-don-vi"
                    },
                    {
                        id: "thong-ke-theo-thoi-gian",
                        title: "Thống k\xea theo thời gian",
                        messageId: "sidebar.manageEvaluation.reportByTime",
                        type: "item",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiAlignLeft */.YSr, {}),
                        url: "/admin/thong-ke-theo-thoi-gian"
                    },
                    {
                        id: "thong-ke-theo-luot-truy-cap",
                        title: "Thống k\xea theo luowit truy cập",
                        messageId: "sidebar.manageEvaluation.reportByAccess",
                        type: "item",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiAlignLeft */.YSr, {}),
                        url: "/admin/thong-ke-theo-luot-truy-cap"
                    },
                    {
                        id: "thong-ke-theo-tieu-chi",
                        title: "Thống k\xea theo ti\xeau ch\xed",
                        messageId: "sidebar.manageEvaluation.reportByCriteria",
                        type: "item",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiAlignLeft */.YSr, {}),
                        url: "/admin/thong-ke-theo-tieu-chi"
                    },
                    {
                        id: "thong-ke-luot-truy-cap-qr",
                        title: "Thống k\xea theo lượt truy cập QR",
                        messageId: "sidebar.manageEvaluation.reportByQR",
                        type: "item",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiAlignLeft */.YSr, {}),
                        url: "/admin/thong-ke-luot-truy-cap-qr"
                    }, 
                ]
            }, 
        ]
    },
    {
        id: "tin-bai",
        title: "Article",
        messageId: "sidebar.article",
        type: "group",
        url: "/admin/tin-bai",
        children: [
            {
                id: "danh-sach",
                title: "Danh s\xe1ch",
                messageId: "sidebar.article.list",
                type: "item",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdOutlineArticle */.TYc, {}),
                url: "/admin/tin-bai/danh-sach"
            },
            {
                id: "tao-moi",
                title: "Tạo mới",
                messageId: "sidebar.article.add",
                type: "item",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdCreate */.Gpi, {}),
                url: "/admin/tin-bai/tao-moi",
                permission: AppEnums/* PermissionCode.CREATE */.nn.CREATE
            },
            {
                id: "duyet",
                title: "Duyệt tin b\xe0i",
                messageId: "sidebar.article.approval",
                type: "item",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdApproval */.OnK, {}),
                url: "/admin/tin-bai/duyet",
                permission: AppEnums/* PermissionCode.APPLY */.nn.APPLY
            }, 
        ]
    },
    {
        id: "phan-anh-kien-nghi",
        title: "Quản l\xfd Phản \xe1nh - Kiến nghị",
        messageId: "sidebar.reflect.list",
        type: "group",
        url: "/admin/phan-anh-kien-nghi",
        permission: AppEnums/* PermissionCode.DELETE */.nn.DELETE,
        children: [
            {
                id: "phan-anh-cho-xu-ly",
                title: "Phản \xe1nh chờ xử l\xfd",
                messageId: "sidebar.reflect.process",
                type: "item",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdHourglassBottom */.TSC, {}),
                url: "/admin/phan-anh-kien-nghi/phan-anh-cho-xu-ly",
                permission: AppEnums/* PermissionCode.DELETE */.nn.DELETE
            },
            {
                id: "phan-anh-cho-duyet",
                title: "Phản \xe1nh chờ duyệt",
                messageId: "sidebar.reflect.approve",
                type: "item",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdAssignmentTurnedIn */.Z5O, {}),
                url: "/admin/phan-anh-kien-nghi/phan-anh-cho-duyet",
                permission: AppEnums/* PermissionCode.DELETE */.nn.DELETE
            },
            {
                id: "phan-anh-cong-khai",
                title: "Phản \xe1nh được c\xf4ng khai",
                messageId: "sidebar.reflect.public",
                type: "item",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdFeed */.UT$, {}),
                url: "/admin/phan-anh-kien-nghi/phan-anh-cong-khai",
                permission: AppEnums/* PermissionCode.DELETE */.nn.DELETE
            },
            {
                id: "thong-ke-phan-anh-kien-nghi",
                title: "Thống k\xea",
                messageId: "sidebar.reflect.report",
                type: "item",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdBarChart */.OMZ, {}),
                url: "/admin/phan-anh-kien-nghi/thong-ke-phan-anh-kien-nghi",
                permission: AppEnums/* PermissionCode.DELETE */.nn.DELETE
            }, 
        ]
    },
    {
        id: "administrative_procedure",
        title: "Administrative Formalities",
        messageId: "sidebar.administrative",
        type: "group",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdOutlineHistoryEdu */.FvL, {}),
        permission: AppEnums/* PermissionCode.READ */.nn.READ,
        children: [
            {
                id: "cap-quan-ly-tthc",
                title: "Managers Level",
                messageId: "sidebar.category.managerslevel",
                type: "item",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiAlignLeft */.YSr, {}),
                url: "/admin/cap-quan-ly-tthc"
            },
            {
                id: "giay-to-thu-tuc-hanh-chinh",
                title: "ArticleProcedure",
                messageId: "sidebar.administrative.articleprocedure",
                type: "item",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdStickyNote2 */.nIP, {}),
                url: "/admin/giay-to-thu-tuc-hanh-chinh",
                permission: AppEnums/* PermissionCode.READ */.nn.READ
            },
            {
                id: "danh-muc-thu-tuc-hanh-chinh",
                title: "Danh mục Thủ tục h\xe0nh ch\xednh",
                messageId: "sidebar.administrative.list",
                type: "item",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdWork */.CvH, {}),
                url: "/admin/danh-muc-thu-tuc-hanh-chinh",
                permission: AppEnums/* PermissionCode.READ */.nn.READ
            }, 
        ]
    },
    {
        id: "cau-hoi",
        title: "Online Inquiry",
        messageId: "sidebar.onlineinquiry",
        type: "group",
        url: "/admin/cau-hoi",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdOutlineHistoryEdu */.FvL, {}),
        children: [
            {
                id: "cau-hoi-da-xu-ly",
                title: "C\xe2u hỏi đ\xe3 xử l\xfd",
                messageId: "sidebar.onlineinquiry.process",
                type: "item",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdAssignmentTurnedIn */.Z5O, {}),
                url: "/admin/cau-hoi/cau-hoi-da-xu-ly",
                permission: AppEnums/* PermissionCode.DELETE */.nn.DELETE
            },
            {
                id: "cau-hoi-cho-xu-ly",
                title: "C\xe2u hỏi chờ xử l\xfd",
                messageId: "sidebar.onlineinquiry.approve",
                type: "item",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdHourglassBottom */.TSC, {}),
                url: "/admin/cau-hoi/cau-hoi-cho-xu-ly",
                permission: AppEnums/* PermissionCode.DELETE */.nn.DELETE
            },
            {
                id: "cau-hinh-hoi-dap",
                title: "Cấu h\xecnh HĐTT",
                messageId: "sidebar.onlineinquiry.config",
                type: "item",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiAlignLeft */.YSr, {}),
                url: "/admin/cau-hinh-hoi-dap",
                permission: AppEnums/* PermissionCode.READ */.nn.READ
            }, 
        ]
    }, 
];
/* harmony default export */ var modules_routesConfig = (routesConfig);

// EXTERNAL MODULE: ./src/@common/core/AppBadge/index.js
var AppBadge = __webpack_require__(13151);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(89582);
;// CONCATENATED MODULE: ./src/@common/utility/helper/RouteHelper.js
var checkPermission = function(routeRole, userRole) {
    if (!routeRole || !routeRole) {
        return true;
    }
    if (userRole && Array.isArray(userRole) && !Array.isArray(routeRole)) {
        return userRole.indexOf(routeRole) >= 0;
    }
    if (routeRole.length === 0) {
        return !userRole || userRole.length === 0;
    }
    if (userRole && Array.isArray(userRole) && Array.isArray(routeRole)) {
        return routeRole.some(function(r) {
            return userRole.indexOf(r) >= 0;
        });
    }
    return routeRole.indexOf(userRole) >= 0;
};
var checkPathPermission = function(asPath, userPermission, permittedPermission) {
    if (!asPath || !userPermission) {
        return true;
    }
    if (userPermission && Array.isArray(userPermission) && !!Array.isArray(userPermission)) {
        return userPermission.some(function(p) {
            return asPath.includes(p.url) && p.quyen.split(",").some(function(r) {
                return r.includes(permittedPermission !== null && permittedPermission !== void 0 ? permittedPermission : "R");
            });
        });
    }
    if (userPermission.length === 0) {
        return !userPermission || userPermission.length === 0;
    }
};
var checkChildrenPermission = function(children, userPermission, permittedPermission) {
    if (!children || !userPermission) {
        return true;
    }
    if (userPermission && Array.isArray(userPermission) && !!Array.isArray(userPermission) && children && Array.isArray(children) && !!Array.isArray(children)) {
        var flag = false;
        children.forEach(function(element) {
            if (userPermission.some(function(p) {
                return element.url.includes(p.url) && p.quyen.split(",").some(function(r) {
                    return r.includes(permittedPermission !== null && permittedPermission !== void 0 ? permittedPermission : "R");
                });
            })) {
                flag = true;
            }
        });
        return flag;
    }
    if (userPermission.length === 0) {
        return !userPermission || userPermission.length === 0;
    }
};
var checkPermissionClient = function(userPermission, permittedPermission, url) {
    if (!userPermission || !url || !permittedPermission) return false;
    if (userPermission && Array.isArray(userPermission) && !!Array.isArray(userPermission)) {
        return userPermission.some(function(p) {
            return p.quyen.split(",").some(function(r) {
                return r.includes(permittedPermission);
            }) && p.url.includes(url);
        });
    }
    return false;
};

// EXTERNAL MODULE: ./src/@common/utility/AuthHooks.js + 1 modules
var AuthHooks = __webpack_require__(35794);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItem/ListItem.js + 4 modules
var ListItem = __webpack_require__(5693);
;// CONCATENATED MODULE: ./src/@common/core/AppLayout/components/VerticalNav/VerticalItem/VerticalNavItem.js











var VerticalNavItem = function(_param) {
    var children = _param.children, item = _param.item, className = _param.className, router = _param.router, level = _param.level, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "item",
        "className",
        "router",
        "level"
    ]);
    var ref = (0,SidebarContextProvider/* useSidebarContext */.Sz)(), sidebarTextColor = ref.sidebarTextColor, sidebarMenuSelectedBgColor = ref.sidebarMenuSelectedBgColor, sidebarMenuSelectedTextColor = ref.sidebarMenuSelectedTextColor, menuStyle = ref.menuStyle;
    var pathname = router.pathname, asPath = router.asPath;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        className: (0,clsx_m["default"])("nav-item menu-vertical-item", {
            "rounded-menu": menuStyle === AppEnums/* MenuStyle.ROUNDED */.gA.ROUNDED,
            "rounded-menu-reverse": menuStyle === AppEnums/* MenuStyle.ROUNDED_REVERSE */.gA.ROUNDED_REVERSE,
            "standard-menu": menuStyle === AppEnums/* MenuStyle.STANDARD */.gA.STANDARD,
            "curved-menu": menuStyle === AppEnums/* MenuStyle.CURVED_MENU */.gA.CURVED_MENU,
            active: item.url === pathname || item.url === asPath
        }),
        sx: {
            height: 40,
            my: 0.25,
            cursor: "pointer",
            textDecoration: "none !important",
            mx: 2,
            width: "calc(100% - 16px)",
            pl: 22 + 33 * level + "px",
            pr: 3,
            borderRadius: 1,
            position: "relative",
            transition: "all 0.4s ease",
            whiteSpace: "nowrap",
            "& .nav-item-icon": {
                color: (0,colorManipulator/* alpha */.Fq)(sidebarTextColor, 0.7),
                fontSize: 20,
                display: "block"
            },
            "& .nav-item-text": {
                color: (0,colorManipulator/* alpha */.Fq)(sidebarTextColor, 0.7),
                fontWeight: AppEnums/* Fonts.MEDIUM */.F3.MEDIUM,
                fontSize: 14
            },
            "& .MuiTouchRipple-root": {
                zIndex: 1
            },
            "&.nav-item-header": {
                textTransform: "uppercase"
            },
            "&:hover, &:focus": {
                "& .nav-item-text, & .nav-item-icon, & .nav-item-icon-arrow": {
                    color: sidebarTextColor
                }
            },
            "&.active": {
                backgroundColor: sidebarMenuSelectedBgColor,
                pointerEvents: "none",
                "& .nav-item-text": {
                    color: sidebarMenuSelectedTextColor + "!important",
                    fontWeight: AppEnums/* Fonts.MEDIUM */.F3.MEDIUM
                },
                "& .nav-item-icon": {
                    color: sidebarMenuSelectedTextColor + "!important"
                }
            },
            "&.rounded-menu": {
                mr: 4,
                ml: 0,
                width: "calc(100% - 16px)",
                pl: 30 + 33 * level + "px",
                pr: 3,
                borderRadius: "0 30px 30px 0"
            },
            "&.rounded-menu-reverse": {
                ml: 4,
                mr: 0,
                width: "calc(100% - 16px)",
                pl: 14 + 33 * level + "px",
                pr: 3,
                borderRadius: "30px 0 0 30px"
            },
            "&.standard-menu": {
                mx: 0,
                width: "100%",
                pl: 30 + 33 * level + "px",
                pr: 3,
                borderRadius: 0,
                position: "relative",
                "&:after": {
                    content: '""',
                    position: "absolute",
                    right: 0,
                    top: 0,
                    height: "100%",
                    width: 4,
                    backgroundColor: "transparent"
                },
                "&.active:after": {
                    backgroundColor: function(theme) {
                        return theme.palette.primary.main;
                    }
                }
            },
            "&.curved-menu": {
                ml: 4,
                mr: 0,
                width: "calc(100% - 16px)",
                pl: 14 + 33 * level + "px",
                pr: 3,
                borderRadius: "30px 0 0 30px",
                position: "relative",
                transition: "none",
                "&:before, &:after": {
                    content: '""',
                    position: "absolute",
                    right: 0,
                    zIndex: 1,
                    height: 40,
                    width: 40,
                    backgroundColor: "transparent",
                    borderRadius: "50%",
                    opacity: 0
                },
                "&:before": {
                    top: -40,
                    boxShadow: "30px 30px 0 10px transparent"
                },
                "&:after": {
                    bottom: -40,
                    boxShadow: "30px -30px 0 10px transparent"
                },
                "&:hover, &.active": {
                    backgroundColor: sidebarMenuSelectedBgColor,
                    "& .nav-item-text, & .nav-item-icon": {
                        color: sidebarMenuSelectedTextColor + "!important"
                    },
                    "&:before": {
                        boxShadow: "30px 30px 0 10px ".concat(sidebarMenuSelectedBgColor),
                        opacity: 1
                    },
                    "&:after": {
                        boxShadow: "30px -30px 0 10px ".concat(sidebarMenuSelectedBgColor),
                        opacity: 1
                    }
                },
                "& .MuiTouchRipple-root": {
                    display: "none"
                }
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var VerticalItem_VerticalNavItem = (VerticalNavItem);
VerticalNavItem.propTypes = {
    children: (prop_types_default()).node,
    level: (prop_types_default()).number,
    className: (prop_types_default()).string,
    item: (prop_types_default()).object,
    router: (prop_types_default()).object
};

// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(44413);
// EXTERNAL MODULE: ./node_modules/@mui/material/Icon/Icon.js + 1 modules
var Icon = __webpack_require__(67799);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
;// CONCATENATED MODULE: ./src/@common/core/AppLayout/components/VerticalNav/VerticalItem/index.js
















var VerticalItem = function(param) {
    var level = param.level, router = param.router, item = param.item;
    var user = (0,AuthHooks/* useAuthUser */.f)().user;
    var intl = (0,useIntl/* default */.Z)();
    var permission = (0,es/* useSelector */.v9)(function(param) {
        var authentication = param.authentication;
        return authentication.permission;
    });
    var isSuperAdmin = (0,es/* useSelector */.v9)(function(param) {
        var authentication = param.authentication;
        return authentication.isSuperAdmin;
    });
    var hasPermission = (0,react.useMemo)(// eslint-disable-next-line react/prop-types
    function() {
        return !isSuperAdmin ? checkPathPermission(item.url, permission, item.permission) : true;
    }, // eslint-disable-next-line react/prop-types
    [
        item.url,
        permission
    ]);
    if (!hasPermission) {
        return null;
    }
    return !item.hidden ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: item.url,
        as: item.as,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            style: {
                textDecoration: "none"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(VerticalItem_VerticalNavItem, {
                item: item,
                level: level,
                router: router,
                exact: item.exact,
                children: [
                    item.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        component: "span",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            sx: {
                                fontSize: 18,
                                display: "block",
                                mr: 4
                            },
                            className: (0,clsx_m["default"])("nav-item-icon", "material-icons-outlined"),
                            color: "action",
                            children: item.icon
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(utility_IntlMessages/* default */.Z, {
                            id: item.messageId
                        }),
                        placement: "right",
                        arrow: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                            className: "nav-item-content",
                            primary: intl.formatMessage({
                                id: item.messageId
                            }).length > 26 ? intl.formatMessage({
                                id: item.messageId
                            }).substring(0, 23).concat("...") : intl.formatMessage({
                                id: item.messageId
                            }),
                            classes: {
                                primary: "nav-item-text"
                            }
                        })
                    }),
                    item.count && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            mr: 3.5
                        },
                        className: "menu-badge",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBadge/* default */.Z, {
                            count: item.count,
                            color: item.color
                        })
                    })
                ]
            })
        })
    }) : null;
};
VerticalItem.propTypes = {
    item: prop_types_default().shape({
        as: (prop_types_default()).string,
        color: (prop_types_default()).string,
        count: prop_types_default().oneOfType([
            (prop_types_default()).string,
            (prop_types_default()).number
        ]),
        exact: (prop_types_default()).bool,
        hidden: (prop_types_default()).any,
        icon: prop_types_default().oneOfType([
            (prop_types_default()).string,
            (prop_types_default()).node
        ]),
        id: (prop_types_default()).string.isRequired,
        messageId: (prop_types_default()).string,
        permittedRole: prop_types_default().oneOfType([
            (prop_types_default()).array,
            (prop_types_default()).string
        ]),
        title: (prop_types_default()).string,
        url: (prop_types_default()).string
    }),
    level: (prop_types_default()).number,
    router: (prop_types_default()).object
};
VerticalItem.defaultProps = {};
/* harmony default export */ var VerticalNav_VerticalItem = (/*#__PURE__*/react.memo(VerticalItem));

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/components/VerticalNav/VerticalCollapse/VerticalCollapseItem.js









var VerticalCollapseItem = function(_param) {
    var children = _param.children, sidebarTextColor = _param.sidebarTextColor, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "sidebarTextColor"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            height: 40,
            my: 0.25,
            pl: "31px",
            pr: 3.75,
            whiteSpace: "nowrap",
            transition: "all 0.4s ease",
            "& .nav-item-text": {
                fontWeight: AppEnums/* Fonts.MEDIUM */.F3.MEDIUM,
                color: (0,colorManipulator/* alpha */.Fq)(sidebarTextColor, 0.7)
            },
            "& .nav-item-icon": {
                color: (0,colorManipulator/* alpha */.Fq)(sidebarTextColor, 0.7),
                fontSize: 20,
                display: "block"
            },
            "& .nav-item-icon-arrow": {
                color: (0,colorManipulator/* alpha */.Fq)(sidebarTextColor, 0.7)
            },
            "& .MuiIconButton-root": {
                mr: 3,
                padding: 0
            },
            "& .MuiTouchRipple-root": {
                zIndex: 10
            },
            "&.open, &:hover, &:focus": {
                "& .nav-item-text": {
                    fontWeight: AppEnums/* Fonts.MEDIUM */.F3.MEDIUM,
                    color: sidebarTextColor
                },
                "& .nav-item-icon": {
                    color: sidebarTextColor
                },
                "& .nav-item-icon-arrow": {
                    color: sidebarTextColor
                }
            },
            "&:hover": {
                backgroundColor: "transparent"
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var VerticalCollapse_VerticalCollapseItem = (VerticalCollapseItem);
VerticalCollapseItem.propTypes = {
    children: (prop_types_default()).node,
    sidebarTextColor: (prop_types_default()).string
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./node_modules/@mui/material/Collapse/Collapse.js + 1 modules
var Collapse = __webpack_require__(75828);
;// CONCATENATED MODULE: ./src/@common/core/AppLayout/components/VerticalNav/VerticalCollapse/index.js



















var needsToBeOpened = function(pathname, item) {
    return pathname && isUrlInChildren(item, pathname);
};
var isUrlInChildren = function(parent, url) {
    if (!parent.children) {
        return false;
    }
    for(var i = 0; i < parent.children.length; i++){
        if (parent.children[i].children) {
            if (isUrlInChildren(parent.children[i], url)) {
                return true;
            }
        }
        if (parent.children[i].url === url || url.includes(parent.children[i].url)) {
            return true;
        }
    }
    return false;
};
var VerticalCollapse = function(param) {
    var item = param.item, router = param.router, level = param.level;
    var theme = (0,ThemeContextProvider/* useThemeContext */.TC)().theme;
    var sidebarTextColor = (0,SidebarContextProvider/* useSidebarContext */.Sz)().sidebarTextColor;
    var pathname = (0,next_router.useRouter)().pathname;
    var ref = (0,react.useState)(function() {
        return needsToBeOpened(pathname, item);
    }), open = ref[0], setOpen = ref[1];
    (0,react.useEffect)(function() {
        if (needsToBeOpened(pathname, item)) {
            setOpen(true);
        }
    }, [
        pathname,
        item
    ]);
    var handleClick = function() {
        setOpen(!open);
    };
    var user = (0,AuthHooks/* useAuthUser */.f)().user;
    var permission = (0,es/* useSelector */.v9)(function(param) {
        var authentication = param.authentication;
        return authentication.permission;
    });
    var isSuperAdmin = (0,es/* useSelector */.v9)(function(param) {
        var authentication = param.authentication;
        return authentication.isSuperAdmin;
    });
    var hasPermission = (0,react.useMemo)(// eslint-disable-next-line react/prop-types
    function() {
        return !isSuperAdmin ? item.url ? checkPathPermission(item.url, permission, item.permission) : checkChildrenPermission(item.children, permission, item.permission) : true;
    }, // eslint-disable-next-line react/prop-types
    [
        item.url,
        permission
    ]);
    if (!hasPermission && !isSuperAdmin) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(VerticalCollapse_VerticalCollapseItem, {
                level: level,
                sidebarTextColor: sidebarTextColor,
                button: true,
                component: "div",
                className: (0,clsx_m["default"])("menu-vertical-collapse", open && "open"),
                onClick: handleClick,
                children: [
                    item.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        component: "span",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            sx: {
                                mr: 4
                            },
                            color: "action",
                            className: (0,clsx_m["default"])("nav-item-icon"),
                            children: item.icon
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                        sx: {
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            fontSize: 14
                        },
                        className: "nav-item-content",
                        classes: {
                            primary: (0,clsx_m["default"])("nav-item-text")
                        },
                        primary: /*#__PURE__*/ (0,jsx_runtime.jsx)(utility_IntlMessages/* default */.Z, {
                            id: item.messageId
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                        className: "nav-item-icon-arrow-btn",
                        sx: {
                            p: 0,
                            mr: 0.75
                        },
                        disableRipple: true,
                        size: "large",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            className: "nav-item-icon-arrow",
                            color: "inherit",
                            children: open ? "expand_more" : theme.direction === "ltr" ? "chevron_right" : "chevron_left"
                        })
                    })
                ]
            }),
            item.children && /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                in: open,
                className: "collapse-children",
                children: item.children.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            item.type === "collapse" && /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalCollapse, {
                                item: item,
                                level: level + 1,
                                router: router
                            }),
                            item.type === "item" && /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalNav_VerticalItem, {
                                item: item,
                                level: level + 1,
                                router: router
                            })
                        ]
                    }, item.id);
                })
            })
        ]
    });
};
VerticalCollapse.propTypes = {
    item: prop_types_default().shape({
        id: (prop_types_default()).string.isRequired,
        title: (prop_types_default()).string,
        icon: prop_types_default().oneOfType([
            (prop_types_default()).node,
            (prop_types_default()).string
        ]),
        permittedRole: prop_types_default().oneOfType([
            (prop_types_default()).array,
            (prop_types_default()).string
        ]),
        children: (prop_types_default()).array,
        messageId: (prop_types_default()).string,
        type: (prop_types_default()).string
    }),
    level: (prop_types_default()).number,
    router: (prop_types_default()).object
};
VerticalCollapse.defaultProps = {};
/* harmony default export */ var VerticalNav_VerticalCollapse = (/*#__PURE__*/react.memo(VerticalCollapse));

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/components/VerticalNav/VerticalNavGroup/VerticalNavGroupItem.js









var VerticalNavGroupItem = function(_param) {
    var children = _param.children, sidebarTextColor = _param.sidebarTextColor, level = _param.level, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "sidebarTextColor",
        "level"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            height: 40,
            my: 0.25,
            pl: 31 + 33 * level + "px",
            pr: 3,
            color: (0,colorManipulator/* alpha */.Fq)(sidebarTextColor, 0.7),
            fontWeight: AppEnums/* Fonts.BOLD */.F3.BOLD,
            textTransform: "uppercase",
            fontSize: 14,
            cursor: "pointer",
            textDecoration: "none!important",
            borderTop: function(theme) {
                return "1px solid ".concat(theme.palette.divider);
            },
            whiteSpace: "nowrap",
            transition: "all 0.4s ease",
            "&.nav-item-header": {
                cursor: "auto",
                transition: "all 0.4s ease"
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var VerticalNavGroup_VerticalNavGroupItem = (VerticalNavGroupItem);
VerticalNavGroupItem.propTypes = {
    children: (prop_types_default()).node,
    sidebarTextColor: (prop_types_default()).string,
    level: (prop_types_default()).number
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/components/VerticalNav/VerticalNavGroup/index.js













var VerticalNavGroup = function(param) {
    var item = param.item, router = param.router, level = param.level;
    var sidebarTextColor = (0,SidebarContextProvider/* useSidebarContext */.Sz)().sidebarTextColor;
    var user = (0,AuthHooks/* useAuthUser */.f)().user;
    var permission = (0,es/* useSelector */.v9)(function(param) {
        var authentication = param.authentication;
        return authentication.permission;
    });
    var isSuperAdmin = (0,es/* useSelector */.v9)(function(param) {
        var authentication = param.authentication;
        return authentication.isSuperAdmin;
    });
    var hasPermission = (0,react.useMemo)(// eslint-disable-next-line react/prop-types
    function() {
        return !isSuperAdmin ? checkPathPermission(item.url, permission, item.permission) : true;
    }, // eslint-disable-next-line react/prop-types
    [
        item.url,
        permission,
        isSuperAdmin
    ]);
    if (!hasPermission) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalNavGroup_VerticalNavGroupItem, {
                level: level,
                sidebarTextColor: sidebarTextColor,
                component: "div",
                className: (0,clsx_m["default"])("nav-item nav-item-header"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utility_IntlMessages/* default */.Z, {
                    id: item.messageId
                })
            }),
            item.children && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: item.children.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            item.type === "group" && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavVerticalGroup, {
                                item: item,
                                level: level,
                                router: router
                            }),
                            item.type === "collapse" && /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalNav_VerticalCollapse, {
                                item: item,
                                level: level,
                                router: router
                            }),
                            item.type === "item" && /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalNav_VerticalItem, {
                                item: item,
                                level: level,
                                router: router
                            })
                        ]
                    }, item.id);
                })
            })
        ]
    });
};
VerticalNavGroup.propTypes = {
    item: prop_types_default().shape({
        id: (prop_types_default()).string.isRequired,
        title: (prop_types_default()).string,
        type: (prop_types_default()).string,
        icon: prop_types_default().oneOfType([
            (prop_types_default()).node,
            (prop_types_default()).string
        ]),
        permittedRole: prop_types_default().oneOfType([
            (prop_types_default()).array,
            (prop_types_default()).string
        ]),
        messageId: (prop_types_default()).string,
        children: (prop_types_default()).array
    }),
    level: (prop_types_default()).number,
    router: (prop_types_default()).object
};
VerticalNavGroup.defaultProps = {};
var NavVerticalGroup = VerticalNavGroup;
/* harmony default export */ var VerticalNav_VerticalNavGroup = (NavVerticalGroup);

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/components/VerticalNav/index.js








var VerticalNav = function() {
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
        sx: {
            position: "relative",
            padding: 0
        },
        component: "div",
        children: modules_routesConfig.map(function(item) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    item.type === "group" && /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalNav_VerticalNavGroup, {
                        item: item,
                        level: 0,
                        router: router
                    }),
                    item.type === "collapse" && /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalNav_VerticalCollapse, {
                        item: item,
                        level: 0,
                        router: router
                    }),
                    item.type === "item" && /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalNav_VerticalItem, {
                        item: item,
                        level: 0,
                        router: router
                    })
                ]
            }, item.id);
        })
    });
};
/* harmony default export */ var components_VerticalNav = (VerticalNav);

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/components/MainSidebar/SidebarBGWrapper.js







var SidebarBgWrapper = function(param) {
    var children = param.children;
    var ref = (0,SidebarContextProvider/* useSidebarContext */.Sz)(), sidebarBgColor = ref.sidebarBgColor, sidebarTextColor = ref.sidebarTextColor, mode = ref.mode, isSidebarBgImage = ref.isSidebarBgImage, sidebarBgImage = ref.sidebarBgImage;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        sx: {
            position: "relative",
            height: "100%",
            width: "100%",
            overflow: "hidden",
            backgroundColor: sidebarBgColor,
            backgroundImage: isSidebarBgImage ? "url(/assets/images/sidebar/images/".concat(sidebarBgImage, ".png)") : "",
            backgroundRepeat: isSidebarBgImage ? "no-repeat" : "",
            backgroundPosition: isSidebarBgImage ? "center center" : "",
            backgroundSize: isSidebarBgImage ? "cover" : "",
            color: sidebarTextColor,
            boxShadow: "3px 3px 4px rgba(0, 0, 0, 0.04)",
            "&:before": {
                content: '""',
                display: isSidebarBgImage ? "block" : "none",
                position: "absolute",
                left: 0,
                top: 0,
                zIndex: 1,
                width: "100%",
                height: "100%",
                backgroundColor: function(theme) {
                    return mode === AppEnums/* ThemeMode.LIGHT */.hY.LIGHT ? (0,colorManipulator/* alpha */.Fq)(theme.palette.common.white, 0.5) : (0,colorManipulator/* alpha */.Fq)(theme.palette.common.black, 0.5);
                }
            },
            "& > *": {
                position: "relative",
                zIndex: 3
            }
        },
        children: children
    });
};
/* harmony default export */ var SidebarBGWrapper = (SidebarBgWrapper);
SidebarBgWrapper.propTypes = {
    children: (prop_types_default()).node,
    isSidebarBgImage: (prop_types_default()).bool,
    themeMode: (prop_types_default()).string,
    sidebarBgColor: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).number
    ]),
    sidebarBgImage: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).number
    ])
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/components/MainSidebar/SidebarWrapper.js







var SidebarWrapper = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            paddingLeft: 0,
            paddingTop: 0,
            paddingBottom: 0,
            position: {
                xs: "relative",
                lg: "fixed"
            },
            borderRight: function(theme) {
                return "1px solid ".concat(theme.palette.divider);
            },
            top: 0,
            left: 0,
            zIndex: 1101,
            width: 280,
            maxHeight: "100vh",
            height: "100%",
            transition: "all 0.4s ease"
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var MainSidebar_SidebarWrapper = (SidebarWrapper);
SidebarWrapper.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/components/MainSidebar/index.js





var MainSidebar = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainSidebar_SidebarWrapper, {
        className: "app-sidebar",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarBGWrapper, {
            children: children
        })
    });
};
/* harmony default export */ var components_MainSidebar = (MainSidebar);
MainSidebar.propTypes = {
    children: (prop_types_default()).node
};

// EXTERNAL MODULE: ./node_modules/@mui/material/colors/orange.js
var colors_orange = __webpack_require__(92810);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(41720);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ExpandMore.js
var ExpandMore = __webpack_require__(58909);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(54649);
// EXTERNAL MODULE: ./node_modules/@mui/material/Badge/Badge.js + 4 modules
var Badge = __webpack_require__(39369);
// EXTERNAL MODULE: ./src/@common/core/Iconify.js + 1 modules
var Iconify = __webpack_require__(60906);
// EXTERNAL MODULE: ./src/redux/actions/guess/Question.js + 1 modules
var Question = __webpack_require__(28278);
;// CONCATENATED MODULE: ./src/@common/core/AppLayout/components/UserInfo/index.js



// eslint-disable-next-line no-restricted-imports

















var UserInfo = function(param) {
    var color = param.color, isView = param.isView, isHome = param.isHome, isSticky = param.isSticky, isClient = param.isClient;
    var logout = (0,AuthHooks/* useAuthMethod */.a)().logout;
    var dispatch = (0,es/* useDispatch */.I0)();
    var history = (0,next_router.useRouter)();
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), anchorEl = ref[0], setAnchorEl = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isCall = ref1[0], setCall = ref1[1];
    var userInfo = (0,es/* useSelector */.v9)(function(param) {
        var authentication = param.authentication;
        return authentication.user;
    });
    var authentication = (0,es/* useSelector */.v9)(function(param) {
        var authentication = param.authentication;
        return authentication;
    });
    var count = (0,es/* useSelector */.v9)(function(param) {
        var articleApp = param.articleApp;
        return articleApp.countArticleApproval;
    });
    var listBlog = (0,es/* useSelector */.v9)(function(param) {
        var lawDisseminationApp = param.lawDisseminationApp;
        return lawDisseminationApp.listBlog;
    });
    var questionNeedProcessCount = (0,es/* useSelector */.v9)(function(param) {
        var questionApp = param.questionApp;
        return questionApp.questionNeedProcessCount;
    });
    var handleClick = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    var getUserAvatar = function() {
        if (userInfo.hoTen) {
            return userInfo.hoTen.charAt(0).toUpperCase();
        }
        if (userInfo.tenDangNhap) {
            return userInfo.tenDangNhap.charAt(0).toUpperCase();
        }
    };
    (0,react.useEffect)(function() {
        if (!isCall && !isView) {
            if (authentication.isSuperAdmin || userInfo && userInfo.isNhanVien && checkPermissionClient(authentication.permission, AppEnums/* PermissionCode.APPLY */.nn.APPLY, "/admin/tin-bai") && checkPermissionClient(authentication.permission, AppEnums/* PermissionCode.READ */.nn.READ, "/admin/tin-bai")) {
                dispatch((0,actions/* onGetCountApproval */.Uh)());
            }
            if (authentication.isSuperAdmin || userInfo && userInfo.isNhanVien && checkPermissionClient(authentication.permission, AppEnums/* PermissionCode.APPLY */.nn.APPLY, "/admin/cau-hoi")) {
                dispatch((0,Question/* onGetQuestionNeedProcess */.F9)());
            }
            setCall(true);
        }
    }, [
        userInfo,
        authentication
    ]);
    if (!userInfo) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                onClick: handleClick,
                sx: {
                    py: isHome ? 0 : 3,
                    px: 3,
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer"
                },
                className: "user-info-view",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            py: isHome ? 0 : 0.5
                        },
                        children: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.avatarPath) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                            sx: {
                                height: 40,
                                width: 40,
                                fontSize: 24,
                                backgroundColor: colors_orange/* default.500 */.Z[500]
                            },
                            src: userInfo.avatarPath
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                            sx: {
                                height: 40,
                                width: 40,
                                fontSize: 24,
                                backgroundColor: colors_orange/* default.500 */.Z[500]
                            },
                            children: getUserAvatar()
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        sx: {
                            // width: {xs: 'calc(100% - 62px)', xl: 'calc(100% - 72px)'},
                            ml: 4,
                            color: color
                        },
                        className: "user-info",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                sx: {
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        sx: {
                                            mb: 0,
                                            maxWidth: 190,
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            fontSize: 13,
                                            fontWeight: AppEnums/* Fonts.MEDIUM */.F3.MEDIUM,
                                            color: isSticky ? "white" : "inherit"
                                        },
                                        component: "span",
                                        children: userInfo.hoTen
                                    }),
                                    !isView && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        sx: {
                                            ml: 3,
                                            color: isSticky ? "white" : "inherit",
                                            display: "flex"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    mt: -0.5,
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    color: isSticky ? "white" : "inherit"
                                },
                                children: userInfo.maNguoiDung
                            })
                        ]
                    })
                ]
            }),
            !isView && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu_Menu/* default */.Z, {
                id: "simple-menu",
                anchorEl: anchorEl,
                keepMounted: true,
                open: Boolean(anchorEl),
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "right"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "right"
                },
                sx: {
                    boxShadow: function(theme) {
                        return theme.customShadows.z1;
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem_MenuItem/* default */.Z, {
                        onClick: function() {
                            handleClose();
                            history.push("".concat(isClient ? "/thong-tin-tai-khoan" : "/admin/thong-tin-tai-khoan"));
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                icon: "bx:user-circle",
                                height: 24,
                                width: 24,
                                sx: {
                                    mr: 2
                                }
                            }),
                            "Th\xf4ng tin t\xe0i khoản"
                        ]
                    }),
                    listBlog && listBlog.find(function(x) {
                        return x.tenDanhMuc === "PHẢN \xc1NH KIẾN NGHỊ";
                    }) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem_MenuItem/* default */.Z, {
                                onClick: function() {
                                    handleClose();
                                    history.push("/phan-anh/".concat(userInfo.tenDangNhap));
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                        icon: "bxs:comment-error",
                                        height: 24,
                                        width: 24,
                                        sx: {
                                            mr: 2
                                        }
                                    }),
                                    "Phản \xe1nh kiến nghị"
                                ]
                            })
                        ]
                    }),
                    (authentication.isSuperAdmin || userInfo && userInfo.isNhanVien) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem_MenuItem/* default */.Z, {
                                onClick: function() {
                                    return router_default().push("/duyet-tin-bai");
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                        icon: "material-symbols:approval-rounded",
                                        height: 24,
                                        width: 24,
                                        sx: {
                                            mr: 2
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                                        color: "secondary",
                                        badgeContent: count,
                                        children: "Duyệt tin b\xe0i"
                                    })
                                ]
                            })
                        ]
                    }),
                    (authentication.isSuperAdmin || userInfo && userInfo.isNhanVien) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem_MenuItem/* default */.Z, {
                                onClick: function() {
                                    return router_default().push("/hoi-dap/cau-hoi-can-xu-ly");
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                        icon: "mdi:question-answer",
                                        height: 24,
                                        width: 24,
                                        sx: {
                                            mr: 2
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                                        color: "secondary",
                                        badgeContent: questionNeedProcessCount === null || questionNeedProcessCount === void 0 ? void 0 : questionNeedProcessCount.totalCount,
                                        children: "Hỏi đ\xe1p trực tuyến"
                                    })
                                ]
                            })
                        ]
                    }),
                    (authentication.isSuperAdmin || userInfo && userInfo.isNhanVien) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem_MenuItem/* default */.Z, {
                                onClick: function() {
                                    return router_default().push(router_default().asPath.includes("/admin") ? "/" : "/admin");
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                        icon: "ooui:article-redirect-ltr",
                                        height: 24,
                                        width: 24,
                                        sx: {
                                            mr: 2
                                        }
                                    }),
                                    router_default().asPath.includes("/admin") ? "Truy cập trang chủ" : "Truy cập trang admin"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem_MenuItem/* default */.Z, {
                        onClick: logout,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                icon: "uim:signout",
                                height: 24,
                                width: 24,
                                sx: {
                                    mr: 2
                                }
                            }),
                            "Đăng xuất"
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_UserInfo = (/*#__PURE__*/react.memo(UserInfo));
UserInfo.defaultProps = {
    color: "text.secondary",
    isView: false,
    isHome: false,
    isSticky: false,
    isClient: false
};
UserInfo.propTypes = {
    color: (prop_types_default()).string,
    isView: (prop_types_default()).bool,
    isHome: (prop_types_default()).bool,
    isSticky: (prop_types_default()).bool,
    isClient: (prop_types_default()).bool
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/DefaultLayout/AppSidebar.js














var AppSidebar = function(props) {
    var dispatch = (0,es/* useDispatch */.I0)();
    var navCollapsed = (0,es/* useSelector */.v9)(function(param) {
        var settings = param.settings;
        return settings === null || settings === void 0 ? void 0 : settings.navCollapsed;
    });
    var ref = (0,LayoutContextProvider/* useLayoutContext */.l5)(), footer = ref.footer, footerType = ref.footerType;
    var sidebarTextColor = (0,SidebarContextProvider/* useSidebarContext */.Sz)().sidebarTextColor;
    var handleToggleDrawer = function() {
        dispatch((0,actions/* toggleNavCollapsedHide */.Eh)());
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                lgUp: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer_Drawer/* default */.ZP, {
                    anchor: props.position,
                    open: navCollapsed,
                    onClose: function() {
                        return handleToggleDrawer();
                    },
                    classes: {
                        root: (0,clsx_m["default"])(props.variant),
                        paper: (0,clsx_m["default"])(props.variant)
                    },
                    style: {
                        position: "absolute"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_MainSidebar, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UserInfo, {
                                color: sidebarTextColor
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(core_AppScrollbar/* default */.Z, {
                                sx: {
                                    py: 2,
                                    height: "calc(100vh - 70px) !important",
                                    borderTop: function(theme) {
                                        return "solid 1px ".concat(theme.palette.divider);
                                    },
                                    mt: 0.5
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_VerticalNav, {})
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                lgDown: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_MainSidebar, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UserInfo, {
                            color: sidebarTextColor
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(core_AppScrollbar/* default */.Z, {
                            className: (0,clsx_m["default"])({
                                "has-footer-fixed": footer && footerType === "fixed"
                            }),
                            sx: {
                                py: 2,
                                height: "calc(100vh - 70px) !important",
                                borderTop: function(theme) {
                                    return "solid 1px ".concat(theme.palette.divider);
                                },
                                mt: 0.5,
                                "&.has-footer-fixed": {
                                    height: {
                                        xs: "calc(100vh - 117px) !important",
                                        xl: "calc(100vh - 127px) !important"
                                    }
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_VerticalNav, {})
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var DefaultLayout_AppSidebar = (AppSidebar);
AppSidebar.defaultProps = {
    variant: "",
    position: "left"
};
AppSidebar.propTypes = {
    position: (prop_types_default()).string,
    variant: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/DefaultLayout/DefaultLayoutContainer.js







var DefaultLayoutContainer = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            position: "relative",
            backgroundColor: function(theme) {
                return theme.palette.background.default;
            },
            "&.boxedLayout": {
                maxWidth: {
                    xl: 1480
                },
                mx: {
                    xl: "auto"
                },
                boxShadow: "none",
                borderLeft: "1px solid #e8e5dd",
                borderRight: "1px solid #e8e5dd",
                pt: {
                    xl: 0
                },
                "& .app-sidebar": {
                    position: {
                        xl: "sticky"
                    },
                    "& [data-simplebar]": {
                        height: {
                            xl: "calc(100vh - 70px) !important"
                        }
                    }
                },
                "& .appMainFixedHeader": {
                    pt: {
                        xl: 0
                    },
                    "& .app-bar": {
                        position: {
                            xl: "sticky"
                        },
                        width: {
                            xl: "100%"
                        }
                    }
                },
                "& .mainContent": {
                    position: {
                        xl: "static"
                    },
                    ml: {
                        xl: 0
                    }
                },
                "& .fixed-footer": {
                    position: {
                        xl: "sticky"
                    }
                },
                "& .appMainFixedFooter": {
                    pb: {
                        xl: 0
                    }
                }
            },
            "&.framedLayout": {
                padding: {
                    xl: 5
                },
                backgroundColor: function(theme) {
                    return theme.palette.primary.main;
                },
                "& .defaultLayoutWrapper": {
                    borderRadius: {
                        xl: 3
                    }
                },
                "& .app-sidebar": {
                    position: {
                        xl: "sticky"
                    },
                    borderTopLeftRadius: {
                        xl: 12
                    },
                    borderBottomLeftRadius: {
                        xl: 12
                    },
                    overflow: {
                        xl: "hidden"
                    },
                    "& [data-simplebar]": {
                        height: {
                            xl: "calc(100vh - 90px) !important"
                        }
                    }
                },
                "& .app-bar": {
                    borderTopRightRadius: {
                        xl: 12
                    }
                },
                "& .footer": {
                    borderBottomRightRadius: {
                        xl: 12
                    }
                },
                "& .appMainFixedHeader": {
                    pt: {
                        xl: 0
                    },
                    "& .app-bar": {
                        position: {
                            xl: "sticky"
                        },
                        width: {
                            xl: "100%"
                        }
                    }
                },
                "& .mainContent": {
                    position: {
                        xl: "static"
                    },
                    ml: {
                        xl: 0
                    }
                },
                "& .fixed-footer": {
                    position: {
                        xl: "sticky"
                    }
                },
                "& .appMainFixedFooter": {
                    pb: {
                        xl: 0
                    }
                }
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var DefaultLayout_DefaultLayoutContainer = (DefaultLayoutContainer);
DefaultLayoutContainer.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/DefaultLayout/index.js














var DefaultLayout = function(param) {
    var children = param.children;
    var ref = (0,LayoutContextProvider/* useLayoutContext */.l5)(), footer = ref.footer, layoutType = ref.layoutType, headerType = ref.headerType, footerType = ref.footerType;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultLayout_DefaultLayoutContainer, {
        className: (0,clsx_m["default"])({
            boxedLayout: layoutType === AppEnums/* LayoutType.BOXED */.ms.BOXED,
            framedLayout: layoutType === AppEnums/* LayoutType.FRAMED */.ms.FRAMED
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DefaultLayout_DefaultLayoutWrapper, {
            className: (0,clsx_m["default"])("defaultLayoutWrapper", {
                appMainFooter: footer && footerType === "fluid",
                appMainFixedFooter: footer && footerType === "fixed",
                appMainFixedHeader: headerType === "fixed"
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultLayout_AppSidebar, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DefaultLayout_MainContent, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultLayout_AppHeader, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AppContentView/* default */.Z, {
                            children: children
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultLayout_AppFixedFooter, {})
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var AppLayout_DefaultLayout = (DefaultLayout);
DefaultLayout.propTypes = {
    children: (prop_types_default()).node
};

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/NavigateBefore.js
var NavigateBefore = __webpack_require__(69569);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/NavigateNext.js
var NavigateNext = __webpack_require__(74397);
;// CONCATENATED MODULE: ./src/@common/core/AppLayout/BitBucket/AppSidebar/BitBucketSidebarWrapper.js







var BitBucketSidebarWrapper = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            width: 320,
            display: "flex",
            flexDirection: "column",
            position: "relative",
            transition: "all 0.5s ease",
            "& .bit-bucket-sidebar-fixed": {
                display: "flex",
                position: "fixed",
                left: 0,
                top: 0,
                zIndex: 99
            },
            "& .bit-bucket-btn": {
                position: "absolute",
                top: 20,
                right: "-12px",
                borderRadius: "50%",
                backgroundColor: function(theme) {
                    return theme.palette.primary.main;
                },
                color: function(theme) {
                    return theme.palette.primary.contrastText;
                },
                cursor: "pointer",
                zIndex: 99,
                display: {
                    xs: "none",
                    lg: "block"
                },
                "& svg": {
                    display: "block"
                }
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var AppSidebar_BitBucketSidebarWrapper = (BitBucketSidebarWrapper);
BitBucketSidebarWrapper.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/BitBucket/AppSidebar/AppSidebarContainer.js








var AppSidebarContainer = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    var borderColor = (0,SidebarContextProvider/* useSidebarContext */.Sz)().borderColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            pl: 0,
            py: 0,
            transition: "all 0.5s ease",
            width: 256,
            borderLeft: "solid 1px ".concat(borderColor),
            "& .app-sidebar": {
                position: "relative",
                width: "100%",
                zIndex: 1
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var AppSidebar_AppSidebarContainer = (AppSidebarContainer);
AppSidebarContainer.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/BitBucket/AppSidebar/BucketMinibar/BucketMinibarWrapper.js










var BucketMinibarWrapper = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    var ref = (0,SidebarContextProvider/* useSidebarContext */.Sz)(), sidebarBgColor = ref.sidebarBgColor, mode = ref.mode, sidebarTextColor = ref.sidebarTextColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        className: "bucketMinibar",
        sx: {
            width: 64,
            backgroundColor: sidebarBgColor,
            display: "flex",
            flexDirection: "column",
            position: "relative",
            "&:before": {
                content: '""',
                position: "absolute",
                left: 0,
                top: 0,
                zIndex: 1,
                width: "100%",
                height: "100%",
                backgroundColor: function(theme) {
                    return mode === AppEnums/* ThemeMode.LIGHT */.hY.LIGHT ? (0,colorManipulator/* alpha */.Fq)(theme.palette.common.black, 0.05) : (0,colorManipulator/* alpha */.Fq)(theme.palette.common.white, 0.05);
                }
            },
            "& > *": {
                position: "relative",
                zIndex: 3
            },
            "& .logo": {
                cursor: "pointer",
                width: 30
            },
            "& .search-icon-btn": {
                color: sidebarTextColor,
                mb: 2.5,
                width: 40,
                height: 40,
                backgroundColor: "transparent",
                "& svg": {
                    fontSize: 20
                }
            },
            "& .icon-btn": {
                color: sidebarTextColor,
                mb: 2.5,
                border: "0 none",
                backgroundColor: "transparent"
            },
            "& .lang-switcher-btn": {
                mb: 2.5,
                width: 40,
                height: 40,
                border: "0 none",
                color: sidebarTextColor,
                backgroundColor: "transparent"
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var BucketMinibar_BucketMinibarWrapper = (BucketMinibarWrapper);
BucketMinibarWrapper.propTypes = {
    children: (prop_types_default()).node
};

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Search.js
var Search = __webpack_require__(43614);
;// CONCATENATED MODULE: ./src/@common/core/AppLayout/BitBucket/AppSidebar/UserInfo/index.js












var UserInfo_UserInfo = function() {
    var logout = (0,AuthHooks/* useAuthMethod */.a)().logout;
    var user = (0,AuthHooks/* useAuthUser */.f)().user;
    var history = (0,next_router.useRouter)();
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), anchorEl = ref[0], setAnchorEl = ref[1];
    var handleClick = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    var getUserAvatar = function() {
        if (user.displayName) {
            return user.displayName.charAt(0).toUpperCase();
        }
        if (user.email) {
            return user.email.charAt(0).toUpperCase();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        sx: {
            py: 3,
            px: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                onClick: handleClick,
                children: (user === null || user === void 0 ? void 0 : user.photoURL) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                    sx: {
                        height: 30,
                        width: 30,
                        backgroundColor: colors_orange/* default.500 */.Z[500]
                    },
                    src: user.photoURL
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                    sx: {
                        height: 30,
                        width: 30,
                        fontSize: 20,
                        backgroundColor: colors_orange/* default.500 */.Z[500]
                    },
                    children: getUserAvatar()
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu_Menu/* default */.Z, {
                id: "simple-menu",
                anchorEl: anchorEl,
                keepMounted: true,
                open: Boolean(anchorEl),
                onClose: handleClose,
                sx: {
                    py: 4
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem_MenuItem/* default */.Z, {
                        sx: {
                            backgroundColor: function(theme) {
                                return (0,colorManipulator/* alpha */.Fq)(theme.palette.common.black, 0.08);
                            },
                            px: 6,
                            py: 3
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    mr: 3.5
                                },
                                children: (user === null || user === void 0 ? void 0 : user.photoURL) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                    sx: {
                                        height: 40,
                                        width: 40
                                    },
                                    src: user.photoURL
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                    sx: {
                                        height: 40,
                                        width: 40,
                                        fontSize: 20,
                                        backgroundColor: colors_orange/* default.500 */.Z[500]
                                    },
                                    children: getUserAvatar()
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        sx: {
                                            mb: 0,
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            fontSize: 14,
                                            fontWeight: AppEnums/* Fonts.MEDIUM */.F3.MEDIUM
                                        },
                                        component: "span",
                                        children: user.displayName ? user.displayName : "Admin User "
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        sx: {
                                            mt: -0.5,
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            fontSize: 12,
                                            color: function(theme) {
                                                return theme.palette.text.secondary;
                                            }
                                        },
                                        children: "System Manager"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                        onClick: function() {
                            handleClose();
                            history.push("/my-account");
                        },
                        sx: {
                            px: 6,
                            py: 1.5
                        },
                        children: "My account"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                        sx: {
                            px: 6,
                            py: 1.5
                        },
                        onClick: logout,
                        children: "Logout"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var AppSidebar_UserInfo = (UserInfo_UserInfo);

;// CONCATENATED MODULE: ./src/assets/icon/logo.svg
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
  }, props), /*#__PURE__*/react.createElement("path", {
    d: "M87.4 29.8C85.8 14 72.4 1.6 56.1 1.6H45.3c-17.4 0-31.5 14.1-31.5 31.5v27.4h2.1c6.3 0 11.4 5.1 11.4 11.4 0 2.5-.9 4.8-2.3 6.7h4.2c6.3 0 11.4 5.1 11.4 11.4 0 2.6-1 5.1-2.5 7 14.5 4.6 29.3-1.5 29.3-1.5 11.8-4.5 20.2-16 20.2-29.4 0-2.3-1.8-4.1-4.1-4.1H67.3c-2.3 0-4.1 1.8-4.1 4.1 0 3.9-3.2 7.1-7.1 7.1H45.3c-3.9 0-7.1-3.2-7.1-7.1v-33c0-3.9 3.2-7.1 7.1-7.1h6.8c2.1 0 3.8 1.7 3.8 3.8v15c0 3.3 2.2 6.4 5.5 7 4.4.9 8.2-2.5 8.2-6.7v-5.8c0-1.2 1-2.2 2.2-2.2 1.2 0 2.2 1 2.2 2.2v1.2c0 3.3 2.2 6.4 5.5 7 4.4.9 8.2-2.5 8.2-6.7V33.1l-.3-3.3z",
    style: {
      fill: "current"
    }
  }));
};

/* harmony default export */ var logo = (SvgLogo);
;// CONCATENATED MODULE: ./src/@common/core/AppLayout/BitBucket/AppSidebar/BucketMinibar/index.js













var BucketMinibar = function() {
    var theme = (0,ThemeContextProvider/* useThemeContext */.TC)().theme;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BucketMinibar_BucketMinibarWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    py: 1.5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                        sx: {
                            flexDirection: "column",
                            color: "white",
                            mb: 2.5
                        },
                        "aria-label": "show 17 new notifications",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo, {
                            fill: theme.palette.primary.main
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                        className: "search-icon-btn",
                        "aria-label": "show 17 new notifications",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLngSwitcher/* default */.Z, {
                        iconOnly: true,
                        tooltipPosition: "right"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AppNotifications/* default */.Z, {
                        drawerPosition: "left",
                        tooltipPosition: "right",
                        sxNotificationContentStyle: {
                            width: 320
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AppMessages/* default */.Z, {
                        drawerPosition: "left",
                        tooltipPosition: "right",
                        sxMessageContentStyle: {
                            width: 320
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    mt: "auto"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppSidebar_UserInfo, {})
            })
        ]
    });
};
/* harmony default export */ var AppSidebar_BucketMinibar = (BucketMinibar);

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/BitBucket/AppSidebar/index.js



















var AppSidebar_AppSidebar = function(props) {
    var isCollapsed = props.isCollapsed, setCollapsed = props.setCollapsed;
    var dispatch = (0,es/* useDispatch */.I0)();
    var navCollapsed = (0,es/* useSelector */.v9)(function(param) {
        var settings = param.settings;
        return settings.navCollapsed;
    });
    var handleToggleDrawer = function() {
        dispatch((0,actions/* toggleNavCollapsedHide */.Eh)());
    };
    var sideBarComponent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppSidebar_BitBucketSidebarWrapper, {
            className: "bit-bucket-sidebar",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                className: "bit-bucket-sidebar-fixed",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        className: "bit-bucket-btn",
                        onClick: function() {
                            return setCollapsed(!isCollapsed);
                        },
                        children: isCollapsed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigateNext["default"], {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigateBefore["default"], {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AppSidebar_BucketMinibar, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AppSidebar_AppSidebarContainer, {
                        className: "app-sidebar-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_MainSidebar, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                    sx: {
                                        py: 4.5,
                                        px: 7.5
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        sx: {
                                            fontSize: 22,
                                            fontWeight: AppEnums/* Fonts.MEDIUM */.F3.MEDIUM
                                        },
                                        component: "h2",
                                        children: "Crema"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(core_AppScrollbar/* default */.Z, {
                                    sx: {
                                        py: 2,
                                        height: "calc(100vh - 70px) !important"
                                    },
                                    scrollToTop: false,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_VerticalNav, {})
                                })
                            ]
                        })
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                xlUp: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer_Drawer/* default */.ZP, {
                    anchor: props.position,
                    open: navCollapsed,
                    onClose: function() {
                        return handleToggleDrawer();
                    },
                    classes: {
                        root: (0,clsx_m["default"])(props.variant),
                        paper: (0,clsx_m["default"])(props.variant)
                    },
                    style: {
                        position: "absolute"
                    },
                    children: sideBarComponent()
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                lgDown: true,
                children: sideBarComponent()
            })
        ]
    });
};
/* harmony default export */ var BitBucket_AppSidebar = (AppSidebar_AppSidebar);
AppSidebar_AppSidebar.defaultProps = {
    variant: "",
    position: "left"
};
AppSidebar_AppSidebar.propTypes = {
    position: (prop_types_default()).string,
    variant: (prop_types_default()).string,
    isCollapsed: (prop_types_default()).bool,
    setCollapsed: (prop_types_default()).func
};

// EXTERNAL MODULE: ./src/@common/index.js + 23 modules
var _common = __webpack_require__(84247);
;// CONCATENATED MODULE: ./src/@common/core/AppLayout/BitBucket/AppHeader/BitBucketHeaderWrapper.js







var BitBucketHeaderWrapper = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            height: {
                xs: 56,
                sm: 70
            },
            display: "flex",
            alignItems: "center",
            top: 0,
            left: 0,
            right: 0,
            width: "100%",
            position: "fixed",
            px: {
                xs: 5,
                md: 7.5
            },
            zIndex: 999,
            backgroundColor: function(theme) {
                return theme.palette.background.paper;
            },
            "& .menu-btn": {
                mr: 2
            },
            "& .menu-icon": {
                width: 35,
                height: 35
            },
            "& .logo-text": {
                display: {
                    xs: "none",
                    sm: "block"
                }
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var AppHeader_BitBucketHeaderWrapper = (BitBucketHeaderWrapper);
BitBucketHeaderWrapper.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/BitBucket/AppHeader/index.js











var AppHeader_AppHeader = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
        lgUp: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppHeader_BitBucketHeaderWrapper, {
            className: "bit-bucket-header",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                    edge: "start",
                    className: "menu-btn",
                    color: "inherit",
                    "aria-label": "open drawer",
                    onClick: function() {
                        return dispatch((0,actions/* toggleNavCollapsed */.xd)());
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                        className: "menu-icon"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLogo/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        ml: "auto"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppSearchBar/* default */.Z, {
                        borderLight: true,
                        placeholder: "Search…"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var BitBucket_AppHeader = (AppHeader_AppHeader);

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/BitBucket/BitBucketWrapper.js







var BitBucketWrapper = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            flex: 1,
            display: "flex",
            flexDirection: "row",
            position: "relative",
            backgroundColor: function(theme) {
                return theme.palette.background.default;
            },
            paddingTop: {
                xs: 14,
                sm: 17.5,
                lg: 0
            },
            "& .mainContent": {
                display: "flex",
                flexDirection: "column",
                position: "relative",
                width: {
                    xs: "100%",
                    lg: "calc(100% - 320px)"
                },
                transition: "all 0.5s ease"
            },
            "&.bitBucketCollapsed": {
                "& .mainContent": {
                    width: "calc(100% - 64px)"
                },
                "& .bit-bucket-sidebar": {
                    width: 64,
                    "& .app-sidebar-container": {
                        width: 8,
                        borderLeftColor: "transparent"
                    }
                }
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var BitBucket_BitBucketWrapper = (BitBucketWrapper);
BitBucketWrapper.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/BitBucket/BitBucketContainer.js







var BitBucketContainer = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            position: "relative",
            backgroundColor: function(theme) {
                return theme.palette.background.default;
            },
            "&.boxedLayout": {
                maxWidth: {
                    xl: 1480
                },
                mx: {
                    xl: "auto"
                },
                boxShadow: "none",
                borderLeft: "1px solid #e8e5dd",
                borderRight: "1px solid #e8e5dd",
                pt: {
                    xl: 0
                },
                "& .bit-bucket-sidebar": {
                    position: {
                        xl: "sticky"
                    },
                    left: {
                        xl: 0
                    },
                    top: {
                        xl: 0
                    },
                    height: {
                        xl: "100%"
                    },
                    "& [data-simplebar]": {
                        height: {
                            xl: "calc(100vh - 70px) !important"
                        }
                    }
                },
                "& .bit-bucket-sidebar-fixed": {
                    position: {
                        xl: "relative"
                    }
                },
                "& .app-bar": {
                    position: {
                        xl: "sticky"
                    },
                    width: {
                        xl: "100%"
                    }
                },
                "& .mainContent": {
                    position: {
                        xl: "static"
                    }
                },
                "& .fixed-footer": {
                    position: {
                        xl: "sticky"
                    }
                },
                "& .appMainFixedFooter": {
                    pb: {
                        xl: 0
                    }
                }
            },
            "&.framedLayout": {
                padding: {
                    xl: 5
                },
                backgroundColor: function(theme) {
                    return theme.palette.primary.main;
                },
                "& .bitBucketWrapper": {
                    borderRadius: {
                        xl: 3
                    }
                },
                "& .bucketMinibar": {
                    borderTopLeftRadius: {
                        xl: 12
                    },
                    borderBottomLeftRadius: {
                        xl: 12
                    }
                },
                "& .bit-bucket-sidebar": {
                    position: {
                        xl: "sticky"
                    },
                    left: {
                        xl: 0
                    },
                    top: {
                        xl: 0
                    },
                    height: {
                        xl: "100%"
                    },
                    "& [data-simplebar]": {
                        height: {
                            xl: "calc(100vh - 70px) !important"
                        }
                    }
                },
                "& .bit-bucket-sidebar-fixed": {
                    position: {
                        xl: "relative"
                    }
                },
                "& .app-bar": {
                    position: {
                        xl: "sticky"
                    },
                    width: {
                        xl: "100%"
                    }
                },
                "& .mainContent": {
                    position: {
                        xl: "static"
                    }
                },
                "& .fixed-footer": {
                    position: {
                        xl: "sticky"
                    }
                },
                "& .appMainFixedFooter": {
                    pb: {
                        xl: 0
                    }
                }
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var BitBucket_BitBucketContainer = (BitBucketContainer);
BitBucketContainer.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/BitBucket/index.js














var BitBucket = function(param) {
    var children = param.children;
    var ref = (0,react.useState)(false), isCollapsed = ref[0], setCollapsed = ref[1];
    var layoutType = (0,LayoutContextProvider/* useLayoutContext */.l5)().layoutType;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BitBucket_BitBucketContainer, {
        className: (0,clsx_m["default"])({
            boxedLayout: layoutType === AppEnums/* LayoutType.BOXED */.ms.BOXED,
            framedLayout: layoutType === AppEnums/* LayoutType.FRAMED */.ms.FRAMED
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BitBucket_BitBucketWrapper, {
            className: (0,clsx_m["default"])("bitBucketWrapper", {
                bitBucketCollapsed: isCollapsed
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                    lgUp: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BitBucket_AppHeader, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BitBucket_AppSidebar, {
                    isCollapsed: isCollapsed,
                    setCollapsed: setCollapsed
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    className: "mainContent",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(_common/* AppContentView */.PD, {
                        children: children
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var AppLayout_BitBucket = (BitBucket);
BitBucket.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/Standard/AppSidebar/StandardSidebarWrapper.js







var StandardSidebarWrapper = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            width: 280,
            display: "flex",
            flexDirection: "column",
            transition: "all 0.5s ease",
            position: {
                xs: "relative",
                lg: "fixed"
            },
            top: {
                xs: 0,
                lg: 71
            },
            left: 0,
            zIndex: 1101,
            "& .app-sidebar": {
                position: "relative",
                top: "auto",
                left: "auto",
                width: "100%"
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var AppSidebar_StandardSidebarWrapper = (StandardSidebarWrapper);
StandardSidebarWrapper.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/Standard/AppSidebar/index.js















var Standard_AppSidebar_AppSidebar = function(props) {
    var dispatch = (0,es/* useDispatch */.I0)();
    var navCollapsed = (0,es/* useSelector */.v9)(function(param) {
        var settings = param.settings;
        return settings.navCollapsed;
    });
    var ref = (0,LayoutContextProvider/* useLayoutContext */.l5)(), footer = ref.footer, footerType = ref.footerType;
    var sidebarTextColor = (0,SidebarContextProvider/* useSidebarContext */.Sz)().sidebarTextColor;
    var handleToggleDrawer = function() {
        dispatch((0,actions/* toggleNavCollapsedHide */.Eh)());
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                xlUp: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer_Drawer/* default */.ZP, {
                    anchor: props.position,
                    open: navCollapsed,
                    onClose: function() {
                        return handleToggleDrawer();
                    },
                    classes: {
                        root: (0,clsx_m["default"])(props.variant),
                        paper: (0,clsx_m["default"])(props.variant)
                    },
                    style: {
                        position: "absolute"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppSidebar_StandardSidebarWrapper, {
                        className: "standard-sidebar",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_MainSidebar, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UserInfo, {
                                    color: sidebarTextColor
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(core_AppScrollbar/* default */.Z, {
                                    sx: {
                                        py: 2,
                                        height: "calc(100vh - 70px) !important"
                                    },
                                    scrollToTop: false,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_VerticalNav, {})
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                lgDown: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppSidebar_StandardSidebarWrapper, {
                    className: "standard-sidebar",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_MainSidebar, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UserInfo, {
                                color: sidebarTextColor
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(core_AppScrollbar/* default */.Z, {
                                className: (0,clsx_m["default"])({
                                    "has-footer-fixed": footer && footerType === "fixed"
                                }),
                                sx: {
                                    py: 2,
                                    height: "calc(100vh - 141px) !important",
                                    "&.has-footer-fixed": {
                                        height: "calc(100vh - 188px) !important"
                                    }
                                },
                                scrollToTop: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_VerticalNav, {})
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Standard_AppSidebar = (Standard_AppSidebar_AppSidebar);
Standard_AppSidebar_AppSidebar.defaultProps = {
    variant: "",
    position: "left"
};
Standard_AppSidebar_AppSidebar.propTypes = {
    position: (prop_types_default()).string,
    variant: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/Standard/AppHeader/index.js





















var Standard_AppHeader_AppHeader = function() {
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), anchorEl = ref[0], setAnchorEl = ref[1];
    var handleClick = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBar/* default */.Z, {
        color: "inherit",
        sx: {
            boxShadow: "none",
            borderBottom: function(theme) {
                return "1px solid ".concat(theme.palette.divider);
            },
            backgroundColor: "background.paper",
            transition: "width 0.5s ease",
            width: "100%"
        },
        className: "app-bar",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Toolbar/* default */.Z, {
            sx: {
                boxSizing: "border-box",
                minHeight: {
                    xs: 56,
                    sm: 70
                },
                paddingLeft: {
                    xs: 5
                },
                paddingRight: {
                    xs: 5,
                    md: 7.5,
                    xl: 12.5
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                    lgUp: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                        sx: {
                            color: "text.secondary"
                        },
                        edge: "start",
                        className: "menu-btn",
                        color: "inherit",
                        "aria-label": "open drawer",
                        onClick: function() {
                            return dispatch((0,actions/* toggleNavCollapsed */.xd)());
                        },
                        size: "large",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                            sx: {
                                width: 35,
                                height: 35
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        "& .logo-text": {
                            display: {
                                xs: "none",
                                sm: "block"
                            }
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLogo/* default */.Z, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        flexGrow: 1
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        minHeight: 40,
                        position: "relative",
                        "& .searchRoot": {
                            position: {
                                xs: "absolute",
                                sm: "relative"
                            },
                            right: {
                                xs: 0,
                                sm: "auto"
                            },
                            top: {
                                xs: 0,
                                sm: "auto"
                            }
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppSearchBar/* default */.Z, {
                        iconPosition: "right",
                        placeholder: "Search…"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        ml: 4
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLngSwitcher/* default */.Z, {
                        iconOnly: true,
                        tooltipPosition: "bottom"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    sx: {
                        ml: 4
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                            smDown: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                sx: {
                                    position: "relative",
                                    display: "flex",
                                    alignItems: "center",
                                    marginLeft: -2,
                                    marginRight: -2
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        sx: {
                                            px: 1.85
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppNotifications/* default */.Z, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        sx: {
                                            px: 1.85
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppMessages/* default */.Z, {})
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                            smUp: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    position: "relative",
                                    display: "flex",
                                    alignItems: "center",
                                    marginLeft: -2,
                                    marginRight: -2
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                    sx: {
                                        px: 1.85
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppTooltip/* default */.Z, {
                                        title: "More",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                                            sx: {
                                                borderRadius: "50%",
                                                width: 40,
                                                height: 40,
                                                color: function(theme) {
                                                    return theme.palette.text.secondary;
                                                },
                                                backgroundColor: function(theme) {
                                                    return theme.palette.background.default;
                                                },
                                                border: 1,
                                                borderColor: "transparent",
                                                "&:hover, &:focus": {
                                                    color: function(theme) {
                                                        return theme.palette.text.primary;
                                                    },
                                                    backgroundColor: function(theme) {
                                                        return (0,colorManipulator/* alpha */.Fq)(theme.palette.background.default, 0.9);
                                                    },
                                                    borderColor: function(theme) {
                                                        return (0,colorManipulator/* alpha */.Fq)(theme.palette.text.secondary, 0.25);
                                                    }
                                                }
                                            },
                                            onClick: handleClick,
                                            size: "large",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreVert/* default */.Z, {})
                                        })
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu_Menu/* default */.Z, {
                            id: "simple-menu",
                            anchorEl: anchorEl,
                            keepMounted: true,
                            open: Boolean(anchorEl),
                            onClose: handleClose,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppNotifications/* default */.Z, {
                                        isMenu: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppMessages/* default */.Z, {
                                        isMenu: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                    children: "Setting"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Standard_AppHeader = (Standard_AppHeader_AppHeader);

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/Standard/StandardWrapper.js







var StandardWrapper = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            flex: 1,
            display: "flex",
            flexDirection: "column",
            position: "relative",
            backgroundColor: function(theme) {
                return theme.palette.background.default;
            },
            paddingTop: {
                xs: 14,
                sm: 17.5
            },
            "& .mainContent": {
                display: "flex",
                flexDirection: "column",
                position: "relative",
                width: {
                    xs: "100%",
                    lg: "calc(100% - 280px)"
                },
                transition: "all 0.5s ease",
                ml: {
                    lg: "280px"
                }
            },
            "&.appMainFixedFooter": {
                pb: {
                    xs: 12,
                    xl: 14.5
                }
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var Standard_StandardWrapper = (StandardWrapper);
StandardWrapper.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/Standard/AppFixedFooter/FooterWrapper.js








var FooterWrapper_FooterWrapper = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            position: "fixed",
            left: 0,
            bottom: 0,
            width: "100%",
            zIndex: 1102,
            boxShadow: "none",
            border: "1px solid #e8e5dd",
            backgroundColor: function(theme) {
                return theme.palette.background.paper;
            },
            backgroundImage: function(theme) {
                return "linear-gradient(".concat((0,colorManipulator/* alpha */.Fq)(theme.palette.common.white, 0.05), ", ").concat((0,colorManipulator/* alpha */.Fq)(theme.palette.common.white, 0.05), ")");
            },
            color: function(theme) {
                return theme.palette.text.primary;
            },
            margin: "0",
            "& .footerContainer": {
                alignItems: "center",
                flexDirection: "row",
                display: "flex",
                padding: {
                    xs: "5px 20px",
                    md: "5px 32px",
                    xl: "10px 32px"
                }
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var Standard_AppFixedFooter_FooterWrapper = (FooterWrapper_FooterWrapper);
FooterWrapper_FooterWrapper.propTypes = {
    children: (prop_types_default()).node,
    sidebarHeaderColor: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/Standard/AppFixedFooter/index.js





var AppFixedFooter_AppFixedFooter = function() {
    var ref = (0,LayoutContextProvider/* useLayoutContext */.l5)(), footer = ref.footer, footerType = ref.footerType;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: footer && footerType === "fixed" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Standard_AppFixedFooter_FooterWrapper, {
            className: "footer fixed-footer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "footerContainer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    children: "Copy right @3si 2022"
                })
            })
        }) : null
    });
};
/* harmony default export */ var Standard_AppFixedFooter = (AppFixedFooter_AppFixedFooter);

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/Standard/StandardContainer.js







var StandardContainer = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            position: "relative",
            backgroundColor: function(theme) {
                return theme.palette.background.default;
            },
            "&.boxedLayout": {
                maxWidth: {
                    xl: 1480
                },
                mx: {
                    xl: "auto"
                },
                boxShadow: "none",
                borderLeft: "1px solid #e8e5dd",
                borderRight: "1px solid #e8e5dd",
                flexDirection: {
                    xl: "column"
                },
                "& .standardWrapper": {
                    pt: {
                        xl: 0
                    }
                },
                "& .standard-sidebar": {
                    position: {
                        xl: "sticky"
                    },
                    height: {
                        xl: "100%"
                    },
                    "& [data-simplebar]": {
                        height: {
                            xl: "calc(100vh - 141px) !important"
                        }
                    }
                },
                "& .app-bar": {
                    position: {
                        xl: "sticky"
                    },
                    width: {
                        xl: "100%"
                    }
                },
                "& .mainContent": {
                    position: {
                        xl: "static"
                    },
                    ml: {
                        xl: 0
                    },
                    width: {
                        xl: "100%"
                    },
                    flexDirection: {
                        xl: "row"
                    },
                    flexWrap: {
                        xl: "wrap"
                    }
                },
                "& .fixed-footer": {
                    position: {
                        xl: "sticky"
                    }
                },
                "& .appMainFixedFooter": {
                    pb: {
                        xl: 0
                    },
                    "& .standard-sidebar": {
                        "& [data-simplebar]": {
                            height: {
                                xl: "calc(100vh - 188px) !important"
                            }
                        }
                    }
                }
            },
            "&.framedLayout": {
                padding: {
                    xl: 5
                },
                backgroundColor: function(theme) {
                    return theme.palette.primary.main;
                },
                "& .standardWrapper": {
                    borderRadius: {
                        xl: 3
                    },
                    pt: {
                        xl: 0
                    }
                },
                "& .standard-sidebar": {
                    position: {
                        xl: "sticky"
                    },
                    height: {
                        xl: "100%"
                    },
                    borderBottomLeftRadius: {
                        xl: 12
                    },
                    overflow: {
                        xl: "hidden"
                    },
                    "& [data-simplebar]": {
                        height: {
                            xl: "calc(100vh - 161px) !important"
                        }
                    }
                },
                "& .app-bar": {
                    position: {
                        xl: "sticky"
                    },
                    width: {
                        xl: "100%"
                    },
                    borderTopLeftRadius: {
                        xl: 12
                    },
                    borderTopRightRadius: {
                        xl: 12
                    }
                },
                "& .footer": {
                    borderBottomRightRadius: {
                        xl: 12
                    }
                },
                "& .mainContent": {
                    position: {
                        xl: "static"
                    },
                    ml: {
                        xl: 0
                    },
                    width: {
                        xl: "100%"
                    },
                    flexDirection: {
                        xl: "row"
                    },
                    flexWrap: {
                        xl: "wrap"
                    }
                },
                "& .fixed-footer": {
                    position: {
                        xl: "sticky"
                    }
                },
                "& .appMainFixedFooter": {
                    pb: {
                        xl: 0
                    },
                    "& .standard-sidebar": {
                        "& [data-simplebar]": {
                            height: {
                                xl: "calc(100vh - 188px) !important"
                            }
                        }
                    }
                }
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var Standard_StandardContainer = (StandardContainer);
StandardContainer.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/Standard/index.js














var Standard = function(param) {
    var children = param.children;
    var ref = (0,LayoutContextProvider/* useLayoutContext */.l5)(), footer = ref.footer, layoutType = ref.layoutType, footerType = ref.footerType;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Standard_StandardContainer, {
        className: (0,clsx_m["default"])({
            boxedLayout: layoutType === AppEnums/* LayoutType.BOXED */.ms.BOXED,
            framedLayout: layoutType === AppEnums/* LayoutType.FRAMED */.ms.FRAMED
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Standard_StandardWrapper, {
            className: (0,clsx_m["default"])("standardWrapper", {
                appMainFooter: footer && footerType === "fluid",
                appMainFixedFooter: footer && footerType === "fixed"
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Standard_AppHeader, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    className: "mainContent",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Standard_AppSidebar, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(_common/* AppContentView */.PD, {
                            children: children
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Standard_AppFixedFooter, {})
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var AppLayout_Standard = (Standard);
Standard.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/DrawerLayout/AppFixedFooter/FooterWrapper.js








var AppFixedFooter_FooterWrapper_FooterWrapper = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            position: "fixed",
            left: 0,
            bottom: 0,
            width: "100%",
            zIndex: 1102,
            boxShadow: "none",
            border: "1px solid #e8e5dd",
            backgroundColor: function(theme) {
                return theme.palette.background.paper;
            },
            backgroundImage: function(theme) {
                return "linear-gradient(".concat((0,colorManipulator/* alpha */.Fq)(theme.palette.common.white, 0.05), ", ").concat((0,colorManipulator/* alpha */.Fq)(theme.palette.common.white, 0.05), ")");
            },
            color: function(theme) {
                return theme.palette.text.primary;
            },
            margin: "0",
            "& .footerContainer": {
                alignItems: "center",
                flexDirection: "row",
                display: "flex",
                padding: {
                    xs: "5px 20px",
                    md: "5px 32px",
                    xl: "10px 32px"
                }
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var DrawerLayout_AppFixedFooter_FooterWrapper = (AppFixedFooter_FooterWrapper_FooterWrapper);
AppFixedFooter_FooterWrapper_FooterWrapper.propTypes = {
    children: (prop_types_default()).node,
    sidebarHeaderColor: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/DrawerLayout/AppFixedFooter/index.js





var DrawerLayout_AppFixedFooter_AppFixedFooter = function() {
    var ref = (0,LayoutContextProvider/* useLayoutContext */.l5)(), footer = ref.footer, footerType = ref.footerType;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: footer && footerType === "fixed" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DrawerLayout_AppFixedFooter_FooterWrapper, {
            className: "footer fixed-footer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "footerContainer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    children: "Copy right @3si 2022"
                })
            })
        }) : null
    });
};
/* harmony default export */ var DrawerLayout_AppFixedFooter = (DrawerLayout_AppFixedFooter_AppFixedFooter);

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/DrawerLayout/AppHeader/index.js





















var DrawerLayout_AppHeader_AppHeader = function() {
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), anchorEl = ref[0], setAnchorEl = ref[1];
    var handleClick = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBar/* default */.Z, {
        position: "relative",
        color: "inherit",
        sx: {
            boxShadow: "none",
            borderBottom: function(theme) {
                return "solid 1px ".concat(theme.palette.divider);
            },
            backgroundColor: "background.paper",
            width: "100%"
        },
        className: "app-bar",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Toolbar/* default */.Z, {
            sx: {
                boxSizing: "border-box",
                minHeight: {
                    xs: 56,
                    sm: 70
                },
                paddingLeft: {
                    xs: 5
                },
                paddingRight: {
                    xs: 5,
                    md: 7.5
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                    sx: {
                        color: "text.secondary"
                    },
                    edge: "start",
                    className: "menu-btn",
                    color: "inherit",
                    "aria-label": "open drawer",
                    onClick: function() {
                        return dispatch((0,actions/* toggleNavCollapsed */.xd)());
                    },
                    size: "large",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                        sx: {
                            width: 35,
                            height: 35
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        "& .logo-text": {
                            display: {
                                xs: "none",
                                sm: "block"
                            }
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLogo/* default */.Z, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        flexGrow: 1
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        minHeight: 40,
                        position: "relative",
                        "& .searchRoot": {
                            position: {
                                xs: "absolute",
                                sm: "relative"
                            },
                            right: {
                                xs: 0,
                                sm: "auto"
                            },
                            top: {
                                xs: 0,
                                sm: "auto"
                            }
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppSearchBar/* default */.Z, {
                        iconPosition: "right",
                        placeholder: "Search…"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        ml: 4
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLngSwitcher/* default */.Z, {
                        iconOnly: true,
                        tooltipPosition: "bottom"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    sx: {
                        ml: 4
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                            smDown: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                sx: {
                                    position: "relative",
                                    display: "flex",
                                    alignItems: "center",
                                    marginLeft: -2,
                                    marginRight: -2
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        sx: {
                                            px: 1.85
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppNotifications/* default */.Z, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        sx: {
                                            px: 1.85
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppMessages/* default */.Z, {})
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                            smUp: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    position: "relative",
                                    display: "flex",
                                    alignItems: "center",
                                    marginLeft: -2,
                                    marginRight: -2
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                    sx: {
                                        px: 1.85
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppTooltip/* default */.Z, {
                                        title: "More",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                                            sx: {
                                                borderRadius: "50%",
                                                width: 40,
                                                height: 40,
                                                color: function(theme) {
                                                    return theme.palette.text.secondary;
                                                },
                                                backgroundColor: function(theme) {
                                                    return theme.palette.background.default;
                                                },
                                                border: 1,
                                                borderColor: "transparent",
                                                "&:hover, &:focus": {
                                                    color: function(theme) {
                                                        return theme.palette.text.primary;
                                                    },
                                                    backgroundColor: function(theme) {
                                                        return (0,colorManipulator/* alpha */.Fq)(theme.palette.background.default, 0.9);
                                                    },
                                                    borderColor: function(theme) {
                                                        return (0,colorManipulator/* alpha */.Fq)(theme.palette.text.secondary, 0.25);
                                                    }
                                                }
                                            },
                                            onClick: handleClick,
                                            size: "large",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreVert/* default */.Z, {})
                                        })
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu_Menu/* default */.Z, {
                            id: "simple-menu",
                            anchorEl: anchorEl,
                            keepMounted: true,
                            open: Boolean(anchorEl),
                            onClose: handleClose,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppNotifications/* default */.Z, {
                                        isMenu: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppMessages/* default */.Z, {
                                        isMenu: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                    children: "Setting"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var DrawerLayout_AppHeader = (DrawerLayout_AppHeader_AppHeader);

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/DrawerLayout/DrawerLayoutWrapper.js







var DrawerLayoutWrapper = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            flex: 1,
            display: "flex",
            flexDirection: "row",
            position: "relative",
            backgroundColor: function(theme) {
                return theme.palette.background.default;
            },
            "&.appMainFixedFooter": {
                pb: {
                    xs: 12,
                    xl: 14.5
                }
            },
            "&.appMainFixedHeader": {
                pt: {
                    xs: 14,
                    sm: 17.5
                },
                "& .app-bar": {
                    position: "fixed",
                    top: 0,
                    right: 0,
                    zIndex: 9,
                    width: "100%"
                }
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var DrawerLayout_DrawerLayoutWrapper = (DrawerLayoutWrapper);
DrawerLayoutWrapper.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/DrawerLayout/MainContent.js







var MainContent_MainContent = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            flex: 1,
            display: "flex",
            width: "100%",
            flexDirection: "column",
            position: "relative",
            transition: "all 0.5s ease"
        },
        className: "mainContent"
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var DrawerLayout_MainContent = (MainContent_MainContent);
MainContent_MainContent.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/DrawerLayout/AppSidebar/StandardSidebarWrapper.js







var StandardSidebarWrapper_StandardSidebarWrapper = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            width: 280,
            display: "flex",
            flexDirection: "column",
            transition: "all 0.5s ease",
            position: "relative",
            top: 0,
            left: 0,
            zIndex: 1101,
            "& .app-sidebar": {
                position: "relative",
                top: "auto",
                left: "auto",
                width: "100%",
                borderRight: "0 none"
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var DrawerLayout_AppSidebar_StandardSidebarWrapper = (StandardSidebarWrapper_StandardSidebarWrapper);
StandardSidebarWrapper_StandardSidebarWrapper.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/DrawerLayout/AppSidebar/index.js













var DrawerLayout_AppSidebar_AppSidebar = function(props) {
    var dispatch = (0,es/* useDispatch */.I0)();
    var navCollapsed = (0,es/* useSelector */.v9)(function(param) {
        var settings = param.settings;
        return settings.navCollapsed;
    });
    var sidebarTextColor = (0,SidebarContextProvider/* useSidebarContext */.Sz)().sidebarTextColor;
    var handleToggleDrawer = function() {
        dispatch((0,actions/* toggleNavCollapsedHide */.Eh)());
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer_Drawer/* default */.ZP, {
            anchor: props.position,
            open: navCollapsed,
            onClose: function() {
                return handleToggleDrawer();
            },
            classes: {
                root: (0,clsx_m["default"])(props.variant),
                paper: (0,clsx_m["default"])(props.variant)
            },
            style: {
                position: "absolute"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DrawerLayout_AppSidebar_StandardSidebarWrapper, {
                className: "standard-sidebar",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_MainSidebar, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UserInfo, {
                            color: sidebarTextColor
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(core_AppScrollbar/* default */.Z, {
                            sx: {
                                py: 2,
                                height: "calc(100vh - 70px) !important"
                            },
                            scrollToTop: false,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_VerticalNav, {})
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var DrawerLayout_AppSidebar = (DrawerLayout_AppSidebar_AppSidebar);
DrawerLayout_AppSidebar_AppSidebar.defaultProps = {
    variant: "",
    position: "left"
};
DrawerLayout_AppSidebar_AppSidebar.propTypes = {
    position: (prop_types_default()).string,
    variant: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/DrawerLayout/DrawerLayoutContainer.js







var DrawerLayoutContainer = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            position: "relative",
            backgroundColor: function(theme) {
                return theme.palette.background.default;
            },
            "&.boxedLayout": {
                maxWidth: {
                    xl: 1480
                },
                mx: {
                    xl: "auto"
                },
                boxShadow: "none",
                borderLeft: "1px solid #e8e5dd",
                borderRight: "1px solid #e8e5dd",
                "& .appMainFixedHeader": {
                    pt: {
                        xl: 0
                    },
                    "& .app-bar": {
                        position: {
                            xl: "sticky"
                        }
                    }
                },
                "& .mainContent": {
                    position: {
                        xl: "static"
                    }
                },
                "& .fixed-footer": {
                    position: {
                        xl: "sticky"
                    }
                },
                "& .appMainFixedFooter": {
                    pb: {
                        xl: 0
                    }
                }
            },
            "&.framedLayout": {
                padding: {
                    xl: 5
                },
                backgroundColor: function(theme) {
                    return theme.palette.primary.main;
                },
                "& .drawerLayoutWrapper": {
                    borderRadius: {
                        xl: 3
                    }
                },
                "& .app-bar": {
                    borderTopLeftRadius: {
                        xl: 12
                    },
                    borderTopRightRadius: {
                        xl: 12
                    }
                },
                "& .footer": {
                    borderBottomLeftRadius: {
                        xl: 12
                    },
                    borderBottomRightRadius: {
                        xl: 12
                    }
                },
                "& .appMainFixedHeader": {
                    pt: {
                        xl: 0
                    },
                    "& .app-bar": {
                        position: {
                            xl: "sticky"
                        }
                    }
                },
                "& .mainContent": {
                    position: {
                        xl: "static"
                    }
                },
                "& .fixed-footer": {
                    position: {
                        xl: "sticky"
                    }
                },
                "& .appMainFixedFooter": {
                    pb: {
                        xl: 0
                    }
                }
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var DrawerLayout_DrawerLayoutContainer = (DrawerLayoutContainer);
DrawerLayoutContainer.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/DrawerLayout/index.js














var DrawerLayout = function(param) {
    var children = param.children;
    var ref = (0,LayoutContextProvider/* useLayoutContext */.l5)(), footer = ref.footer, layoutType = ref.layoutType, headerType = ref.headerType, footerType = ref.footerType;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DrawerLayout_DrawerLayoutContainer, {
        className: (0,clsx_m["default"])({
            boxedLayout: layoutType === AppEnums/* LayoutType.BOXED */.ms.BOXED,
            framedLayout: layoutType === AppEnums/* LayoutType.FRAMED */.ms.FRAMED
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DrawerLayout_DrawerLayoutWrapper, {
            className: (0,clsx_m["default"])("drawerLayoutWrapper", {
                appMainFooter: footer && footerType === "fluid",
                appMainFixedFooter: footer && footerType === "fixed",
                appMainFixedHeader: headerType === "fixed"
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DrawerLayout_AppSidebar, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DrawerLayout_MainContent, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DrawerLayout_AppHeader, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AppContentView/* default */.Z, {
                            children: children
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DrawerLayout_AppFixedFooter, {})
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var AppLayout_DrawerLayout = (DrawerLayout);
DrawerLayout.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/MiniSidebar/AppSidebar/SidebarWrapper.js







var SidebarWrapper_SidebarWrapper = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            width: 280,
            display: "flex",
            flexDirection: "column",
            transition: "all 0.5s ease",
            position: {
                xs: "relative",
                lg: "fixed"
            },
            top: 0,
            left: 0,
            zIndex: 1101,
            "& .app-sidebar": {
                position: "relative",
                top: "auto",
                left: "auto",
                width: "100%"
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var AppSidebar_SidebarWrapper = (SidebarWrapper_SidebarWrapper);
SidebarWrapper_SidebarWrapper.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/MiniSidebar/AppSidebar/index.js















var MiniSidebar_AppSidebar_AppSidebar = function(props) {
    var dispatch = (0,es/* useDispatch */.I0)();
    var navCollapsed = (0,es/* useSelector */.v9)(function(param) {
        var settings = param.settings;
        return settings.navCollapsed;
    });
    var ref = (0,LayoutContextProvider/* useLayoutContext */.l5)(), footer = ref.footer, footerType = ref.footerType;
    var sidebarTextColor = (0,SidebarContextProvider/* useSidebarContext */.Sz)().sidebarTextColor;
    var handleToggleDrawer = function() {
        dispatch((0,actions/* toggleNavCollapsedHide */.Eh)());
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                xlUp: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer_Drawer/* default */.ZP, {
                    anchor: props.position,
                    open: navCollapsed,
                    onClose: function() {
                        return handleToggleDrawer();
                    },
                    classes: {
                        root: (0,clsx_m["default"])(props.variant),
                        paper: (0,clsx_m["default"])(props.variant)
                    },
                    style: {
                        position: "absolute"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppSidebar_SidebarWrapper, {
                        className: "mini-sidebar",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_MainSidebar, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UserInfo, {
                                    color: sidebarTextColor
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(core_AppScrollbar/* default */.Z, {
                                    sx: {
                                        py: 2,
                                        height: "calc(100vh - 70px) !important"
                                    },
                                    scrollToTop: false,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_VerticalNav, {})
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                lgDown: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppSidebar_SidebarWrapper, {
                    className: "mini-sidebar",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_MainSidebar, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UserInfo, {
                                color: sidebarTextColor
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(core_AppScrollbar/* default */.Z, {
                                className: (0,clsx_m["default"])({
                                    "has-footer-fixed": footer && footerType === "fixed"
                                }),
                                sx: {
                                    py: 2,
                                    height: "calc(100vh - 70px) !important",
                                    "&.has-footer-fixed": {
                                        height: "calc(100vh - 117px) !important"
                                    }
                                },
                                scrollToTop: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_VerticalNav, {})
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var MiniSidebar_AppSidebar = (MiniSidebar_AppSidebar_AppSidebar);
MiniSidebar_AppSidebar_AppSidebar.defaultProps = {
    variant: "",
    position: "left"
};
MiniSidebar_AppSidebar_AppSidebar.propTypes = {
    position: (prop_types_default()).string,
    variant: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/MiniSidebar/AppHeader/index.js






















var MiniSidebar_AppHeader_AppHeader = function(props) {
    var isCollapsed = props.isCollapsed, setCollapsed = props.setCollapsed;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), anchorEl = ref[0], setAnchorEl = ref[1];
    var handleClick = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBar/* default */.Z, {
        position: "relative",
        color: "inherit",
        sx: {
            boxShadow: "none",
            borderBottom: function(theme) {
                return "1px solid ".concat(theme.palette.divider);
            },
            backgroundColor: "background.paper",
            transition: "width 0.5s ease",
            width: "100%"
        },
        className: "app-bar",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Toolbar/* default */.Z, {
            sx: {
                boxSizing: "border-box",
                minHeight: {
                    xs: 56,
                    sm: 70
                },
                paddingLeft: {
                    xs: 5
                },
                paddingRight: {
                    xs: 5,
                    md: 7.5
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                    lgDown: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                        sx: {
                            color: "text.secondary"
                        },
                        edge: "start",
                        className: "menu-btn",
                        color: "inherit",
                        "aria-label": "open drawer",
                        onClick: function() {
                            return setCollapsed(!isCollapsed);
                        },
                        size: "large",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                            sx: {
                                width: 35,
                                height: 35
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                    lgUp: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                        sx: {
                            color: "text.secondary"
                        },
                        edge: "start",
                        className: "menu-btn",
                        color: "inherit",
                        "aria-label": "open drawer",
                        onClick: function() {
                            return dispatch((0,actions/* toggleNavCollapsed */.xd)());
                        },
                        size: "large",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                            sx: {
                                width: 35,
                                height: 35
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        "& .logo-text": {
                            display: {
                                xs: "none",
                                sm: "block"
                            }
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLogo/* default */.Z, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        flexGrow: 1
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        minHeight: 40,
                        position: "relative",
                        "& .searchRoot": {
                            position: {
                                xs: "absolute",
                                sm: "relative"
                            },
                            right: {
                                xs: 0,
                                sm: "auto"
                            },
                            top: {
                                xs: 0,
                                sm: "auto"
                            }
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppSearchBar/* default */.Z, {
                        iconPosition: "right",
                        placeholder: "Search…"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        ml: 4
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLngSwitcher/* default */.Z, {
                        iconOnly: true,
                        tooltipPosition: "bottom"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    sx: {
                        ml: 4
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                            smDown: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                sx: {
                                    position: "relative",
                                    display: "flex",
                                    alignItems: "center",
                                    marginLeft: -2,
                                    marginRight: -2
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        sx: {
                                            px: 1.85
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppNotifications/* default */.Z, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        sx: {
                                            px: 1.85
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppMessages/* default */.Z, {})
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                            smUp: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    position: "relative",
                                    display: "flex",
                                    alignItems: "center",
                                    marginLeft: -2,
                                    marginRight: -2
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                    sx: {
                                        px: 1.85
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppTooltip/* default */.Z, {
                                        title: "More",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                                            sx: {
                                                borderRadius: "50%",
                                                width: 40,
                                                height: 40,
                                                color: function(theme) {
                                                    return theme.palette.text.secondary;
                                                },
                                                backgroundColor: function(theme) {
                                                    return theme.palette.background.default;
                                                },
                                                border: 1,
                                                borderColor: "transparent",
                                                "&:hover, &:focus": {
                                                    color: function(theme) {
                                                        return theme.palette.text.primary;
                                                    },
                                                    backgroundColor: function(theme) {
                                                        return (0,colorManipulator/* alpha */.Fq)(theme.palette.background.default, 0.9);
                                                    },
                                                    borderColor: function(theme) {
                                                        return (0,colorManipulator/* alpha */.Fq)(theme.palette.text.secondary, 0.25);
                                                    }
                                                }
                                            },
                                            onClick: handleClick,
                                            size: "large",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreVert/* default */.Z, {})
                                        })
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu_Menu/* default */.Z, {
                            id: "simple-menu",
                            anchorEl: anchorEl,
                            keepMounted: true,
                            open: Boolean(anchorEl),
                            onClose: handleClose,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppNotifications/* default */.Z, {
                                        isMenu: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppMessages/* default */.Z, {
                                        isMenu: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                    children: "Setting"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var MiniSidebar_AppHeader = (MiniSidebar_AppHeader_AppHeader);
MiniSidebar_AppHeader_AppHeader.propTypes = {
    isCollapsed: (prop_types_default()).bool,
    setCollapsed: (prop_types_default()).func
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/MiniSidebar/MiniSidebarWrapper.js







var MiniSidebarWrapper = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            flex: 1,
            display: "flex",
            flexDirection: "row",
            position: "relative",
            backgroundColor: function(theme) {
                return theme.palette.background.default;
            },
            "& .mainContent": {
                display: "flex",
                flexDirection: "column",
                position: "relative",
                width: {
                    xs: "100%",
                    lg: "calc(100% - 280px)"
                },
                transition: "all 0.5s ease",
                ml: {
                    lg: "280px"
                }
            },
            "&.mini-sidebar-collapsed": {
                "& .mainContent": {
                    width: {
                        lg: "calc(100% - 64px)"
                    },
                    ml: {
                        lg: "64px"
                    }
                },
                "& .mini-sidebar:not(:hover)": {
                    width: {
                        lg: 64
                    },
                    "& .user-info, & .nav-item-header, & .nav-item-content, & .menu-badge, & .collapse-children, & .nav-item-icon-arrow-btn": {
                        display: "none"
                    },
                    "& .nav-item-icon": {
                        mr: 0,
                        ml: 0.5
                    }
                },
                "&.appMainFixedHeader .app-bar": {
                    width: {
                        lg: "calc(100% - 64px)"
                    }
                },
                "& .menu-vertical-item": {
                    pl: 3,
                    "&.rounded-menu": {
                        mx: 2,
                        pl: 3,
                        borderRadius: 1
                    },
                    "&.rounded-menu-reverse": {
                        mx: 2,
                        pl: 3,
                        borderRadius: 1
                    },
                    "&.standard-menu": {
                        mx: 2,
                        width: "calc(100% - 16px)",
                        pl: 3,
                        borderRadius: 1,
                        "&.active:after": {
                            backgroundColor: "transparent"
                        }
                    },
                    "&.curved-menu": {
                        mx: 2,
                        borderRadius: 1,
                        "&:before, &:after": {
                            display: "none"
                        }
                    }
                },
                "& .menu-vertical-collapse": {
                    pl: 3,
                    mx: 2,
                    width: "calc(100% - 16px)"
                }
            },
            "&.appMainFixedFooter": {
                pb: {
                    xs: 12,
                    xl: 14.5
                }
            },
            "&.appMainFixedHeader": {
                pt: {
                    xs: 14,
                    sm: 17.5
                },
                "& .app-bar": {
                    position: "fixed",
                    top: 0,
                    right: 0,
                    zIndex: 9,
                    width: {
                        xs: "100%",
                        lg: "calc(100% - 280px)"
                    }
                }
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var MiniSidebar_MiniSidebarWrapper = (MiniSidebarWrapper);
MiniSidebarWrapper.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/MiniSidebar/AppFixedFooter/FooterWrapper.js








var MiniSidebar_AppFixedFooter_FooterWrapper_FooterWrapper = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            position: "fixed",
            left: 0,
            bottom: 0,
            width: "100%",
            zIndex: 1102,
            boxShadow: "none",
            border: "1px solid #e8e5dd",
            backgroundColor: function(theme) {
                return theme.palette.background.paper;
            },
            backgroundImage: function(theme) {
                return "linear-gradient(".concat((0,colorManipulator/* alpha */.Fq)(theme.palette.common.white, 0.05), ", ").concat((0,colorManipulator/* alpha */.Fq)(theme.palette.common.white, 0.05), ")");
            },
            color: function(theme) {
                return theme.palette.text.primary;
            },
            margin: "0",
            "& .footerContainer": {
                alignItems: "center",
                flexDirection: "row",
                display: "flex",
                padding: {
                    xs: "5px 20px",
                    md: "5px 32px",
                    xl: "10px 32px"
                }
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var MiniSidebar_AppFixedFooter_FooterWrapper = (MiniSidebar_AppFixedFooter_FooterWrapper_FooterWrapper);
MiniSidebar_AppFixedFooter_FooterWrapper_FooterWrapper.propTypes = {
    children: (prop_types_default()).node,
    sidebarHeaderColor: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/MiniSidebar/AppFixedFooter/index.js





var MiniSidebar_AppFixedFooter_AppFixedFooter = function() {
    var ref = (0,LayoutContextProvider/* useLayoutContext */.l5)(), footer = ref.footer, footerType = ref.footerType;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: footer && footerType === "fixed" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniSidebar_AppFixedFooter_FooterWrapper, {
            className: "footer fixed-footer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "footerContainer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    children: "Copy right @3si 2022"
                })
            })
        }) : null
    });
};
/* harmony default export */ var MiniSidebar_AppFixedFooter = (MiniSidebar_AppFixedFooter_AppFixedFooter);

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/MiniSidebar/MiniSidebarContainer.js







var MiniSidebarContainer = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            position: "relative",
            backgroundColor: function(theme) {
                return theme.palette.background.default;
            },
            "&.boxedLayout": {
                maxWidth: {
                    xl: 1480
                },
                mx: {
                    xl: "auto"
                },
                boxShadow: "none",
                borderLeft: "1px solid #e8e5dd",
                borderRight: "1px solid #e8e5dd",
                pt: {
                    xl: 0
                },
                "& .mini-sidebar": {
                    position: {
                        xl: "sticky"
                    },
                    height: {
                        xl: "100%"
                    },
                    "& [data-simplebar]": {
                        height: {
                            xl: "calc(100vh - 70px) !important"
                        }
                    }
                },
                "& .appMainFixedHeader": {
                    pt: {
                        xl: 0
                    },
                    "& .app-bar": {
                        position: {
                            xl: "sticky"
                        },
                        width: {
                            xl: "100%"
                        }
                    }
                },
                "& .mainContent": {
                    position: {
                        xl: "static"
                    },
                    ml: {
                        xl: 0
                    }
                },
                "& .mini-sidebar-collapsed": {
                    "&.appMainFixedHeader": {
                        "& .app-bar": {
                            width: {
                                xl: "100%"
                            }
                        }
                    },
                    "& .mainContent": {
                        width: {
                            xl: "100%"
                        },
                        ml: {
                            xl: 0
                        }
                    }
                },
                "& .fixed-footer": {
                    position: {
                        xl: "sticky"
                    }
                },
                "& .appMainFixedFooter": {
                    pb: {
                        xl: 0
                    }
                }
            },
            "&.framedLayout": {
                padding: {
                    xl: 5
                },
                backgroundColor: function(theme) {
                    return theme.palette.primary.main;
                },
                "& .miniSidebarWrapper": {
                    borderRadius: {
                        xl: 3
                    }
                },
                "& .mini-sidebar": {
                    position: {
                        xl: "sticky"
                    },
                    height: {
                        xl: "100%"
                    },
                    borderTopLeftRadius: {
                        xl: 12
                    },
                    borderBottomLeftRadius: {
                        xl: 12
                    },
                    overflow: {
                        xl: "hidden"
                    },
                    "& [data-simplebar]": {
                        height: {
                            xl: "calc(100vh - 70px) !important"
                        }
                    }
                },
                "& .app-bar": {
                    borderTopRightRadius: {
                        xl: 12
                    }
                },
                "& .footer": {
                    borderBottomRightRadius: {
                        xl: 12
                    }
                },
                "& .appMainFixedHeader": {
                    pt: {
                        xl: 0
                    },
                    "& .app-bar": {
                        position: {
                            xl: "sticky"
                        },
                        width: {
                            xl: "100%"
                        }
                    }
                },
                "& .mainContent": {
                    position: {
                        xl: "static"
                    },
                    ml: {
                        xl: 0
                    }
                },
                "& .mini-sidebar-collapsed": {
                    "&.appMainFixedHeader": {
                        "& .app-bar": {
                            width: {
                                xl: "100%"
                            }
                        }
                    },
                    "& .mainContent": {
                        width: {
                            xl: "100%"
                        },
                        ml: {
                            xl: 0
                        }
                    }
                },
                "& .fixed-footer": {
                    position: {
                        xl: "sticky"
                    }
                },
                "& .appMainFixedFooter": {
                    pb: {
                        xl: 0
                    }
                }
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var MiniSidebar_MiniSidebarContainer = (MiniSidebarContainer);
MiniSidebarContainer.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/MiniSidebar/index.js














var MiniSidebar = function(param) {
    var children = param.children;
    var ref = (0,react.useState)(true), isCollapsed = ref[0], setCollapsed = ref[1];
    var ref1 = (0,LayoutContextProvider/* useLayoutContext */.l5)(), footer = ref1.footer, layoutType = ref1.layoutType, headerType = ref1.headerType, footerType = ref1.footerType;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniSidebar_MiniSidebarContainer, {
        className: (0,clsx_m["default"])({
            boxedLayout: layoutType === AppEnums/* LayoutType.BOXED */.ms.BOXED,
            framedLayout: layoutType === AppEnums/* LayoutType.FRAMED */.ms.FRAMED
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MiniSidebar_MiniSidebarWrapper, {
            className: (0,clsx_m["default"])("miniSidebarWrapper", {
                "mini-sidebar-collapsed": isCollapsed,
                appMainFooter: footer && footerType === "fluid",
                appMainFixedFooter: footer && footerType === "fixed",
                appMainFixedHeader: headerType === "fixed"
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniSidebar_AppSidebar, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    className: "mainContent",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniSidebar_AppHeader, {
                            setCollapsed: setCollapsed,
                            isCollapsed: isCollapsed
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(_common/* AppContentView */.PD, {
                            children: children
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniSidebar_AppFixedFooter, {})
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var AppLayout_MiniSidebar = (MiniSidebar);
MiniSidebar.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/MiniSidebarToggle/AppSidebar/SidebarWrapper.js







var AppSidebar_SidebarWrapper_SidebarWrapper = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            width: 280,
            display: "flex",
            flexDirection: "column",
            transition: "all 0.5s ease",
            position: {
                xs: "relative",
                lg: "fixed"
            },
            top: 0,
            left: 0,
            zIndex: 1101,
            "& .app-sidebar": {
                position: "relative",
                top: "auto",
                left: "auto",
                width: "100%"
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var MiniSidebarToggle_AppSidebar_SidebarWrapper = (AppSidebar_SidebarWrapper_SidebarWrapper);
AppSidebar_SidebarWrapper_SidebarWrapper.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/MiniSidebarToggle/AppTitle/index.js







var AppTitle = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
            sx: {
                py: 3,
                mx: "auto",
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                justifyContent: "center"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    py: 0.5
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/admin",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        style: {
                            all: "unset"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            component: "h3",
                            variant: "h3",
                            sx: {
                                fontWeight: AppEnums/* Fonts.BOLD */.F3.BOLD,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                fontSize: 15,
                                textTransform: "uppercase",
                                color: function(theme) {
                                    return theme.palette.secondary.mauExtension;
                                }
                            },
                            children: "Quản trị hệ thống"
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ var MiniSidebarToggle_AppTitle = (AppTitle);

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/MiniSidebarToggle/AppSidebar/index.js

















var MiniSidebarToggle_AppSidebar_AppSidebar = function(props) {
    var dispatch = (0,es/* useDispatch */.I0)();
    var navCollapsed = (0,es/* useSelector */.v9)(function(param) {
        var settings = param.settings;
        return settings.navCollapsed;
    });
    var ref = (0,LayoutContextProvider/* useLayoutContext */.l5)(), footer = ref.footer, footerType = ref.footerType;
    var sidebarTextColor = (0,SidebarContextProvider/* useSidebarContext */.Sz)().sidebarTextColor;
    var handleToggleDrawer = function() {
        dispatch((0,actions/* toggleNavCollapsedHide */.Eh)());
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                xlUp: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer_Drawer/* default */.ZP, {
                    anchor: props.position,
                    open: navCollapsed,
                    onClose: function() {
                        return handleToggleDrawer();
                    },
                    classes: {
                        root: (0,clsx_m["default"])(props.variant),
                        paper: (0,clsx_m["default"])(props.variant)
                    },
                    style: {
                        position: "absolute"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniSidebarToggle_AppSidebar_SidebarWrapper, {
                        className: "mini-toggle-sidebar",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MainSidebar, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(core_AppScrollbar/* default */.Z, {
                                sx: {
                                    py: 2,
                                    height: "calc(100vh - 70px) !important"
                                },
                                scrollToTop: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_VerticalNav, {})
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                lgDown: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniSidebarToggle_AppSidebar_SidebarWrapper, {
                    className: "mini-toggle-sidebar",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_MainSidebar, {
                        children: [
                            !props.isCollapsed && /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniSidebarToggle_AppTitle, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UserInfo, {
                                color: sidebarTextColor,
                                isView: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(core_AppScrollbar/* default */.Z, {
                                className: (0,clsx_m["default"])({
                                    "has-footer-fixed": footer && footerType === "fixed"
                                }),
                                sx: {
                                    py: 2,
                                    height: props.isCollapsed ? "calc(100vh - 70px) !important" : "calc(100vh - 130px) !important",
                                    "&.has-footer-fixed": {
                                        height: "calc(100vh - 117px) !important"
                                    }
                                },
                                scrollToTop: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_VerticalNav, {})
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var MiniSidebarToggle_AppSidebar = (MiniSidebarToggle_AppSidebar_AppSidebar);
MiniSidebarToggle_AppSidebar_AppSidebar.defaultProps = {
    variant: "",
    position: "left"
};
MiniSidebarToggle_AppSidebar_AppSidebar.propTypes = {
    position: (prop_types_default()).string,
    variant: (prop_types_default()).string,
    isCollapsed: (prop_types_default()).bool
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/MiniSidebarToggle/AppHeader/index.js























var MiniSidebarToggle_AppHeader_AppHeader = function(props) {
    var isCollapsed = props.isCollapsed, setCollapsed = props.setCollapsed;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), anchorEl = ref[0], setAnchorEl = ref[1];
    var handleClick = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBar/* default */.Z, {
        position: "relative",
        color: "inherit",
        sx: {
            boxShadow: "none",
            borderBottom: function(theme) {
                return "1px solid ".concat(theme.palette.divider);
            },
            backgroundColor: "background.paper",
            transition: "width 0.5s ease",
            width: "100%"
        },
        className: "app-bar",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Toolbar/* default */.Z, {
            sx: {
                boxSizing: "border-box",
                minHeight: {
                    xs: 56,
                    sm: 70
                },
                paddingLeft: {
                    xs: 5
                },
                paddingRight: {
                    xs: 5,
                    md: 7.5
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                    lgDown: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                        sx: {
                            color: "text.secondary"
                        },
                        edge: "start",
                        className: "menu-btn",
                        color: "inherit",
                        "aria-label": "open drawer",
                        onClick: function() {
                            return setCollapsed(!isCollapsed);
                        },
                        size: "large",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                            sx: {
                                width: 35,
                                height: 35
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                    lgUp: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                        sx: {
                            color: "text.secondary"
                        },
                        edge: "start",
                        className: "menu-btn",
                        color: "inherit",
                        "aria-label": "open drawer",
                        onClick: function() {
                            return dispatch((0,actions/* toggleNavCollapsed */.xd)());
                        },
                        size: "large",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                            sx: {
                                width: 35,
                                height: 35
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        "& .logo-text": {
                            display: {
                                xs: "none",
                                sm: "block"
                            }
                        }
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        flexGrow: 1
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        minHeight: 40,
                        position: "relative",
                        "& .searchRoot": {
                            position: {
                                xs: "absolute",
                                sm: "relative"
                            },
                            right: {
                                xs: 0,
                                sm: "auto"
                            },
                            top: {
                                xs: 0,
                                sm: "auto"
                            }
                        }
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        ml: 4
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    sx: {
                        ml: 4,
                        display: "flex",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                            smDown: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    position: "relative",
                                    display: "flex",
                                    alignItems: "center",
                                    marginLeft: -2,
                                    marginRight: -2
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                    sx: {
                                        px: 1.85
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                ml: {
                                    sm: 4
                                },
                                mr: {
                                    xs: 4,
                                    sm: 0
                                },
                                minWidth: {
                                    md: 220
                                },
                                "& .user-info-view": {
                                    p: 0
                                },
                                "& .user-info": {
                                    display: {
                                        xs: "none",
                                        md: "block"
                                    }
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UserInfo, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                            smUp: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    position: "relative",
                                    display: "flex",
                                    alignItems: "center",
                                    marginLeft: -2,
                                    marginRight: -2
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                    sx: {
                                        px: 1.85
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppTooltip/* default */.Z, {
                                        title: "More",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                                            sx: {
                                                borderRadius: "50%",
                                                width: 40,
                                                height: 40,
                                                color: function(theme) {
                                                    return theme.palette.text.secondary;
                                                },
                                                backgroundColor: function(theme) {
                                                    return theme.palette.background.default;
                                                },
                                                border: 1,
                                                borderColor: "transparent",
                                                "&:hover, &:focus": {
                                                    color: function(theme) {
                                                        return theme.palette.text.primary;
                                                    },
                                                    backgroundColor: function(theme) {
                                                        return (0,colorManipulator/* alpha */.Fq)(theme.palette.background.default, 0.9);
                                                    },
                                                    borderColor: function(theme) {
                                                        return (0,colorManipulator/* alpha */.Fq)(theme.palette.text.secondary, 0.25);
                                                    }
                                                }
                                            },
                                            onClick: handleClick,
                                            size: "large",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreVert/* default */.Z, {})
                                        })
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu_Menu/* default */.Z, {
                            id: "simple-menu",
                            anchorEl: anchorEl,
                            keepMounted: true,
                            open: Boolean(anchorEl),
                            onClose: handleClose,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppNotifications/* default */.Z, {
                                        isMenu: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                    children: "C\xe0i đặt"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var MiniSidebarToggle_AppHeader = (MiniSidebarToggle_AppHeader_AppHeader);
MiniSidebarToggle_AppHeader_AppHeader.propTypes = {
    isCollapsed: (prop_types_default()).bool,
    setCollapsed: (prop_types_default()).func
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/MiniSidebarToggle/MiniSidebarToggleWrapper.js







var MiniSidebarToggleWrapper = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            flex: 1,
            display: "flex",
            flexDirection: "row",
            position: "relative",
            backgroundColor: function(theme) {
                return theme.palette.background.default;
            },
            "& .mainContent": {
                display: "flex",
                flexDirection: "column",
                position: "relative",
                width: {
                    xs: "100%",
                    lg: "calc(100% - 280px)"
                },
                transition: "all 0.5s ease",
                ml: {
                    lg: "280px"
                }
            },
            "&.mini-sidebar-collapsed": {
                "& .mainContent": {
                    width: {
                        lg: "calc(100% - 64px)"
                    },
                    ml: {
                        lg: "64px"
                    }
                },
                "& .mini-toggle-sidebar:not(:hover)": {
                    width: {
                        lg: 64
                    },
                    "& .user-info, & .nav-item-header, & .nav-item-content, & .menu-badge, & .collapse-children, & .nav-item-icon-arrow-btn": {
                        display: "none"
                    },
                    "& .nav-item-icon": {
                        mr: 0,
                        ml: 0.5
                    }
                },
                "&.appMainFixedHeader .app-bar": {
                    width: {
                        lg: "calc(100% - 64px)"
                    }
                },
                "& .menu-vertical-item": {
                    pl: 3,
                    "&.rounded-menu": {
                        mx: 2,
                        pl: 3,
                        borderRadius: 1
                    },
                    "&.rounded-menu-reverse": {
                        mx: 2,
                        pl: 3,
                        borderRadius: 1
                    },
                    "&.standard-menu": {
                        mx: 2,
                        width: "calc(100% - 16px)",
                        pl: 3,
                        borderRadius: 1,
                        "&.active:after": {
                            backgroundColor: "transparent"
                        }
                    },
                    "&.curved-menu": {
                        mx: 2,
                        borderRadius: 1,
                        "&:before, &:after": {
                            display: "none"
                        }
                    }
                },
                "& .menu-vertical-collapse": {
                    pl: 3,
                    mx: 2,
                    width: "calc(100% - 16px)"
                }
            },
            "&.appMainFixedFooter": {
                pb: {
                    xs: 12,
                    xl: 14.5
                }
            },
            "&.appMainFixedHeader": {
                pt: {
                    xs: 14,
                    sm: 17.5
                },
                "& .app-bar": {
                    position: "fixed",
                    top: 0,
                    right: 0,
                    zIndex: 9,
                    width: {
                        xs: "100%",
                        lg: "calc(100% - 280px)"
                    }
                }
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var MiniSidebarToggle_MiniSidebarToggleWrapper = (MiniSidebarToggleWrapper);
MiniSidebarToggleWrapper.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/MiniSidebarToggle/AppFixedFooter/FooterWrapper.js








var MiniSidebarToggle_AppFixedFooter_FooterWrapper_FooterWrapper = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            position: "fixed",
            left: 0,
            bottom: 0,
            width: "100%",
            zIndex: 1102,
            boxShadow: "none",
            border: "1px solid #e8e5dd",
            backgroundColor: function(theme) {
                return theme.palette.background.paper;
            },
            backgroundImage: function(theme) {
                return "linear-gradient(".concat((0,colorManipulator/* alpha */.Fq)(theme.palette.common.white, 0.05), ", ").concat((0,colorManipulator/* alpha */.Fq)(theme.palette.common.white, 0.05), ")");
            },
            color: function(theme) {
                return theme.palette.text.primary;
            },
            margin: "0",
            "& .footerContainer": {
                alignItems: "center",
                flexDirection: "row",
                display: "flex",
                padding: {
                    xs: "5px 20px",
                    md: "5px 32px",
                    xl: "10px 32px"
                }
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var MiniSidebarToggle_AppFixedFooter_FooterWrapper = (MiniSidebarToggle_AppFixedFooter_FooterWrapper_FooterWrapper);
MiniSidebarToggle_AppFixedFooter_FooterWrapper_FooterWrapper.propTypes = {
    children: (prop_types_default()).node,
    sidebarHeaderColor: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/MiniSidebarToggle/AppFixedFooter/index.js





var MiniSidebarToggle_AppFixedFooter_AppFixedFooter = function() {
    var ref = (0,LayoutContextProvider/* useLayoutContext */.l5)(), footer = ref.footer, footerType = ref.footerType;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: footer && footerType === "fixed" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniSidebarToggle_AppFixedFooter_FooterWrapper, {
            className: "footer fixed-footer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "footerContainer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    children: "Copy right @3si 2022"
                })
            })
        }) : null
    });
};
/* harmony default export */ var MiniSidebarToggle_AppFixedFooter = (MiniSidebarToggle_AppFixedFooter_AppFixedFooter);

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/MiniSidebarToggle/MiniSidebarToggleContainer.js







var MiniSidebarToggleContainer = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            position: "relative",
            backgroundColor: function(theme) {
                return theme.palette.background.default;
            },
            "&.boxedLayout": {
                maxWidth: {
                    xl: 1480
                },
                mx: {
                    xl: "auto"
                },
                boxShadow: "none",
                borderLeft: "1px solid #e8e5dd",
                borderRight: "1px solid #e8e5dd",
                "& .mini-toggle-sidebar": {
                    position: {
                        xl: "sticky"
                    },
                    height: {
                        xl: "100%"
                    },
                    "& [data-simplebar]": {
                        height: {
                            xl: "calc(100vh - 70px) !important"
                        }
                    }
                },
                "& .mini-sidebar-collapsed": {
                    "&.appMainFixedHeader": {
                        "& .app-bar": {
                            width: {
                                xl: "100%"
                            }
                        }
                    },
                    "& .mainContent": {
                        width: {
                            xl: "100%"
                        },
                        ml: {
                            xl: 0
                        }
                    }
                },
                "& .appMainFixedHeader": {
                    pt: {
                        xl: 0
                    },
                    "& .app-bar": {
                        position: {
                            xl: "sticky"
                        },
                        width: {
                            xl: "100%"
                        }
                    }
                },
                "& .mainContent": {
                    position: {
                        xl: "static"
                    },
                    ml: {
                        xl: 0
                    }
                },
                "& .fixed-footer": {
                    position: {
                        xl: "sticky"
                    }
                },
                "& .appMainFixedFooter": {
                    pb: {
                        xl: 0
                    }
                }
            },
            "&.framedLayout": {
                padding: {
                    xl: 5
                },
                backgroundColor: function(theme) {
                    return theme.palette.primary.main;
                },
                "& .miniSidebarToggleWrapper": {
                    borderRadius: {
                        xl: 3
                    }
                },
                "& .mini-toggle-sidebar": {
                    position: {
                        xl: "sticky"
                    },
                    height: {
                        xl: "100%"
                    },
                    borderTopLeftRadius: {
                        xl: 12
                    },
                    borderBottomLeftRadius: {
                        xl: 12
                    },
                    overflow: {
                        xl: "hidden"
                    },
                    "& [data-simplebar]": {
                        height: {
                            xl: "calc(100vh - 70px) !important"
                        }
                    }
                },
                "& .app-bar": {
                    borderTopRightRadius: {
                        xl: 12
                    }
                },
                "& .footer": {
                    borderBottomRightRadius: {
                        xl: 12
                    }
                },
                "& .mini-sidebar-collapsed": {
                    "&.appMainFixedHeader": {
                        "& .app-bar": {
                            width: {
                                xl: "100%"
                            }
                        }
                    },
                    "& .mainContent": {
                        width: {
                            xl: "100%"
                        },
                        ml: {
                            xl: 0
                        }
                    }
                },
                "& .appMainFixedHeader": {
                    pt: {
                        xl: 0
                    },
                    "& .app-bar": {
                        position: {
                            xl: "sticky"
                        },
                        width: {
                            xl: "100%"
                        }
                    }
                },
                "& .mainContent": {
                    position: {
                        xl: "static"
                    },
                    ml: {
                        xl: 0
                    }
                },
                "& .fixed-footer": {
                    position: {
                        xl: "sticky"
                    }
                },
                "& .appMainFixedFooter": {
                    pb: {
                        xl: 0
                    }
                }
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var MiniSidebarToggle_MiniSidebarToggleContainer = (MiniSidebarToggleContainer);
MiniSidebarToggleContainer.propTypes = {
    children: (prop_types_default()).node
};

// EXTERNAL MODULE: ./node_modules/@mui/material/Breadcrumbs/Breadcrumbs.js + 3 modules
var Breadcrumbs = __webpack_require__(73758);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ChevronRightOutlined.js
var ChevronRightOutlined = __webpack_require__(94690);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 1 modules
var Link = __webpack_require__(3518);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Home.js
var Home = __webpack_require__(40867);
;// CONCATENATED MODULE: ./src/@common/core/AppBreadscrum/index.js














var getPathFromUrl = function(url) {
    return url.split(/[?#]/)[0];
};
//Array method
var recursivelyFindKeyValue = function(key, keyValue, list) {
    var depth = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    var results = [];
    for(var i = 0; i < list.length; i++){
        var item = list[i];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.keys(item)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key1 = _step.value;
                //check if its not an array
                if (Array.isArray(item[key1])) {
                    var res = recursivelyFindKeyValue(key1, keyValue, item[key1], depth + 1);
                    results = results.concat(res);
                } else if (item[key1] === keyValue) {
                    //found, return the list
                    //return { found: true, containingArray: list, depth: depth };
                    results.push({
                        found: true,
                        containingArray: list,
                        depth: depth,
                        object: item
                    });
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return results;
};
var AppBreadcrumbs = function(param) {
    var useDefaultStyle = param.useDefaultStyle, rootLabel = param.rootLabel, omitRootLabel = param.omitRootLabel, labelsToUppercase = param.labelsToUppercase, replaceCharacterList = param.replaceCharacterList, transformLabel = param.transformLabel, omitIndexList = param.omitIndexList, containerStyle = param.containerStyle, containerClassName = param.containerClassName, listStyle = param.listStyle, listClassName = param.listClassName, inactiveItemStyle = param.inactiveItemStyle, inactiveItemClassName = param.inactiveItemClassName, activeItemStyle = param.activeItemStyle, activeItemClassName = param.activeItemClassName, separator = param.separator;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(null), AppBreadcrumbs = ref[0], setAppBreadcrumbs = ref[1];
    var messages = (0,useIntl/* default */.Z)().messages;
    var convertBreadcrumb = (0,react.useCallback)(function(title, toUpperCase, replaceCharacterList, transformLabel) {
        var transformedTitle = getPathFromUrl(title);
        if (transformLabel) {
            var res = recursivelyFindKeyValue("id", transformedTitle, modules_routesConfig);
            if (Array.isArray(res) && res.length > 0) {
                return messages[res[0].object.messageId];
            } else if (transformedTitle === "admin") {
                return messages["breadcrumb.admin"];
            }
            return transformLabel(transformedTitle);
        }
        if (replaceCharacterList) {
            for(var i = 0; i < replaceCharacterList.length; i++){
                transformedTitle = transformedTitle.replaceAll(replaceCharacterList[i].from, replaceCharacterList[i].to);
            }
        }
        // decode for utf-8 characters and return ascii.
        return toUpperCase ? decodeURI(transformedTitle).toUpperCase() : decodeURI(transformedTitle);
    }, [
        messages,
        useIntl/* default */.Z
    ]);
    (0,react.useEffect)(function() {
        if (router) {
            var linkPath = router.asPath.split("/");
            linkPath.shift();
            var pathArray = linkPath.map(function(path, i) {
                return {
                    breadcrumb: path,
                    href: "/" + linkPath.slice(0, i + 1).join("/")
                };
            });
            setAppBreadcrumbs(pathArray);
        }
    }, [
        router
    ]);
    if (!AppBreadcrumbs) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        sx: {
            display: "flex",
            p: 2,
            bgcolor: "#ffffff",
            alignItems: "center",
            borderBottom: "1px solid #e8e8e8"
        },
        direction: "row",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumbs/* default */.Z, {
            style: containerStyle,
            className: containerClassName,
            "aria-label": "breadcrumb",
            separator: separator,
            children: [
                !omitRootLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                        color: "inherit",
                        underline: "hover",
                        textTransform: "capitalize",
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Home/* default */.Z, {
                                sx: {
                                    mr: 0.5
                                },
                                fontSize: "medium"
                            }),
                            convertBreadcrumb(rootLabel || "Home", labelsToUppercase, replaceCharacterList, transformLabel)
                        ]
                    })
                }),
                AppBreadcrumbs.length >= 1 && AppBreadcrumbs.map(function(breadcrumb, i) {
                    if (!breadcrumb || breadcrumb.breadcrumb.length === 0 || omitIndexList && omitIndexList.find(function(value) {
                        return value === i;
                    })) {
                        return;
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: breadcrumb.href + "/",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            color: "inherit",
                            underline: "hover",
                            textTransform: "capitalize",
                            sx: {
                                cursor: "pointer"
                            },
                            href: breadcrumb.href,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                color: "primary",
                                textTransform: "capitalize",
                                children: convertBreadcrumb(breadcrumb.breadcrumb, labelsToUppercase, replaceCharacterList, transformLabel)
                            })
                        })
                    }, breadcrumb.href);
                })
            ]
        })
    });
};
AppBreadcrumbs.propTypes = {
    useDefaultStyle: (prop_types_default()).bool,
    rootLabel: (prop_types_default()).string | null,
    omitRootLabel: (prop_types_default()).bool,
    labelsToUppercase: (prop_types_default()).bool,
    replaceCharacterList: (prop_types_default()).array,
    transformLabel: (prop_types_default()).any,
    omitIndexList: (prop_types_default()).array,
    containerStyle: (prop_types_default()).any,
    containerClassName: (prop_types_default()).string,
    listStyle: (prop_types_default()).any,
    listClassName: (prop_types_default()).any,
    inactiveItemStyle: (prop_types_default()).any,
    inactiveItemClassName: (prop_types_default()).string,
    activeItemStyle: (prop_types_default()).any,
    activeItemClassName: (prop_types_default()).string,
    separator: (prop_types_default()).any
};
var defaultProps = {
    useDefaultStyle: false,
    rootLabel: "Home",
    omitRootLabel: false,
    labelsToUppercase: false,
    replaceCharacterList: [
        {
            from: "-",
            to: " "
        }
    ],
    transformLabel: undefined,
    omitIndexList: undefined,
    containerStyle: null,
    containerClassName: "",
    listStyle: null,
    listClassName: "",
    inactiveItemStyle: null,
    inactiveItemClassName: "",
    activeItemStyle: null,
    activeItemClassName: "",
    separator: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRightOutlined/* default */.Z, {})
};
AppBreadcrumbs.defaultProps = defaultProps;
/* harmony default export */ var AppBreadscrum = (AppBreadcrumbs);

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/MiniSidebarToggle/index.js
















var MiniSidebarToggle = function(param) {
    var children = param.children;
    var ref = (0,react.useState)(false), isCollapsed = ref[0], setCollapsed = ref[1];
    var ref1 = (0,LayoutContextProvider/* useLayoutContext */.l5)(), footer = ref1.footer, layoutType = ref1.layoutType, headerType = ref1.headerType, footerType = ref1.footerType, navStyle = ref1.navStyle;
    var messages = (0,useIntl/* default */.Z)().messages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniSidebarToggle_MiniSidebarToggleContainer, {
        className: (0,clsx_m["default"])({
            boxedLayout: layoutType === AppEnums/* LayoutType.BOXED */.ms.BOXED,
            framedLayout: layoutType === AppEnums/* LayoutType.FRAMED */.ms.FRAMED
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MiniSidebarToggle_MiniSidebarToggleWrapper, {
            className: (0,clsx_m["default"])("miniSidebarToggleWrapper", {
                "mini-sidebar-collapsed": isCollapsed,
                appMainFooter: footer && footerType === "fluid",
                appMainFixedFooter: footer && footerType === "fixed",
                appMainFixedHeader: headerType === "fixed"
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniSidebarToggle_AppSidebar, {
                    isCollapsed: isCollapsed
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    className: "mainContent",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniSidebarToggle_AppHeader, {
                            setCollapsed: setCollapsed,
                            isCollapsed: isCollapsed
                        }),
                        navStyle === AppEnums/* NavStyle.H_DEFAULT */.Dt.H_DEFAULT ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBreadscrum, {
                            rootLabel: messages["breadcrumb.home"],
                            transformLabel: function(title) {
                                return title.charAt(0).toUpperCase() + title.slice(1);
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(_common/* AppContentView */.PD, {
                            children: children
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniSidebarToggle_AppFixedFooter, {})
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var AppLayout_MiniSidebarToggle = (MiniSidebarToggle);
MiniSidebarToggle.propTypes = {
    children: (prop_types_default()).node
};

// EXTERNAL MODULE: ./src/@common/core/AppLayout/HorDefault/AppFixedFooter/index.js + 2 modules
var HorDefault_AppFixedFooter = __webpack_require__(13704);
;// CONCATENATED MODULE: ./src/@common/core/AppLayout/HorDefault/AppHeader/HeaderNavWrapper.js






var HeaderNavWrapper = function(param) {
    var children = param.children;
    var ref = (0,SidebarContextProvider/* useSidebarContext */.Sz)(), sidebarBgColor = ref.sidebarBgColor, sidebarTextColor = ref.sidebarTextColor, sidebarMenuSelectedBgColor = ref.sidebarMenuSelectedBgColor, sidebarMenuSelectedTextColor = ref.sidebarMenuSelectedTextColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        sx: {
            backgroundColor: sidebarBgColor,
            color: sidebarTextColor,
            py: 1,
            "& .navbarNav": {
                display: "flex",
                padding: 0,
                justifyContent: "center",
                alignItems: "center"
            },
            "& .navItem": {
                width: "auto",
                cursor: "pointer",
                py: 1,
                px: {
                    xs: 4,
                    lg: 5
                },
                borderRadius: 1,
                "&.active": {
                    color: sidebarMenuSelectedTextColor,
                    backgroundColor: (0,colorManipulator/* alpha */.Fq)(sidebarMenuSelectedBgColor, 0.8),
                    "& .navLinkIcon": {
                        color: function(theme) {
                            return theme.palette.secondary.main;
                        }
                    }
                }
            },
            "& .navLinkIcon": {
                mr: 2.5,
                color: sidebarMenuSelectedTextColor,
                fontSize: 20
            }
        },
        children: children
    });
};
/* harmony default export */ var AppHeader_HeaderNavWrapper = (HeaderNavWrapper);
HeaderNavWrapper.propTypes = {
    children: (prop_types_default()).node
};

// EXTERNAL MODULE: ./node_modules/react-popper/lib/esm/Manager.js
var Manager = __webpack_require__(81385);
// EXTERNAL MODULE: ./node_modules/react-popper/lib/esm/Reference.js
var Reference = __webpack_require__(63351);
// EXTERNAL MODULE: ./node_modules/react-popper/lib/esm/Popper.js + 55 modules
var Popper = __webpack_require__(70614);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./src/@common/core/AppLayout/components/HorizontalNav/HorizontalItem.js

















function HorizontalItem(props) {
    var item = props.item, dense = props.dense;
    var ref = (0,next_router.useRouter)(), pathname = ref.pathname, asPath = ref.asPath;
    var dispatch = (0,es/* useDispatch */.I0)();
    var active = isUrlInChildren(item, pathname);
    var ref1 = (0,SidebarContextProvider/* useSidebarContext */.Sz)(), sidebarMenuSelectedBgColor = ref1.sidebarMenuSelectedBgColor, sidebarMenuSelectedTextColor = ref1.sidebarMenuSelectedTextColor;
    var breadcrumbs = (0,es/* useSelector */.v9)(function(param) {
        var common = param.common;
        return common.breadcrumbs;
    });
    function isUrlInChildren(parent, url) {
        if (!parent.children) {
            return false;
        }
        for(var i = 0; i < parent.children.length; i++){
            if (parent.children[i].children) {
                if (isUrlInChildren(parent.children[i], url)) {
                    return true;
                }
            }
            if (parent.children[i].url === url || url.includes(parent.children[i].url)) {
                return true;
            }
        }
        return false;
    }
    var isActiveArticle = function() {
        if (asPath.includes("/bai-viet/")) {
            if (Array.isArray(breadcrumbs) && breadcrumbs.length > 0) {
                var result = breadcrumbs.filter(function(x) {
                    return x.slug === item.originSlug;
                });
                if (result.length > 0) {
                    return true;
                }
            }
        }
        return false;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: item.url,
        as: item.as,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            style: {
                all: "unset"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.ZP, {
                className: (0,clsx_m["default"])("navItemSubmenu", dense && "dense", {
                    active: item.url === asPath || isActiveArticle()
                }),
                button: true,
                exact: item.exact,
                sx: {
                    cursor: "pointer",
                    minHeight: 40,
                    padding: "4px 12px",
                    color: function(theme) {
                        return theme.palette.text.primary;
                    },
                    textDecoration: "none!important",
                    minWidth: 160,
                    "&.active, &.active:hover, &.active:focus": {
                        backgroundColor: sidebarMenuSelectedBgColor + "!important",
                        color: sidebarMenuSelectedTextColor + "!important"
                    },
                    "&.active": {
                        backgroundColor: sidebarMenuSelectedBgColor,
                        color: sidebarMenuSelectedTextColor + "!important",
                        pointerEvents: "none",
                        "& .list-item-text-primary": {
                            color: "inherit"
                        },
                        "& .list-item-icon": {
                            color: "inherit"
                        }
                    },
                    "& .list-item-text": {
                        padding: "0 0 0 16px"
                    },
                    "&.dense": {
                        padding: "4px 12px",
                        minHeight: 40,
                        "& .list-item-text": {
                            padding: "0 0 0 8px"
                        }
                    }
                },
                children: [
                    item.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                        sx: {
                            color: active ? sidebarMenuSelectedTextColor : "action",
                            mr: 3,
                            fontSize: {
                                xs: 16,
                                xl: 18
                            }
                        },
                        children: item.icon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                        className: "AppNavLinkTextSubmenu",
                        // primary={<IntlMessages id={item.messageId} />}
                        primary: item.title,
                        primaryTypographyProps: {
                            fontWeight: AppEnums/* Fonts.BOLD */.F3.BOLD
                        }
                    }),
                    item.count && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        ml: 4,
                        clone: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                            count: item.count,
                            sx: {
                                color: item.color
                            }
                        })
                    })
                ]
            })
        })
    });
}
HorizontalItem.defaultProps = {};
/* harmony default export */ var HorizontalNav_HorizontalItem = ((0,next_router.withRouter)(/*#__PURE__*/ react.memo(HorizontalItem)));
HorizontalItem.propTypes = {
    item: (prop_types_default()).object,
    dense: (prop_types_default()).bool,
    router: (prop_types_default()).object
};

// EXTERNAL MODULE: ./node_modules/@mui/material/Grow/Grow.js
var Grow = __webpack_require__(98600);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(31626);
;// CONCATENATED MODULE: ./src/@common/core/AppLayout/components/HorizontalNav/HorizontalCollapse.js
























function HorizontalCollapse(props) {
    var ref = (0,react.useState)(false), opened = ref[0], setOpened = ref[1];
    var theme = (0,ThemeContextProvider/* useThemeContext */.TC)().theme;
    var ref1 = (0,next_router.useRouter)(), pathname = ref1.pathname, asPath = ref1.asPath;
    var item = props.item, nestedLevel = props.nestedLevel, dense = props.dense;
    var active = isUrlInChildren(item, asPath);
    var ref2 = (0,SidebarContextProvider/* useSidebarContext */.Sz)(), sidebarMenuSelectedBgColor = ref2.sidebarMenuSelectedBgColor, sidebarMenuSelectedTextColor = ref2.sidebarMenuSelectedTextColor;
    var breadcrumbs = (0,es/* useSelector */.v9)(function(param) {
        var common = param.common;
        return common.breadcrumbs;
    });
    var handleToggle = function(open) {
        setOpened(open);
    };
    function isUrlInChildren(parent, url) {
        if (!parent.children) {
            return false;
        }
        for(var i = 0; i < parent.children.length; i++){
            if (parent.children[i].children) {
                if (isUrlInChildren(parent.children[i], url)) {
                    return true;
                }
            }
            if (parent.children[i].url === url || url.includes(parent.children[i].url)) {
                return true;
            }
        }
        return false;
    }
    var isActiveArticle = function() {
        if (asPath.includes("/bai-viet/")) {
            if (Array.isArray(breadcrumbs) && breadcrumbs.length > 0) {
                var result = breadcrumbs.filter(function(x) {
                    return x.slug === item.originSlug;
                });
                if (result.length > 0) {
                    return true;
                }
            }
        }
        return false;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
        sx: {
            py: 0,
            "& .list-item-text": {
                padding: "0 0 0 16px"
            }
        },
        className: "navbarNavSubmenu",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Manager/* Manager */.dK, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Reference/* Reference */.s, {
                    children: function(param) {
                        var ref = param.ref;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.ZP, {
                            ref: ref,
                            button: true,
                            sx: {
                                color: theme.palette.text.primary,
                                padding: "0px 12px",
                                "&.active, &.active:hover, &.active:focus": {
                                    backgroundColor: sidebarMenuSelectedBgColor + "!important",
                                    color: sidebarMenuSelectedTextColor + "!important"
                                },
                                "&.open": {
                                    backgroundColor: "rgba(0,0,0,.08)"
                                },
                                "&.dense": {
                                    padding: "0px 12px",
                                    "& .list-item-text": {
                                        padding: "0 0 0 8px"
                                    }
                                }
                            },
                            className: (0,clsx_m["default"])("navItemSubmenu", opened && "open", dense && "dense", (active || isActiveArticle()) && "active"),
                            onMouseEnter: function() {
                                return handleToggle(true);
                            },
                            onMouseLeave: function() {
                                return handleToggle(false);
                            },
                            "aria-owns": opened ? "menu-list-grow" : null,
                            "aria-haspopup": "true",
                            children: [
                                item.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                    sx: {
                                        color: active ? sidebarMenuSelectedTextColor : "action",
                                        mr: 3.5,
                                        fontSize: {
                                            xs: 16,
                                            xl: 18
                                        }
                                    },
                                    children: item.icon
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: item.url,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        style: {
                                            all: "unset",
                                            display: "flex",
                                            alignItems: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                                className: "navLinkTextSubmenu",
                                                // primary={<IntlMessages id={item.messageId} />}
                                                primary: item.title,
                                                primaryTypographyProps: {
                                                    fontWeight: AppEnums/* Fonts.BOLD */.F3.BOLD
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                                p: 0,
                                                clone: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                                                    disableRipple: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                        sx: {
                                                            color: active || isActiveArticle() ? sidebarMenuSelectedTextColor : "action"
                                                        },
                                                        children: theme.direction === "ltr" ? "chevron_right" : "chevron_left"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        });
                    }
                }),
                /*#__PURE__*/ react_dom.createPortal(/*#__PURE__*/ (0,jsx_runtime.jsx)(Popper/* Popper */.r, {
                    placement: "right",
                    eventsEnabled: opened,
                    positionFixed: true,
                    children: function(param) {
                        var ref = param.ref, style = param.style, placement = param.placement;
                        return opened && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            ref: ref,
                            sx: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                boxShadow: "0 0 3px 0 rgba(0, 0, 0, 0.2)",
                                zIndex: 1110 + nestedLevel + 1
                            }, style), {
                                "& .popperClose": {
                                    pointerEvents: "none"
                                }
                            }),
                            "data-placement": placement,
                            className: (0,clsx_m["default"])({
                                popperClose: !opened
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grow/* default */.Z, {
                                in: opened,
                                id: "menu-list-grow",
                                sx: {
                                    transformOrigin: "0 0 0"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* default */.Z, {
                                    onMouseEnter: function() {
                                        return handleToggle(true);
                                    },
                                    onMouseLeave: function() {
                                        return handleToggle(false);
                                    },
                                    children: item.children && /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                                        sx: {
                                            px: 0
                                        },
                                        children: item.children.map(function(item) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                children: [
                                                    item.type === "group" && /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalNav_HorizontalGroup, {
                                                        item: item,
                                                        nestedLevel: nestedLevel + 1
                                                    }),
                                                    item.type === "collapse" && /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalCollapse, {
                                                        item: item,
                                                        nestedLevel: nestedLevel + 1
                                                    }),
                                                    item.type === "item" && /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalNav_HorizontalItem, {
                                                        item: item,
                                                        nestedLevel: nestedLevel + 1
                                                    })
                                                ]
                                            }, item.id);
                                        })
                                    })
                                })
                            })
                        });
                    }
                }), document.querySelector("#root"))
            ]
        })
    });
}
/* harmony default export */ var HorizontalNav_HorizontalCollapse = (/*#__PURE__*/react.memo(HorizontalCollapse));
HorizontalCollapse.propTypes = {
    item: (prop_types_default()).object,
    nestedLevel: (prop_types_default()).number,
    dense: (prop_types_default()).number
};
HorizontalCollapse.defaultProps = {};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/components/HorizontalNav/HorizontalGroup.js























function HorizontalGroup(props) {
    var ref = (0,react.useState)(false), opened = ref[0], setOpened = ref[1];
    var ref1 = (0,next_router.useRouter)(), pathname = ref1.pathname, asPath = ref1.asPath;
    var item = props.item, nestedLevel = props.nestedLevel;
    var dispatch = (0,es/* useDispatch */.I0)();
    var breadcrumbs = (0,es/* useSelector */.v9)(function(param) {
        var common = param.common;
        return common.breadcrumbs;
    });
    var handleToggle = function(open) {
        setOpened(open);
    };
    function isUrlInChildren(parent, url) {
        if (!parent.children) {
            return false;
        }
        for(var i = 0; i < parent.children.length; i++){
            if (parent.children[i].children) {
                if (isUrlInChildren(parent.children[i], url)) {
                    return true;
                }
            }
            if (parent.children[i].url === url || url.includes(parent.children[i].url)) {
                return true;
            }
        }
        return false;
    }
    var isActiveArticle = function() {
        if (asPath.includes("/bai-viet/")) {
            if (Array.isArray(breadcrumbs) && breadcrumbs.length > 0) {
                var result = breadcrumbs.filter(function(x) {
                    return x.slug === item.originSlug;
                });
                if (result.length > 0) {
                    return true;
                }
            }
        }
        return false;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Manager/* Manager */.dK, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Reference/* Reference */.s, {
                children: function(param) {
                    var ref = param.ref;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: item.url,
                        as: item.as,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            style: {
                                all: "unset"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                                ref: ref,
                                className: (0,clsx_m["default"])("navItem", (item.url === "/" ? item.url === asPath : asPath.includes(item.url) || isActiveArticle()) && "active"),
                                onMouseEnter: function() {
                                    return handleToggle(true);
                                },
                                onMouseLeave: function() {
                                    return handleToggle(false);
                                },
                                "aria-owns": opened ? "menu-list-grow" : null,
                                "aria-haspopup": "true",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                    sx: {
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    },
                                    children: [
                                        item.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                            color: "action",
                                            className: "navLinkIcon",
                                            children: item.icon
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                            // primary={<IntlMessages id={item.messageId} />}
                                            primary: item.title,
                                            primaryTypographyProps: {
                                                fontWeight: AppEnums/* Fonts.BOLD */.F3.BOLD,
                                                fontSize: 12
                                            }
                                        })
                                    ]
                                }, item.id)
                            })
                        })
                    });
                }
            }),
            /*#__PURE__*/ react_dom.createPortal(/*#__PURE__*/ (0,jsx_runtime.jsx)(Popper/* Popper */.r, {
                placement: nestedLevel === 0 ? "bottom-start" : "right",
                eventsEnabled: opened,
                positionFixed: true,
                children: function(param) {
                    var ref = param.ref, style = param.style, placement = param.placement;
                    return opened && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        ref: ref,
                        sx: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, style), {
                            boxShadow: "0 0 3px 0 rgba(0, 0, 0, 0.2)",
                            zIndex: 1110 + nestedLevel,
                            "& .popperClose": {
                                pointerEvents: "none"
                            }
                        }),
                        "data-placement": placement,
                        className: (0,clsx_m["default"])({
                            popperClose: !opened
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grow/* default */.Z, {
                            in: opened,
                            id: "menu-list-grow",
                            style: {
                                transformOrigin: "0 0 0"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* default */.Z, {
                                onMouseEnter: function() {
                                    return handleToggle(true);
                                },
                                onMouseLeave: function() {
                                    return handleToggle(false);
                                },
                                children: item.children && /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                                    sx: {
                                        px: 0
                                    },
                                    children: item.children.map(function(item) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                            children: [
                                                item.type === "group" && /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalGroup, {
                                                    item: item,
                                                    nestedLevel: nestedLevel
                                                }),
                                                item.type === "collapse" && /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalNav_HorizontalCollapse, {
                                                    item: item,
                                                    nestedLevel: nestedLevel
                                                }),
                                                item.type === "item" && /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalNav_HorizontalItem, {
                                                    item: item,
                                                    nestedLevel: nestedLevel
                                                })
                                            ]
                                        }, item.id);
                                    })
                                })
                            })
                        })
                    });
                }
            }), document.querySelector("#root"))
        ]
    });
}
HorizontalGroup.propTypes = {
    item: (prop_types_default()).object,
    nestedLevel: (prop_types_default()).number
};
HorizontalGroup.defaultProps = {};
/* harmony default export */ var HorizontalNav_HorizontalGroup = (/*#__PURE__*/react.memo(HorizontalGroup));

// EXTERNAL MODULE: ./node_modules/react-content-loader/dist/react-content-loader.es.js
var react_content_loader_es = __webpack_require__(24561);
;// CONCATENATED MODULE: ./src/@common/core/AppSkeleton/MenuHomeSkeleton.js





var MenuItemSkeleton = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_content_loader_es/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        speed: 1,
        width: 200,
        height: 40,
        viewBox: "0 0 200 40"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "9",
                y: "4",
                rx: "0",
                ry: "0",
                width: "320",
                height: "22"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "18",
                y: "14",
                rx: "0",
                ry: "0",
                width: "303",
                height: "6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "11",
                y: "33",
                rx: "0",
                ry: "0",
                width: "108",
                height: "13"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "129",
                y: "33",
                rx: "0",
                ry: "0",
                width: "60",
                height: "13"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "196",
                y: "33",
                rx: "0",
                ry: "0",
                width: "60",
                height: "13"
            })
        ]
    }));
};
var MenuHomeSkeleton = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItemSkeleton, (0,src_object_spread/* default */.Z)({}, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItemSkeleton, (0,src_object_spread/* default */.Z)({}, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItemSkeleton, (0,src_object_spread/* default */.Z)({}, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItemSkeleton, (0,src_object_spread/* default */.Z)({}, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItemSkeleton, (0,src_object_spread/* default */.Z)({}, props))
        ]
    });
};
/* harmony default export */ var AppSkeleton_MenuHomeSkeleton = (MenuHomeSkeleton);

// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var ai_index_esm = __webpack_require__(8193);
// EXTERNAL MODULE: ./src/@common/core/AppMuiImage/index.js + 1 modules
var AppMuiImage = __webpack_require__(29220);
;// CONCATENATED MODULE: ./src/@common/core/AppLayout/components/HorizontalNav/index.js













var HorizontalNav = function(param) {
    var visible = param.visible;
    var dataFooter = (0,es/* useSelector */.v9)(function(param) {
        var customerApp = param.customerApp;
        return customerApp.dataFooter;
    });
    var dataRouteHome = (0,es/* useSelector */.v9)(function(param) {
        var categoryApp = param.categoryApp;
        return categoryApp.treeCategories.data;
    });
    var categoryHome = {
        id: 1,
        title: "TRANG CHỦ",
        messageId: "sidebar",
        type: "group",
        url: "/",
        children: null,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ai_index_esm/* AiFillHome */.V9Z, {})
    };
    if (!dataRouteHome) return /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
        className: "navbarNav",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppSkeleton_MenuHomeSkeleton, {})
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* default */.Z, {
        className: "navbarNav",
        children: [
            !!visible && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    px: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppMuiImage/* default */.Z, {
                    fit: "contain",
                    src: dataFooter.logoFilePath,
                    height: 32,
                    width: 40
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalNav_HorizontalGroup, {
                item: categoryHome,
                nestedLevel: 0
            }),
            dataRouteHome.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        item.type === "group" && /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalNav_HorizontalGroup, {
                            item: item,
                            nestedLevel: 0
                        }),
                        item.type === "collapse" && /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalNav_HorizontalCollapse, {
                            item: item,
                            nestedLevel: 0
                        }),
                        item.type === "item" && /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalNav_HorizontalItem, {
                            item: item,
                            nestedLevel: 0
                        }),
                        item.type === "divider" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                            sx: {
                                my: 5
                            }
                        })
                    ]
                }, item.id);
            })
        ]
    });
};
HorizontalNav.propTypes = {
    visible: (prop_types_default()).bool
};
/* harmony default export */ var components_HorizontalNav = (HorizontalNav);

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/HorDefault/AppHeader/index.js












var HorDefault_AppHeader_AppHeader = function() {
    var top = 260;
    var updateSidebarColorSet = (0,SidebarContextProvider/* useSidebarActionsContext */.Lf)().updateSidebarColorSet;
    var ref = (0,react.useState)(false), visible = ref[0], setVisible = ref[1];
    var layoutClient = (0,es/* useSelector */.v9)(function(param) {
        var layoutClientApp = param.layoutClientApp;
        return layoutClientApp.layoutClientList;
    });
    (0,react.useEffect)(function() {
        var onScroll = function() {
            if (document.documentElement.scrollTop >= top) updateSidebarColorSet(defaultConfig/* LightSidebarSticky */.Ar);
            else updateSidebarColorSet(defaultConfig/* default.sidebar.colorSet */.ZP.sidebar.colorSet);
            setVisible(document.documentElement.scrollTop >= top);
        };
        onScroll();
        document.addEventListener("scroll", onScroll);
        return function() {
            return document.removeEventListener("scroll", onScroll);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBar/* default */.Z, {
                color: "inherit",
                position: "relative",
                sx: {
                    boxShadow: "none",
                    // borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
                    backgroundColor: "background.default",
                    width: {
                        xs: "100%"
                    },
                    filter: Array.isArray(layoutClient) && layoutClient.length > 0 && layoutClient.filter(function(x) {
                        return x.sectionName === AppEnums/* ElementSection.GRAYBACKGROUND */.Pw.GRAYBACKGROUND && x.isDisplay;
                    }).length > 0 ? "grayscale(100%)" : "unset"
                },
                className: "app-bar",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                    lgDown: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppHeader_HeaderNavWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                width: "100%",
                                mx: "auto"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_HorizontalNav, {
                                visible: visible
                            })
                        })
                    })
                })
            }),
            visible && /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                lgDown: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBar/* default */.Z, {
                    color: "inherit",
                    position: "fixed",
                    sx: {
                        boxShadow: "none",
                        borderBottom: function(theme) {
                            return "solid 1px ".concat(theme.palette.divider);
                        },
                        backgroundColor: "background.paper",
                        width: {
                            xs: "100%"
                        },
                        mx: "auto",
                        filter: Array.isArray(layoutClient) && layoutClient.length > 0 && layoutClient.filter(function(x) {
                            return x.sectionName === AppEnums/* ElementSection.GRAYBACKGROUND */.Pw.GRAYBACKGROUND && x.isDisplay;
                        }).length > 0 ? "grayscale(100%)" : "unset"
                    },
                    className: "app-bar",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppHeader_HeaderNavWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                width: "100%",
                                mx: "auto"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_HorizontalNav, {
                                visible: visible
                            })
                        })
                    })
                })
            })
        ]
    });
};
HorDefault_AppHeader_AppHeader.propTypes = {};
/* harmony default export */ var HorDefault_AppHeader = (HorDefault_AppHeader_AppHeader);

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/HorDefault/AppSidebar/StandardSidebarWrapper.js







var AppSidebar_StandardSidebarWrapper_StandardSidebarWrapper = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            width: 280,
            display: "flex",
            flexDirection: "column",
            transition: "all 0.5s ease",
            position: "relative",
            top: 0,
            left: 0,
            zIndex: 1101,
            "& .app-sidebar": {
                position: "relative",
                top: "auto",
                left: "auto",
                width: "100%",
                borderRight: "0 none"
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var HorDefault_AppSidebar_StandardSidebarWrapper = (AppSidebar_StandardSidebarWrapper_StandardSidebarWrapper);
AppSidebar_StandardSidebarWrapper_StandardSidebarWrapper.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/components/VerticalNavClient/VerticalItem/VerticalNavItem.js











var VerticalNavItem_VerticalNavItem = function(_param) {
    var children = _param.children, item = _param.item, className = _param.className, router = _param.router, level = _param.level, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "item",
        "className",
        "router",
        "level"
    ]);
    var ref = (0,SidebarContextProvider/* useSidebarContext */.Sz)(), sidebarTextColor = ref.sidebarTextColor, sidebarMenuSelectedBgColor = ref.sidebarMenuSelectedBgColor, sidebarMenuSelectedTextColor = ref.sidebarMenuSelectedTextColor, menuStyle = ref.menuStyle;
    var pathname = router.pathname;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        className: (0,clsx_m["default"])("nav-item menu-vertical-item", {
            "rounded-menu": menuStyle === AppEnums/* MenuStyle.ROUNDED */.gA.ROUNDED,
            "rounded-menu-reverse": menuStyle === AppEnums/* MenuStyle.ROUNDED_REVERSE */.gA.ROUNDED_REVERSE,
            "standard-menu": menuStyle === AppEnums/* MenuStyle.STANDARD */.gA.STANDARD,
            "curved-menu": menuStyle === AppEnums/* MenuStyle.CURVED_MENU */.gA.CURVED_MENU,
            active: item.url === pathname
        }),
        sx: {
            height: 40,
            my: 0.25,
            cursor: "pointer",
            textDecoration: "none !important",
            mx: 2,
            width: "calc(100% - 16px)",
            pl: 22 + 33 * level + "px",
            pr: 3,
            borderRadius: 1,
            position: "relative",
            transition: "all 0.4s ease",
            whiteSpace: "nowrap",
            "& .nav-item-icon": {
                color: (0,colorManipulator/* alpha */.Fq)(sidebarTextColor, 0.7),
                fontSize: 20,
                display: "block"
            },
            "& .nav-item-text": {
                color: (0,colorManipulator/* alpha */.Fq)(sidebarTextColor, 0.7),
                fontWeight: AppEnums/* Fonts.MEDIUM */.F3.MEDIUM,
                fontSize: 14
            },
            "& .MuiTouchRipple-root": {
                zIndex: 1
            },
            "&.nav-item-header": {
                textTransform: "uppercase"
            },
            "&:hover, &:focus": {
                "& .nav-item-text, & .nav-item-icon, & .nav-item-icon-arrow": {
                    color: sidebarTextColor
                }
            },
            "&.active": {
                backgroundColor: sidebarMenuSelectedBgColor,
                pointerEvents: "none",
                "& .nav-item-text": {
                    color: sidebarMenuSelectedTextColor + "!important",
                    fontWeight: AppEnums/* Fonts.MEDIUM */.F3.MEDIUM
                },
                "& .nav-item-icon": {
                    color: sidebarMenuSelectedTextColor + "!important"
                }
            },
            "&.rounded-menu": {
                mr: 4,
                ml: 0,
                width: "calc(100% - 16px)",
                pl: 30 + 33 * level + "px",
                pr: 3,
                borderRadius: "0 30px 30px 0"
            },
            "&.rounded-menu-reverse": {
                ml: 4,
                mr: 0,
                width: "calc(100% - 16px)",
                pl: 14 + 33 * level + "px",
                pr: 3,
                borderRadius: "30px 0 0 30px"
            },
            "&.standard-menu": {
                mx: 0,
                width: "100%",
                pl: 30 + 33 * level + "px",
                pr: 3,
                borderRadius: 0,
                position: "relative",
                "&:after": {
                    content: '""',
                    position: "absolute",
                    right: 0,
                    top: 0,
                    height: "100%",
                    width: 4,
                    backgroundColor: "transparent"
                },
                "&.active:after": {
                    backgroundColor: function(theme) {
                        return theme.palette.primary.main;
                    }
                }
            },
            "&.curved-menu": {
                ml: 4,
                mr: 0,
                width: "calc(100% - 16px)",
                pl: 14 + 33 * level + "px",
                pr: 3,
                borderRadius: "30px 0 0 30px",
                position: "relative",
                transition: "none",
                "&:before, &:after": {
                    content: '""',
                    position: "absolute",
                    right: 0,
                    zIndex: 1,
                    height: 40,
                    width: 40,
                    backgroundColor: "transparent",
                    borderRadius: "50%",
                    opacity: 0
                },
                "&:before": {
                    top: -40,
                    boxShadow: "30px 30px 0 10px transparent"
                },
                "&:after": {
                    bottom: -40,
                    boxShadow: "30px -30px 0 10px transparent"
                },
                "&:hover, &.active": {
                    backgroundColor: sidebarMenuSelectedBgColor,
                    "& .nav-item-text, & .nav-item-icon": {
                        color: sidebarMenuSelectedTextColor + "!important"
                    },
                    "&:before": {
                        boxShadow: "30px 30px 0 10px ".concat(sidebarMenuSelectedBgColor),
                        opacity: 1
                    },
                    "&:after": {
                        boxShadow: "30px -30px 0 10px ".concat(sidebarMenuSelectedBgColor),
                        opacity: 1
                    }
                },
                "& .MuiTouchRipple-root": {
                    display: "none"
                }
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var VerticalNavClient_VerticalItem_VerticalNavItem = (VerticalNavItem_VerticalNavItem);
VerticalNavItem_VerticalNavItem.propTypes = {
    children: (prop_types_default()).node,
    level: (prop_types_default()).number,
    className: (prop_types_default()).string,
    item: (prop_types_default()).object,
    router: (prop_types_default()).object
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/components/VerticalNavClient/VerticalItem/index.js













var VerticalItem_VerticalItem = function(param) {
    var level = param.level, router = param.router, item = param.item;
    var user = (0,AuthHooks/* useAuthUser */.f)().user;
    // const hasPermission = useMemo(
    //   () => checkPermission(item.permittedRole, user.role),
    //   [item.permittedRole, user.role],
    // );
    // if (!hasPermission) {
    //   return null;
    // }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: item.url,
        as: item.as,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            style: {
                all: "unset"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(VerticalNavClient_VerticalItem_VerticalNavItem, {
                item: item,
                level: level,
                router: router,
                exact: item.exact,
                children: [
                    item.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        component: "span",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            sx: {
                                fontSize: 18,
                                display: "block",
                                mr: 4
                            },
                            className: (0,clsx_m["default"])("nav-item-icon", "material-icons-outlined"),
                            color: "action",
                            children: item.icon
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                        className: "nav-item-content",
                        primary: item.title,
                        classes: {
                            primary: "nav-item-text"
                        }
                    }),
                    item.count && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            mr: 3.5
                        },
                        className: "menu-badge",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBadge/* default */.Z, {
                            count: item.count,
                            color: item.color
                        })
                    })
                ]
            })
        })
    });
};
VerticalItem_VerticalItem.propTypes = {
    item: prop_types_default().shape({
        id: (prop_types_default()).string.isRequired,
        title: (prop_types_default()).string,
        icon: prop_types_default().oneOfType([
            (prop_types_default()).node,
            (prop_types_default()).string
        ]),
        permittedRole: prop_types_default().oneOfType([
            (prop_types_default()).array,
            (prop_types_default()).string
        ]),
        exact: (prop_types_default()).bool,
        messageId: (prop_types_default()).string,
        count: prop_types_default().oneOfType([
            (prop_types_default()).number,
            (prop_types_default()).string
        ]),
        url: (prop_types_default()).string,
        color: (prop_types_default()).string,
        as: (prop_types_default()).string
    }),
    level: (prop_types_default()).number,
    router: (prop_types_default()).object
};
VerticalItem_VerticalItem.defaultProps = {};
/* harmony default export */ var VerticalNavClient_VerticalItem = (/*#__PURE__*/react.memo(VerticalItem_VerticalItem));

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/components/VerticalNavClient/VerticalCollapse/VerticalCollapseItem.js









var VerticalCollapseItem_VerticalCollapseItem = function(_param) {
    var children = _param.children, sidebarTextColor = _param.sidebarTextColor, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "sidebarTextColor"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            height: 40,
            my: 0.25,
            pl: "31px",
            pr: 3.75,
            whiteSpace: "nowrap",
            transition: "all 0.4s ease",
            "& .nav-item-text": {
                fontWeight: AppEnums/* Fonts.MEDIUM */.F3.MEDIUM,
                color: (0,colorManipulator/* alpha */.Fq)(sidebarTextColor, 0.7)
            },
            "& .nav-item-icon": {
                color: (0,colorManipulator/* alpha */.Fq)(sidebarTextColor, 0.7),
                fontSize: 20,
                display: "block"
            },
            "& .nav-item-icon-arrow": {
                color: (0,colorManipulator/* alpha */.Fq)(sidebarTextColor, 0.7)
            },
            "& .MuiIconButton-root": {
                mr: 3,
                padding: 0
            },
            "& .MuiTouchRipple-root": {
                zIndex: 10
            },
            "&.open, &:hover, &:focus": {
                "& .nav-item-text": {
                    fontWeight: AppEnums/* Fonts.MEDIUM */.F3.MEDIUM,
                    color: sidebarTextColor
                },
                "& .nav-item-icon": {
                    color: sidebarTextColor
                },
                "& .nav-item-icon-arrow": {
                    color: sidebarTextColor
                }
            },
            "&:hover": {
                backgroundColor: "transparent"
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var VerticalNavClient_VerticalCollapse_VerticalCollapseItem = (VerticalCollapseItem_VerticalCollapseItem);
VerticalCollapseItem_VerticalCollapseItem.propTypes = {
    children: (prop_types_default()).node,
    sidebarTextColor: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/components/VerticalNavClient/VerticalCollapse/index.js


















var VerticalCollapse_needsToBeOpened = function(pathname, item) {
    return pathname && VerticalCollapse_isUrlInChildren(item, pathname);
};
var VerticalCollapse_isUrlInChildren = function(parent, url) {
    if (!parent.children) {
        return false;
    }
    for(var i = 0; i < parent.children.length; i++){
        if (parent.children[i].children) {
            if (VerticalCollapse_isUrlInChildren(parent.children[i], url)) {
                return true;
            }
        }
        if (parent.children[i].url === url || url.includes(parent.children[i].url)) {
            return true;
        }
    }
    return false;
};
var VerticalCollapse_VerticalCollapse = function(param) {
    var item = param.item, router = param.router, level = param.level;
    var theme = (0,ThemeContextProvider/* useThemeContext */.TC)().theme;
    var sidebarTextColor = (0,SidebarContextProvider/* useSidebarContext */.Sz)().sidebarTextColor;
    var pathname = (0,next_router.useRouter)().pathname;
    var ref = (0,react.useState)(function() {
        return VerticalCollapse_needsToBeOpened(pathname, item);
    }), open = ref[0], setOpen = ref[1];
    (0,react.useEffect)(function() {
        if (VerticalCollapse_needsToBeOpened(pathname, item)) {
            setOpen(true);
        }
    }, [
        pathname,
        item
    ]);
    var handleClick = function() {
        setOpen(!open);
    };
    var user = (0,AuthHooks/* useAuthUser */.f)().user;
    // const hasPermission = useMemo(
    //   () => checkPermission(item.permittedRole, user.role),
    //   [item.permittedRole, user.role],
    // );
    // if (!hasPermission) {
    //   return null;
    // }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(VerticalNavClient_VerticalCollapse_VerticalCollapseItem, {
                level: level,
                sidebarTextColor: sidebarTextColor,
                button: true,
                component: "div",
                className: (0,clsx_m["default"])("menu-vertical-collapse", open && "open"),
                onClick: handleClick,
                children: [
                    item.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        component: "span",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            sx: {
                                mr: 4
                            },
                            color: "action",
                            className: (0,clsx_m["default"])("nav-item-icon"),
                            children: item.icon
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                        sx: {
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            fontSize: 14
                        },
                        className: "nav-item-content",
                        classes: {
                            primary: (0,clsx_m["default"])("nav-item-text")
                        },
                        primary: item.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                        className: "nav-item-icon-arrow-btn",
                        sx: {
                            p: 0,
                            mr: 0.75
                        },
                        disableRipple: true,
                        size: "large",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            className: "nav-item-icon-arrow",
                            color: "inherit",
                            children: open ? "expand_more" : theme.direction === "ltr" ? "chevron_right" : "chevron_left"
                        })
                    })
                ]
            }),
            item.children && /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                in: open,
                className: "collapse-children",
                children: item.children.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            item.type === "collapse" && /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalCollapse_VerticalCollapse, {
                                item: item,
                                level: level + 1,
                                router: router
                            }),
                            item.type === "item" && /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalNavClient_VerticalItem, {
                                item: item,
                                level: level + 1,
                                router: router
                            })
                        ]
                    }, item.id);
                })
            })
        ]
    });
};
VerticalCollapse_VerticalCollapse.propTypes = {
    item: prop_types_default().shape({
        id: (prop_types_default()).string.isRequired,
        title: (prop_types_default()).string,
        icon: prop_types_default().oneOfType([
            (prop_types_default()).node,
            (prop_types_default()).string
        ]),
        permittedRole: prop_types_default().oneOfType([
            (prop_types_default()).array,
            (prop_types_default()).string
        ]),
        children: (prop_types_default()).array,
        messageId: (prop_types_default()).string,
        type: (prop_types_default()).string
    }),
    level: (prop_types_default()).number,
    router: (prop_types_default()).object
};
VerticalCollapse_VerticalCollapse.defaultProps = {};
/* harmony default export */ var VerticalNavClient_VerticalCollapse = (/*#__PURE__*/react.memo(VerticalCollapse_VerticalCollapse));

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/components/VerticalNavClient/VerticalNavGroup/VerticalNavGroupItem.js









var VerticalNavGroupItem_VerticalNavGroupItem = function(_param) {
    var children = _param.children, sidebarTextColor = _param.sidebarTextColor, level = _param.level, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "sidebarTextColor",
        "level"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            height: 40,
            my: 0.25,
            pl: 31 + 33 * level + "px",
            pr: 3,
            color: (0,colorManipulator/* alpha */.Fq)(sidebarTextColor, 0.7),
            fontWeight: AppEnums/* Fonts.SEMI_BOLD */.F3.SEMI_BOLD,
            fontSize: 14,
            cursor: "pointer",
            textDecoration: "none!important",
            whiteSpace: "nowrap",
            transition: "all 0.4s ease",
            "&.nav-item-header": {
                cursor: "auto",
                transition: "all 0.4s ease"
            },
            display: "flex",
            alignItems: "center",
            justifyItems: "center",
            flexDirection: "row",
            justifySelf: "center"
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var VerticalNavClient_VerticalNavGroup_VerticalNavGroupItem = (VerticalNavGroupItem_VerticalNavGroupItem);
VerticalNavGroupItem_VerticalNavGroupItem.propTypes = {
    children: (prop_types_default()).node,
    sidebarTextColor: (prop_types_default()).string,
    level: (prop_types_default()).number
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/components/VerticalNavClient/VerticalNavGroup/index.js
















var VerticalNavGroup_VerticalNavGroup = function(param) {
    var item = param.item, router = param.router, level = param.level;
    var sidebarTextColor = (0,SidebarContextProvider/* useSidebarContext */.Sz)().sidebarTextColor;
    var user = (0,AuthHooks/* useAuthUser */.f)().user;
    // const hasPermission = useMemo(
    //   () => checkPermission(item.permittedRole, user.role),
    //   [item.permittedRole, user.role],
    // );
    // if (!hasPermission) {
    //   return null;
    // }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: item.url,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(VerticalNavClient_VerticalNavGroup_VerticalNavGroupItem, {
                    level: level,
                    sidebarTextColor: sidebarTextColor,
                    component: "div",
                    className: (0,clsx_m["default"])("nav-item nav-item-header"),
                    children: [
                        item.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            color: "action",
                            sx: {
                                color: function(theme) {
                                    return theme.palette.secondary.mauExtension;
                                }
                            },
                            children: item.icon
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            children: item.title
                        }),
                        item.children && item.children.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                            sx: {
                                ml: 1
                            },
                            disableRipple: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                sx: {
                                    fontSize: 30
                                },
                                className: "arrow-icon",
                                children: "keyboard_arrow_down"
                            })
                        })
                    ]
                })
            }),
            item.children && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: item.children.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            item.type === "group" && /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalNavGroup_NavVerticalGroup, {
                                item: item,
                                level: level,
                                router: router
                            }),
                            item.type === "collapse" && /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalNavClient_VerticalCollapse, {
                                item: item,
                                level: level,
                                router: router
                            }),
                            item.type === "item" && /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalNavClient_VerticalItem, {
                                item: item,
                                level: level,
                                router: router
                            })
                        ]
                    }, item.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {})
        ]
    });
};
VerticalNavGroup_VerticalNavGroup.propTypes = {
    item: prop_types_default().shape({
        id: (prop_types_default()).string.isRequired,
        title: (prop_types_default()).string,
        type: (prop_types_default()).string,
        icon: prop_types_default().oneOfType([
            (prop_types_default()).node,
            (prop_types_default()).string
        ]),
        permittedRole: prop_types_default().oneOfType([
            (prop_types_default()).array,
            (prop_types_default()).string
        ]),
        messageId: (prop_types_default()).string,
        children: (prop_types_default()).array,
        url: (prop_types_default()).string
    }),
    level: (prop_types_default()).number,
    router: (prop_types_default()).object
};
VerticalNavGroup_VerticalNavGroup.defaultProps = {};
var VerticalNavGroup_NavVerticalGroup = VerticalNavGroup_VerticalNavGroup;
/* harmony default export */ var VerticalNavClient_VerticalNavGroup = (VerticalNavGroup_NavVerticalGroup);

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/HomeTwoTone.js
var HomeTwoTone = __webpack_require__(75972);
;// CONCATENATED MODULE: ./src/@common/core/AppLayout/components/VerticalNavClient/index.js









var VerticalNavClient = function() {
    var router = (0,next_router.useRouter)();
    var dataRouteHome = (0,es/* useSelector */.v9)(function(param) {
        var categoryApp = param.categoryApp;
        return categoryApp.treeCategories.data;
    });
    var categoryHome = {
        id: 1,
        title: "TRANG CHỦ",
        messageId: "sidebar",
        type: "item",
        url: "/",
        children: null,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeTwoTone/* default */.Z, {
            fontSize: "medium"
        })
    };
    if (!dataRouteHome) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* default */.Z, {
        sx: {
            position: "relative",
            padding: 0
        },
        component: "div",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalNavClient_VerticalNavGroup, {
                item: categoryHome,
                level: 0,
                router: router
            }),
            dataRouteHome.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        item.type === "group" && /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalNavClient_VerticalNavGroup, {
                            item: item,
                            level: 0,
                            router: router
                        }),
                        item.type === "collapse" && /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalNavClient_VerticalCollapse, {
                            item: item,
                            level: 0,
                            router: router
                        }),
                        item.type === "item" && /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalNavClient_VerticalItem, {
                            item: item,
                            level: 0,
                            router: router
                        })
                    ]
                }, item.id);
            })
        ]
    });
};
/* harmony default export */ var components_VerticalNavClient = (VerticalNavClient);

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/HorDefault/AppSidebar/index.js



















var HorDefault_AppSidebar_AppSidebar = function(props) {
    var dispatch = (0,es/* useDispatch */.I0)();
    var navCollapsed = (0,es/* useSelector */.v9)(function(param) {
        var settings = param.settings;
        return settings.navCollapsed;
    });
    var layoutClient = (0,es/* useSelector */.v9)(function(param) {
        var layoutClientApp = param.layoutClientApp;
        return layoutClientApp.layoutClientList;
    });
    var sidebarTextColor = (0,SidebarContextProvider/* useSidebarContext */.Sz)().sidebarTextColor;
    var handleToggleDrawer = function() {
        dispatch((0,actions/* toggleNavCollapsedHide */.Eh)());
    };
    var isAuthenticated = (0,es/* useSelector */.v9)(function(param) {
        var authentication = param.authentication;
        return authentication.isAuthenticated;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer_Drawer/* default */.ZP, {
            anchor: props.position,
            open: navCollapsed,
            onClose: function() {
                return handleToggleDrawer();
            },
            classes: {
                root: (0,clsx_m["default"])(props.variant),
                paper: (0,clsx_m["default"])(props.variant)
            },
            style: {
                position: "absolute",
                filter: Array.isArray(layoutClient) && layoutClient.length > 0 && layoutClient.filter(function(x) {
                    return x.sectionName === AppEnums/* ElementSection.GRAYBACKGROUND */.Pw.GRAYBACKGROUND && x.isDisplay;
                }).length > 0 ? "grayscale(100%)" : "unset"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HorDefault_AppSidebar_StandardSidebarWrapper, {
                className: "standard-sidebar",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_MainSidebar, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                py: 3,
                                px: 3,
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                                background: function(theme) {
                                    return theme.palette.secondary.mauExtension;
                                }
                            },
                            className: "user-info-view",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                sx: {
                                    width: {
                                        xs: "calc(100% - 62px)",
                                        xl: "calc(100% - 72px)"
                                    },
                                    ml: 4
                                },
                                className: "user-info",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UserInfo, {
                                        isView: false,
                                        isHome: true,
                                        isSticky: true,
                                        isClient: true
                                    }),
                                    !isAuthenticated && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                        sx: {
                                            display: "flex",
                                            alignItems: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                                sx: {
                                                    mx: 2
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                                    component: "span",
                                                    sx: {
                                                        "& a": {
                                                            color: function(theme) {
                                                                return theme.palette.primary.main;
                                                            },
                                                            textDecoration: "none",
                                                            cursor: "pointer"
                                                        }
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/dang-ky",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                                                component: "span",
                                                                sx: {
                                                                    fontSize: 14,
                                                                    alignItems: "center",
                                                                    display: "flex",
                                                                    fontWeight: AppEnums/* Fonts.MEDIUM */.F3.MEDIUM,
                                                                    color: function(theme) {
                                                                        return theme.palette.grey["50"];
                                                                    }
                                                                },
                                                                children: "Đăng k\xfd"
                                                            })
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                                sx: {
                                                    color: "grey.500"
                                                },
                                                children: "|"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                                sx: {
                                                    mx: 2
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                                    component: "span",
                                                    sx: {
                                                        "& a": {
                                                            color: function(theme) {
                                                                return theme.palette.primary.main;
                                                            },
                                                            textDecoration: "none",
                                                            cursor: "pointer"
                                                        }
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/dang-nhap",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                                                component: "span",
                                                                sx: {
                                                                    fontSize: 14,
                                                                    alignItems: "center",
                                                                    display: "flex",
                                                                    fontWeight: AppEnums/* Fonts.MEDIUM */.F3.MEDIUM,
                                                                    color: function(theme) {
                                                                        return theme.palette.grey["50"];
                                                                    }
                                                                },
                                                                children: "Đăng nhập"
                                                            })
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(core_AppScrollbar/* default */.Z, {
                            sx: {
                                py: 2,
                                height: "calc(100vh - 70px) !important"
                            },
                            scrollToTop: false,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_VerticalNavClient, {})
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var HorDefault_AppSidebar = (HorDefault_AppSidebar_AppSidebar);
HorDefault_AppSidebar_AppSidebar.defaultProps = {
    variant: "",
    position: "left"
};
HorDefault_AppSidebar_AppSidebar.propTypes = {
    position: (prop_types_default()).string,
    variant: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/HorDefault/HorDefaultWrapper.js







var HorDefaultWrapper = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            flex: 1,
            display: "flex",
            flexDirection: "row",
            position: "relative",
            backgroundColor: function(theme) {
                return theme.palette.background.default;
            },
            "&.appMainFixedFooter": {
                pb: {
                    xs: 12,
                    xl: 14.5
                }
            },
            "& .customizerOption": {
                top: 210
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var HorDefault_HorDefaultWrapper = (HorDefaultWrapper);
HorDefaultWrapper.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/HorDefault/MainContent.js







var HorDefault_MainContent_MainContent = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            flex: 1,
            display: "flex",
            width: "100%",
            flexDirection: "column",
            position: "relative",
            transition: "all 0.5s ease",
            "& .app-content, & .footerContainer": {
                px: 1,
                width: "100%",
                maxWidth: {
                    lg: 1140,
                    xl: 1420
                },
                mx: "auto"
            }
        },
        className: "mainContent"
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var HorDefault_MainContent = (HorDefault_MainContent_MainContent);
HorDefault_MainContent_MainContent.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/HorDefault/HorDefaultContainer.js







var HorDefaultContainer = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            minHeight: "100vh",
            display: "flex",
            flexDirection: "row",
            position: "relative",
            backgroundColor: function(theme) {
                return theme.palette.background.default;
            },
            "&.boxedLayout": {
                maxWidth: {
                    xl: 1480
                },
                mx: {
                    xl: "auto"
                },
                boxShadow: "none",
                borderLeft: "1px solid #e8e5dd",
                borderRight: "1px solid #e8e5dd",
                pt: {
                    xl: 0
                },
                "& .app-bar": {
                    position: {
                        xl: "fixed"
                    },
                    top: 0
                },
                "& .mainContent": {
                    position: {
                        xl: "static"
                    }
                },
                "& .fixed-footer": {
                    position: {
                        xl: "sticky"
                    }
                },
                "& .appMainFixedFooter": {
                    pb: {
                        xl: 0
                    }
                }
            },
            "&.framedLayout": {
                padding: {
                    xl: 5
                },
                backgroundColor: function(theme) {
                    return theme.palette.primary.main;
                },
                "& .horDefaultWrapper": {
                    borderRadius: {
                        xl: 3
                    }
                },
                "& .app-bar": {
                    borderTopLeftRadius: {
                        xl: 12
                    },
                    borderTopRightRadius: {
                        xl: 12
                    },
                    overflow: "hidden",
                    position: {
                        xl: "fixed"
                    },
                    top: 0
                },
                "& .footer": {
                    borderBottomLeftRadius: {
                        xl: 12
                    },
                    borderBottomRightRadius: {
                        xl: 12
                    }
                },
                "& .mainContent": {
                    position: {
                        xl: "static"
                    }
                },
                "& .fixed-footer": {
                    position: {
                        xl: "sticky"
                    }
                },
                "& .appMainFixedFooter": {
                    pb: {
                        xl: 0
                    }
                }
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var HorDefault_HorDefaultContainer = (HorDefaultContainer);
HorDefaultContainer.propTypes = {
    children: (prop_types_default()).node
};

// EXTERNAL MODULE: ./src/@common/core/AppAnimate/index.js
var AppAnimate = __webpack_require__(29863);
// EXTERNAL MODULE: ./src/@common/core/AppGridContainer/index.js
var AppGridContainer = __webpack_require__(6813);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(90087);
// EXTERNAL MODULE: ./src/@common/core/AppCard/index.js
var AppCard = __webpack_require__(77305);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(48055);
// EXTERNAL MODULE: ./node_modules/@mui/private-theming/useTheme/useTheme.js
var useTheme = __webpack_require__(56760);
;// CONCATENATED MODULE: ./src/@common/core/AppLayout/HorDefault/AppExtension/ExtensionContainer.js










var ExtensionContainerStatics = function(param) {
    var data = param.data, index = param.index, number = param.number;
    var theme = (0,useTheme/* default */.Z)();
    var icon = data.icon, name = data.name, id = data.id, iconPath = data.iconPath;
    var isHome = window.location.pathname === "/" ? true : false;
    var isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("md"));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppCard/* default */.Z, {
        sxStyle: {
            backgroundColor: function(theme) {
                return theme.palette.secondary.mauExtension;
            },
            boxShadow: "unset",
            borderRadius: "unset",
            height: "100%",
            borderLeft: "".concat(index === 0 ? "" : "2px solid #e8e5dd"),
            alignItems: "center"
        },
        contentStyle: {
            p: {
                xs: isHome ? 1.5 : 1,
                lg: 5
            }
        },
        className: "card-hover",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
            sx: {
                display: "flex",
                alignItems: "center",
                flexDirection: {
                    lg: "row",
                    xs: "column"
                },
                justifyContent: "center",
                justifyItems: "center"
            },
            children: [
                !isMobile && !icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        px: 2
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppMuiImage/* default */.Z, {
                        src: iconPath,
                        alt: "icon",
                        fit: "fill",
                        height: isMobile ? 20 : 25,
                        width: isMobile ? 20 : 25
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        px: 2
                    },
                    children: icon
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: {
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            textAlign: "center",
                            whiteSpace: isMobile ? "normal" : "nowrap",
                            width: "100%",
                            color: function(theme) {
                                return !isMobile ? theme.palette.grey["50"] : theme.palette.secondary.yellowCongAn;
                            },
                            fontWeight: AppEnums/* Fonts.MEDIUM */.F3.MEDIUM,
                            fontSize: {
                                xs: 10,
                                xl: 13,
                                lg: 13,
                                sm: 11
                            },
                            mt: isMobile ? 3 : 0
                        },
                        children: name.toUpperCase()
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ExtensionContainer = (ExtensionContainerStatics);
ExtensionContainerStatics.propTypes = {
    data: (prop_types_default()).object,
    index: (prop_types_default()).any,
    number: (prop_types_default()).any
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/HorDefault/AppExtension/index.js













function AppExtension() {
    var ref = (0,react.useState)(), source = ref[0], setSource = ref[1];
    var ref1 = (0,react.useState)([]), dataExtension = ref1[0], setDataExtension = ref1[1];
    var treeCategories = (0,es/* useSelector */.v9)(function(param) {
        var categoryApp = param.categoryApp;
        return categoryApp.treeCategories.data;
    });
    var layoutClient = (0,es/* useSelector */.v9)(function(param) {
        var layoutClientApp = param.layoutClientApp;
        return layoutClientApp.layoutClientList;
    });
    var listBlog = (0,es/* useSelector */.v9)(function(param) {
        var lawDisseminationApp = param.lawDisseminationApp;
        return lawDisseminationApp.listBlog;
    });
    (0,react.useEffect)(function() {
        var ref;
        var source = (ref = treeCategories.find(function(param) {
            var source = param.source;
            return source === 2;
        })) === null || ref === void 0 ? void 0 : ref.originSlug;
        setSource(source);
    }, [
        treeCategories
    ]);
    (0,react.useEffect)(function() {
        var tempData = [];
        if (Array.isArray(listBlog) && !!listBlog.length) {
            for(var i = 0; i < listBlog.length; i++){
                if (listBlog[i].tenDanhMuc.toUpperCase() === "GIỚI THIỆU") {
                    tempData.push((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, listBlog[i]), {
                        name: "Giới thiệu",
                        href: "/gioi-thieu",
                        iconPath: "/assets/images/home-pages/categoryContact.png",
                        color: "#c62e14"
                    }));
                } else if (listBlog[i].tenDanhMuc.toUpperCase() === "PHỔ BIẾN PH\xc1P LUẬT") {
                    tempData.push((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, listBlog[i]), {
                        name: "Phổ biến ph\xe1p luật",
                        href: "/pho-bien-phap-luat",
                        iconPath: "/assets/images/home-pages/categoryBook.png",
                        color: "#6c6c6c"
                    }));
                } else if (listBlog[i].tenDanhMuc.toUpperCase() === "DỊCH VỤ C\xd4NG") {
                    tempData.push((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, listBlog[i]), {
                        name: "Dịch vụ c\xf4ng",
                        href: "/".concat(source),
                        iconPath: "/assets/images/home-pages/categoryService.png",
                        color: "#e89319"
                    }));
                } else if (listBlog[i].tenDanhMuc.toUpperCase() === "HỎI Đ\xc1P TRỰC TUYẾN") {
                    tempData.push((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, listBlog[i]), {
                        name: "Hỏi đ\xe1p trực tuyến",
                        href: "/hoi-dap",
                        iconPath: "/assets/images/home-pages/categoryQuestion.png",
                        color: "#0a903b"
                    }));
                } else if (listBlog[i].tenDanhMuc.toUpperCase() === "PHẢN \xc1NH KIẾN NGHỊ") {
                    tempData.push((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, listBlog[i]), {
                        name: "Phản \xe1nh kiến nghị",
                        href: "/phan-anh-kien-nghi",
                        iconPath: "/assets/images/home-pages/categoryComplain.png",
                        color: "#0a903b"
                    }));
                } else if (listBlog[i].tenDanhMuc.toUpperCase() === "THƯ VIỆN PH\xc1P LUẬT") {
                    tempData.push((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, listBlog[i]), {
                        name: "Thư viện ph\xe1p luật",
                        href: "/thu-vien-phap-luat",
                        iconPath: "/assets/images/home-pages/categoryLibrary.png",
                        color: "#0a903b"
                    }));
                }
            }
        }
        setDataExtension(tempData);
    }, [
        listBlog,
        source
    ]);
    // const dataExtension = [
    //   {
    //     id: 1,
    //     name: 'Giới thiệu',
    //     href: '/gioi-thieu',
    //     iconPath: '/assets/images/home-pages/categoryContact.png',
    //     color: '#c62e14',
    //   },
    //   {
    //     id: 2,
    //     name: 'Phổ biến pháp luật',
    //     href: '/pho-bien-phap-luat',
    //     iconPath: '/assets/images/home-pages/categoryBook.png',
    //     color: '#6c6c6c',
    //   },
    //   {
    //     id: 3,
    //     name: 'Dịch vụ công',
    //     href: `/${source}`,
    //     iconPath: '/assets/images/home-pages/categoryService.png',
    //     color: '#e89319',
    //   },
    //   {
    //     id: 4,
    //     name: 'Phản ánh kiến nghị',
    //     href: '/phan-anh-kien-nghi',
    //     iconPath: '/assets/images/home-pages/categoryComplain.png',
    //     color: '#0a903b',
    //   },
    //   {
    //     id: 4,
    //     name: 'Hỏi đáp trực tuyến',
    //     href: '/hoi-dap',
    //     iconPath: '/assets/images/home-pages/categoryQuestion.png',
    //     color: '#0a903b',
    //   },
    // ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppAnimate/* default */.Z, {
        animation: "transition.slideUpIn",
        delay: 200,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
            sx: {
                backgroundColor: function(theme) {
                    return theme.palette.secondary.mauExtension;
                },
                filter: Array.isArray(layoutClient) && layoutClient.length > 0 && layoutClient.filter(function(x) {
                    return x.sectionName === AppEnums/* ElementSection.GRAYBACKGROUND */.Pw.GRAYBACKGROUND && x.isDisplay;
                }).length > 0 ? "grayscale(100%)" : "none"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    maxWidth: {
                        lg: 1140
                    },
                    mx: "auto",
                    pl: {
                        md: 1
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppGridContainer/* default */.Z, {
                    spacing: 0.5,
                    sx: {
                        py: 0,
                        justifyContent: "center",
                        boxShadow: 0,
                        mt: 0
                    },
                    children: dataExtension.map(function(data, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12 / dataExtension.length,
                            sm: 12 / dataExtension.length,
                            lg: 12 / dataExtension.length,
                            sx: {
                                cursor: "pointer"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: data.href,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    style: {
                                        all: "unset"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExtensionContainer, {
                                        data: data,
                                        index: index,
                                        number: dataExtension.length
                                    })
                                })
                            })
                        }, index);
                    })
                })
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-material-ui-carousel/dist/index.js
var dist = __webpack_require__(13056);
;// CONCATENATED MODULE: ./src/@common/core/AppSkeleton/BannerSkeleton.js






var BannerSkeleton = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        sx: {
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            background: function(theme) {
                return theme.palette.background.paper;
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_content_loader_es/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            viewBox: "0 0 500 500",
            height: 150,
            width: 800,
            backgroundColor: "#f3f3f3",
            foregroundColor: "#ecebeb"
        }, props), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M484.52,64.61H15.65C7.1,64.61.17,71.2.17,79.31V299.82c0,8.12,6.93,14.7,15.48,14.7H484.52c8.55,0,15.48-6.58,15.48-14.7V79.31C500,71.2,493.07,64.61,484.52,64.61Zm-9,204.34c0,11.84-7.14,21.44-15.94,21.44H436.39L359.16,171.52c-7.1-10.92-19.67-11.16-27-.51L258.64,277.94C253.78,285,245.73,286,240,280.2l-79.75-80.62c-6-6.06-14.33-5.7-20,.88L62.34,290.39H40.63c-8.8,0-15.94-9.6-15.94-21.44V110.19c0-11.84,7.14-21.44,15.94-21.44H459.54c8.8,0,15.94,9.6,15.94,21.44Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                    cx: "120",
                    cy: "140",
                    rx: "28",
                    ry: "28"
                })
            ]
        }))
    });
};
/* harmony default export */ var AppSkeleton_BannerSkeleton = (BannerSkeleton);

// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(4338);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardMedia/CardMedia.js + 1 modules
var CardMedia = __webpack_require__(53413);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardContent/CardContent.js + 1 modules
var CardContent = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardActions/CardActions.js + 1 modules
var CardActions = __webpack_require__(65517);
;// CONCATENATED MODULE: ./src/@common/core/AppCard/AppCardMedia.js












var AppCardMedia = function(_param) {
    var children = _param.children, sxStyle = _param.sxStyle, contentStyle = _param.contentStyle, cardMedia = _param.cardMedia, sxCardMedia = _param.sxCardMedia, cardMediaAction = _param.cardMediaAction, sxCardMediaAction = _param.sxCardMediaAction, footer = _param.footer, footerStyle = _param.footerStyle, _noContent = _param.noContent, noContent = _noContent === void 0 ? false : _noContent, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "sxStyle",
        "contentStyle",
        "cardMedia",
        "sxCardMedia",
        "cardMediaAction",
        "sxCardMediaAction",
        "footer",
        "footerStyle",
        "noContent"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: (0,src_object_spread/* default */.Z)({
            display: "flex",
            flexDirection: "column"
        }, sxStyle)
    }, rest), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardMedia/* default */.Z, {
                        component: "img",
                        image: cardMedia,
                        alt: "card media",
                        sx: (0,src_object_spread/* default */.Z)({
                            minHeight: 140,
                            width: "100%",
                            maxHeight: 500
                        }, sxCardMedia)
                    }),
                    cardMediaAction ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        component: "span",
                        sx: (0,src_object_spread/* default */.Z)({
                            backgroundColor: function(theme) {
                                return alpha(theme.palette.text.primary, 0.7);
                            },
                            color: function(theme) {
                                return theme.palette.background.paper;
                            },
                            pt: 0.75,
                            pb: 1.75,
                            px: 4,
                            borderRadius: 7.5,
                            position: "absolute",
                            right: 15,
                            top: 15,
                            zIndex: 1,
                            fontSize: 12,
                            fontWeight: AppEnums/* Fonts.BOLD */.F3.BOLD
                        }, sxCardMediaAction),
                        children: cardMediaAction
                    }) : null
                ]
            }),
            !noContent && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                style: (0,src_object_spread/* default */.Z)({
                    paddingLeft: 20,
                    paddingRight: 20,
                    height: "100%"
                }, contentStyle),
                children: children
            }),
            footer ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActions/* default */.Z, {
                style: (0,src_object_spread/* default */.Z)({
                    paddingLeft: 20,
                    paddingRight: 20,
                    paddingBottom: 16
                }, footerStyle),
                children: footer
            }) : null
        ]
    }));
};
/* harmony default export */ var AppCard_AppCardMedia = ((/* unused pure expression or super */ null && (AppCardMedia)));
AppCardMedia.propTypes = {
    children: (prop_types_default()).node,
    sxStyle: (prop_types_default()).object,
    contentStyle: (prop_types_default()).object,
    cardMedia: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).object
    ]),
    sxCardMedia: (prop_types_default()).object,
    cardMediaAction: (prop_types_default()).string,
    sxCardMediaAction: (prop_types_default()).object,
    footer: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).node
    ]),
    footerStyle: (prop_types_default()).object,
    noContent: (prop_types_default()).bool
};

// EXTERNAL MODULE: ./node_modules/@mui/styles/makeStyles/makeStyles.js + 5 modules
var makeStyles = __webpack_require__(70902);
// EXTERNAL MODULE: ./src/@common/core/LazyLoadImage.js
var LazyLoadImage = __webpack_require__(76475);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var styles_useTheme = __webpack_require__(85385);
;// CONCATENATED MODULE: ./src/@common/core/AppCarousel/atom/CarouselArrowIndex.js





// @mui





//
// ----------------------------------------------------------------------
var RootStyle = (0,styled/* default */.ZP)(Box_Box/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        zIndex: 9,
        display: "flex",
        alignItems: "center",
        position: "absolute",
        bottom: theme.spacing(2),
        right: theme.spacing(2),
        color: theme.palette.common.white,
        borderRadius: theme.shape.borderRadius,
        backgroundColor: (0,colorManipulator/* alpha */.Fq)(theme.palette.grey[900], 0.48)
    };
});
var ArrowStyle = (0,styled/* default */.ZP)(IconButton_IconButton/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        padding: 6,
        opacity: 0.48,
        color: theme.palette.common.white,
        "&:hover": {
            opacity: 1
        }
    };
});
// ----------------------------------------------------------------------
CarouselArrowIndex.propTypes = {
    customIcon: prop_types_default().oneOfType([
        (prop_types_default()).element,
        (prop_types_default()).string
    ]),
    index: (prop_types_default()).number,
    onNext: (prop_types_default()).func,
    onPrevious: (prop_types_default()).func,
    total: (prop_types_default()).number
};
function CarouselArrowIndex(_param) {
    var index = _param.index, total = _param.total, onNext = _param.onNext, onPrevious = _param.onPrevious, customIcon = _param.customIcon, other = (0,_object_without_properties/* default */.Z)(_param, [
        "index",
        "total",
        "onNext",
        "onPrevious",
        "customIcon"
    ]);
    var theme = (0,styles_useTheme/* default */.Z)();
    var isRTL = theme.direction === "rtl";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootStyle, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, other), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowStyle, {
                size: "small",
                onClick: onPrevious,
                children: leftIcon(customIcon, isRTL)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                variant: "subtitle2",
                children: [
                    index + 1,
                    "/",
                    total
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowStyle, {
                size: "small",
                onClick: onNext,
                children: rightIcon(customIcon, isRTL)
            })
        ]
    }));
};
// ----------------------------------------------------------------------
var leftIcon = function(customIcon, isRTL) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
        icon: customIcon ? customIcon : "eva:arrow-right-fill",
        sx: (0,src_object_spread/* default */.Z)({
            width: 20,
            height: 20,
            transform: " scaleX(-1)"
        }, isRTL && {
            transform: " scaleX(1)"
        })
    });
};
var rightIcon = function(customIcon, isRTL) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
        icon: customIcon ? customIcon : "eva:arrow-right-fill",
        sx: (0,src_object_spread/* default */.Z)({
            width: 20,
            height: 20
        }, isRTL && {
            transform: " scaleX(-1)"
        })
    });
};

;// CONCATENATED MODULE: ./src/@common/core/AppCarousel/CarouselBasic.js










function CarouselBasic(param) {
    var _carousels = param._carousels;
    var theme = (0,useTheme/* default */.Z)();
    var carouselRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(theme.direction === "rtl" ? _carousels.length - 1 : 0), currentIndex = ref[0], setCurrentIndex = ref[1];
    var settings = {
        dots: false,
        arrows: false,
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        rtl: Boolean(theme.direction === "rtl"),
        beforeChange: function(current, next) {
            return setCurrentIndex(next);
        }
    };
    var handlePrevious = function() {
        var ref;
        (ref = carouselRef.current) === null || ref === void 0 ? void 0 : ref.slickPrev();
    };
    var handleNext = function() {
        var ref;
        (ref = carouselRef.current) === null || ref === void 0 ? void 0 : ref.slickNext();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
        sx: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                ref: carouselRef
            }, settings), {
                children: _carousels.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselItem, {
                        item: item
                    }, index);
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselArrowIndex, {
                index: currentIndex,
                total: _carousels.length,
                onNext: handleNext,
                onPrevious: handlePrevious
            })
        ]
    });
};
CarouselBasic.propTypes = {
    _carousels: (prop_types_default()).array
};
// ----------------------------------------------------------------------
CarouselItem.propTypes = {
    item: (prop_types_default()).any
};
function CarouselItem(param) {
    var item = param.item;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyLoadImage/* default */.Z, {
        src: item,
        sx: {
            maxHeight: 225
        }
    });
}

// EXTERNAL MODULE: ./src/@common/services/db/notifications/index.js
var notifications = __webpack_require__(90579);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(90133);
;// CONCATENATED MODULE: ./src/@common/core/AppNotificationsReflect/NotificationItem.js












var NotificationItem = function(props) {
    var item = props.item;
    return(// <Link
    //   sx={{
    //     all: 'unset',
    //     cursor: 'pointer',
    //   }}
    //   href={`/chi-tiet-phan-anh/${item.slug}`}
    // >
    //   <a style={{all: 'unset'}}>
    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/chi-tiet-phan-anh/".concat(item.slug),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
            sx: {
                all: "unset",
                cursor: "pointer"
            },
            href: "/chi-tiet-phan-anh/".concat(item.slug),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                    sx: {
                        padding: "4px 20px"
                    },
                    className: "item-hover",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            fontSize: 14,
                            color: function(theme) {
                                return theme.palette.text.secondary;
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                    component: "span",
                                    sx: {
                                        fontSize: 14,
                                        fontWeight: AppEnums/* Fonts.MEDIUM */.F3.MEDIUM,
                                        mb: 0,
                                        color: function(theme) {
                                            return theme.palette.text.primary;
                                        },
                                        mr: 1,
                                        display: "inline-block",
                                        cursor: "pointer",
                                        "&:hover": {
                                            color: function(theme) {
                                                return theme.palette.secondary.mauExtension;
                                            }
                                        }
                                    },
                                    children: item.phanAnhKienNghi
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: item.maTrangThai === defaultConfig/* numberStatus.choTiepNhan */.Hz.choTiepNhan ? {
                                        color: defaultConfig/* colorStatus.choTiepNhan */.Cf.choTiepNhan
                                    } : item.maTrangThai === defaultConfig/* numberStatus.daTiepNhan */.Hz.daTiepNhan ? {
                                        color: defaultConfig/* colorStatus.daTiepNhan */.Cf.daTiepNhan
                                    } : item.maTrangThai === defaultConfig/* numberStatus.daXuLy */.Hz.daXuLy ? {
                                        color: defaultConfig/* colorStatus.daXuLy */.Cf.daXuLy
                                    } : {
                                        color: defaultConfig/* colorStatus.daTuChoi */.Cf.daTuChoi
                                    },
                                    children: item.thongBao
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                    color: "#C7262E"
                })
            ]
        })
    }));
};
/* harmony default export */ var AppNotificationsReflect_NotificationItem = (NotificationItem);
NotificationItem.propTypes = {
    item: (prop_types_default()).object.isRequired
};

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/CancelOutlined.js
var CancelOutlined = __webpack_require__(8549);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/NotificationsActive.js
var NotificationsActive = __webpack_require__(70781);
;// CONCATENATED MODULE: ./src/@common/core/AppNotificationsReflect/AppNotificationContent.js

















var AppNotificationContent = function(param) {
    var onClose = param.onClose, sxStyle = param.sxStyle, reflectNotificationNoFilter = param.reflectNotificationNoFilter;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        sx: (0,src_object_spread/* default */.Z)({
            display: "flex",
            flexDirection: "column",
            width: 320,
            height: "100%"
        }, sxStyle),
        children: reflectNotificationNoFilter && (reflectNotificationNoFilter === null || reflectNotificationNoFilter === void 0 ? void 0 : reflectNotificationNoFilter.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    sx: {
                        padding: "0px 20px",
                        display: "flex",
                        alignItems: "center",
                        borderBottom: 1,
                        backgroundColor: function(theme) {
                            return theme.palette.primary.main;
                        },
                        color: "white",
                        borderBottomColor: function(theme) {
                            return theme.palette.primary.main;
                        },
                        height: 50
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            component: "h3",
                            variant: "h3",
                            children: "Phản \xe1nh kiến nghị"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                            sx: {
                                height: 40,
                                width: 40,
                                marginLeft: "auto",
                                color: "white"
                            },
                            onClick: onClose,
                            size: "large",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelOutlined/* default */.Z, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    sx: {
                        padding: "5px 20px",
                        display: "flex",
                        alignItems: "center",
                        backgroundColor: function(theme) {
                            return theme.palette.primary.main;
                        },
                        color: "white",
                        borderBottomColor: function(theme) {
                            return theme.palette.primary.main;
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationsActive/* default */.Z, {}),
                        "(",
                        reflectNotificationNoFilter === null || reflectNotificationNoFilter === void 0 ? void 0 : reflectNotificationNoFilter.length,
                        ")"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(core_AppScrollbar/* default */.Z, {
                    sx: {
                        height: {
                            xs: "calc(100% - 96px)",
                            sm: "calc(100% - 110px)"
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                        sx: {
                            py: 0
                        },
                        children: reflectNotificationNoFilter.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppNotificationsReflect_NotificationItem, {
                                item: item
                            }, item.id);
                        })
                    })
                }),
                (reflectNotificationNoFilter === null || reflectNotificationNoFilter === void 0 ? void 0 : reflectNotificationNoFilter.length) > 0 && // <Link
                //   sx={{
                //     all: 'unset',
                //     cursor: 'pointer',
                //   }}
                //   href={`/phan-anh-thong-bao`}
                // >
                //   <a style={{all: 'unset'}}>
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/phan-anh-thong-bao",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            all: "unset",
                            cursor: "pointer"
                        },
                        href: "/phan-anh-thong-bao",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            sx: {
                                borderRadius: 0,
                                width: "100%",
                                textTransform: "capitalize",
                                marginTop: "auto",
                                height: 40
                            },
                            variant: "contained",
                            color: "primary",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utility_IntlMessages/* default */.Z, {
                                id: "common.viewAll"
                            })
                        })
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
            sx: {
                padding: "5px 20px",
                display: "flex",
                alignItems: "center",
                minHeight: {
                    xs: 56,
                    sm: 70
                }
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                component: "h3",
                variant: "h3",
                children: "Kh\xf4ng c\xf3 th\xf4ng b\xe1o"
            })
        })
    });
};
/* harmony default export */ var AppNotificationsReflect_AppNotificationContent = (AppNotificationContent);
AppNotificationContent.propTypes = {
    onClose: (prop_types_default()).func,
    sxStyle: (prop_types_default()).object,
    reflectNotificationNoFilter: (prop_types_default()).any
};

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/NotificationsNone.js
var NotificationsNone = __webpack_require__(6337);
;// CONCATENATED MODULE: ./src/@common/core/AppNotificationsReflect/index.js













var AppNotificationsReflect = function(param) {
    var drawerPosition = param.drawerPosition, tooltipPosition = param.tooltipPosition, isMenu = param.isMenu, sxNotificationContentStyle = param.sxNotificationContentStyle;
    var ref = (0,react.useState)(false), showNotification = ref[0], setShowNotification = ref[1];
    var reflectNotificationNoFilter = (0,es/* useSelector */.v9)(function(param) {
        var reflectApp = param.reflectApp;
        return reflectApp;
    }).reflectNotificationNoFilter;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isMenu ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                component: "span",
                onClick: function() {
                    return setShowNotification(true);
                },
                children: "Message"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppTooltip/* default */.Z, {
                    title: "Th\xf4ng b\xe1o phản \xe1nh",
                    placement: tooltipPosition,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                        className: "icon-btn",
                        sx: {
                            borderRadius: "50%",
                            width: 40,
                            height: 40,
                            color: function(theme) {
                                return theme.palette.text.secondary;
                            },
                            backgroundColor: function(theme) {
                                return theme.palette.background.default;
                            },
                            border: 1,
                            borderColor: "transparent",
                            "&:hover, &:focus": {
                                color: function(theme) {
                                    return theme.palette.text.primary;
                                },
                                backgroundColor: function(theme) {
                                    return (0,colorManipulator/* alpha */.Fq)(theme.palette.background.default, 0.9);
                                },
                                borderColor: function(theme) {
                                    return (0,colorManipulator/* alpha */.Fq)(theme.palette.text.secondary, 0.25);
                                }
                            }
                        },
                        onClick: function() {
                            return setShowNotification(true);
                        },
                        size: "large",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                            badgeContent: reflectNotificationNoFilter === null || reflectNotificationNoFilter === void 0 ? void 0 : reflectNotificationNoFilter.length,
                            color: "secondary",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationsNone/* default */.Z, {})
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer_Drawer/* default */.ZP, {
                anchor: drawerPosition,
                open: showNotification,
                onClose: function() {
                    return setShowNotification(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppNotificationsReflect_AppNotificationContent, {
                    sxStyle: sxNotificationContentStyle,
                    onClose: function() {
                        return setShowNotification(false);
                    },
                    reflectNotificationNoFilter: reflectNotificationNoFilter
                })
            })
        ]
    });
};
/* harmony default export */ var core_AppNotificationsReflect = (AppNotificationsReflect);
AppNotificationsReflect.defaultProps = {
    drawerPosition: "right",
    tooltipPosition: "bottom"
};
AppNotificationsReflect.propTypes = {
    drawerPosition: (prop_types_default()).string,
    tooltipPosition: (prop_types_default()).string,
    isMenu: (prop_types_default()).bool,
    sxNotificationContentStyle: (prop_types_default()).object
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/HorDefault/AppBanner/index.js
/* eslint-disable react/prop-types */ 
























var useStyles = (0,makeStyles/* default */.Z)(function() {
    return {
        carousel: {
            "& img": {
                maxWidth: "100%",
                maxHeight: "100%"
            }
        }
    };
});
var AppBanner = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var theme = (0,useTheme/* default */.Z)();
    var dataBanner = (0,es/* useSelector */.v9)(function(param) {
        var bannerApp = param.bannerApp;
        return bannerApp.bannerListClient.top;
    });
    var dataFooter = (0,es/* useSelector */.v9)(function(param) {
        var customerApp = param.customerApp;
        return customerApp.dataFooter;
    });
    var layoutClient = (0,es/* useSelector */.v9)(function(param) {
        var layoutClientApp = param.layoutClientApp;
        return layoutClientApp.layoutClientList;
    });
    var isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("sm"));
    var isLoadBannerClient = (0,es/* useSelector */.v9)(function(param) {
        var bannerApp = param.bannerApp;
        return bannerApp.isLoadBannerClient;
    });
    var isAuthenticated = (0,es/* useSelector */.v9)(function(param) {
        var authentication = param.authentication;
        return authentication.isAuthenticated;
    });
    var listBlog = (0,es/* useSelector */.v9)(function(param) {
        var lawDisseminationApp = param.lawDisseminationApp;
        return lawDisseminationApp.listBlog;
    });
    if (!dataBanner) return null;
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                lgUp: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Toolbar/* default */.Z, {
                    sx: {
                        boxSizing: "border-box",
                        minHeight: {
                            xs: 56,
                            sm: 70
                        },
                        px: {
                            xs: 0
                        },
                        borderBottom: function(theme) {
                            return "solid 1px ".concat(theme.palette.divider);
                        },
                        background: function(theme) {
                            return theme.palette.secondary.mauExtension;
                        },
                        filter: Array.isArray(layoutClient) && layoutClient.length > 0 && layoutClient.filter(function(x) {
                            return x.sectionName === AppEnums/* ElementSection.GRAYBACKGROUND */.Pw.GRAYBACKGROUND && x.isDisplay;
                        }).length > 0 ? "grayscale(100%)" : "unset"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        sx: {
                            width: "100%",
                            maxWidth: {
                                lg: 1140,
                                xl: 1420
                            },
                            mx: "auto",
                            px: 5,
                            display: "flex",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                                sx: {
                                    marginRight: function(theme) {
                                        return theme.spacing(1);
                                    },
                                    color: "text.secondary"
                                },
                                edge: "start",
                                className: "menu-btn",
                                color: "inherit",
                                "aria-label": "open drawer",
                                onClick: function() {
                                    return dispatch((0,actions/* toggleNavCollapsed */.xd)());
                                },
                                size: "large",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                                    sx: {
                                        width: 35,
                                        height: 35,
                                        color: "white"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h6",
                                sx: {
                                    color: function(theme) {
                                        return theme.palette.secondary.yellowCongAn;
                                    },
                                    fontWeight: AppEnums/* Fonts.BOLD */.F3.BOLD,
                                    fontSize: {
                                        xs: 13
                                    }
                                },
                                children: "C\xd4NG AN TH\xc0NH PHỐ HUẾ"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    ml: isMobile ? "auto" : "none"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyLoadImage/* default */.Z, {
                                    src: "assets/images/quocHuy.png",
                                    sx: {
                                        height: 32,
                                        width: 40,
                                        marginLeft: 4,
                                        right: 0
                                    }
                                })
                            }),
                            isAuthenticated && listBlog && listBlog.find(function(x) {
                                return x.tenDanhMuc === "PHẢN \xc1NH KIẾN NGHỊ";
                            }) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        sx: {
                                            mx: 2
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(core_AppNotificationsReflect, {
                                        sx: {
                                            height: 50,
                                            width: 60
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                lgDown: true,
                children: isLoadBannerClient && dataBanner.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AppSkeleton_BannerSkeleton, {
                    sx: {
                        filter: Array.isArray(layoutClient) && layoutClient.length > 0 && layoutClient.filter(function(x) {
                            return x.sectionName === AppEnums/* ElementSection.GRAYBACKGROUND */.Pw.GRAYBACKGROUND && x.isDisplay;
                        }).length > 0 ? "grayscale(100%)" : "unset"
                    }
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        maxHeight: {
                            xl: 250
                        },
                        // backgroundColor: (theme) => theme.palette.background.default,
                        backgroundImage: function(theme) {
                            return "linear-gradient(to top, #790303 2%,#DB080D 45%)";
                        },
                        filter: Array.isArray(layoutClient) && layoutClient.length > 0 && layoutClient.filter(function(x) {
                            return x.sectionName === AppEnums/* ElementSection.GRAYBACKGROUND */.Pw.GRAYBACKGROUND && x.isDisplay;
                        }).length > 0 ? "grayscale(100%)" : "unset"
                    },
                    children: dataBanner.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            position: "relative",
                            maxHeight: {
                                xl: 230
                            },
                            py: 1
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: (_obj = {
                                    position: "absolute",
                                    zIndex: 9,
                                    top: 0,
                                    width: {
                                        lg: 1130,
                                        xl: 1130
                                    },
                                    left: "50%"
                                }, (0,_define_property/* default */.Z)(_obj, "top", "50%"), (0,_define_property/* default */.Z)(_obj, "transform", "translate(-50%, -50%)"), (0,_define_property/* default */.Z)(_obj, "pl", 2), _obj),
                                children: dataFooter && dataFooter.logoChinhFilePath ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyLoadImage/* default */.Z, {
                                    src: dataFooter.logoChinhFilePath
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyLoadImage/* default */.Z, {
                                    src: "/assets/images/new_logo_catp.png"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    width: "100%",
                                    mx: "auto",
                                    maxWidth: {
                                        xl: 1134,
                                        lg: 1134
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                    sx: {
                                        maxWidth: {
                                            xl: 880,
                                            md: 880
                                        },
                                        ml: {
                                            xl: 62,
                                            lg: 62
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselBasic, {
                                        _carousels: dataBanner
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var HorDefault_AppBanner = (AppBanner);
AppBanner.defaultProps = {
    cityData: []
};
AppBanner.propTypes = {
    cityData: (prop_types_default()).array
};

;// CONCATENATED MODULE: ./src/@common/core/AppScrollToTop/index.js






function scrollToTop() {
    var smooth = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if (smooth) {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    } else {
        document.documentElement.scrollTop = 0;
    }
}
var AppScrollToTop = function(_param) {
    var _top = _param.top, top = _top === void 0 ? 20 : _top, _className = _param.className, className = _className === void 0 ? "" : _className, _color = _param.color, color = _color === void 0 ? "black" : _color, _smooth = _param.smooth, smooth = _smooth === void 0 ? false : _smooth, _component = _param.component, component = _component === void 0 ? "" : _component, _viewBox = _param.viewBox, viewBox = _viewBox === void 0 ? "0 0 256 256" : _viewBox, _svgPath = _param.svgPath, svgPath = _svgPath === void 0 ? "M222.138,91.475l-89.6-89.6c-2.5-2.5-6.551-2.5-9.051,0l-89.6,89.6c-2.5,2.5-2.5,6.551,0,9.051s6.744,2.5,9.244,0L122,21.85  V249.6c0,3.535,2.466,6.4,6,6.4s6-2.865,6-6.4V21.85l78.881,78.676c1.25,1.25,2.992,1.875,4.629,1.875s3.326-0.625,4.576-1.875  C224.586,98.025,224.638,93.975,222.138,91.475z" : _svgPath, _width = _param.width, width = _width === void 0 ? "28" : _width, _height = _param.height, height = _height === void 0 ? "28" : _height, props = (0,_object_without_properties/* default */.Z)(_param, [
        "top",
        "className",
        "color",
        "smooth",
        "component",
        "viewBox",
        "svgPath",
        "width",
        "height"
    ]);
    var ref = (0,react.useState)(false), visible = ref[0], setVisible = ref[1];
    (0,react.useEffect)(function() {
        var onScroll = function() {
            setVisible(document.documentElement.scrollTop >= top);
        };
        onScroll();
        document.addEventListener("scroll", onScroll);
        return function() {
            return document.removeEventListener("scroll", onScroll);
        };
    }, [
        top
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: visible && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            className: "scroll-to-top ".concat(className),
            onClick: function() {
                return scrollToTop(smooth);
            },
            "aria-label": "Scroll to top"
        }, props), {
            children: component || /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                width: width,
                height: height,
                fill: color,
                viewBox: viewBox,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: svgPath
                })
            })
        }))
    });
};
AppScrollToTop.propTypes = {
    className: (prop_types_default()).string,
    color: (prop_types_default()).string,
    component: (prop_types_default()).string,
    height: (prop_types_default()).string,
    smooth: (prop_types_default()).bool,
    svgPath: (prop_types_default()).string,
    top: (prop_types_default()).number,
    viewBox: (prop_types_default()).string,
    width: (prop_types_default()).string
};
/* harmony default export */ var core_AppScrollToTop = (AppScrollToTop);

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/HorDefault/AppBanner/AppBannerBottom.js





function AppBannerBottom() {
    var dataBanner = (0,es/* useSelector */.v9)(function(param) {
        var bannerApp = param.bannerApp;
        return bannerApp.bannerListClient.bottom;
    });
    if (!dataBanner || !(Array.isArray(dataBanner) && dataBanner.length > 0)) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        sx: {
            py: 0,
            borderRadius: 1,
            pb: 1,
            px: 1
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyLoadImage/* default */.Z, {
            src: dataBanner[0],
            sx: {
                height: 140,
                objectFit: "cover"
            }
        })
    });
}
AppBannerBottom.propTypes = {};
/* harmony default export */ var AppBanner_AppBannerBottom = ((/* unused pure expression or super */ null && (AppBannerBottom)));

// EXTERNAL MODULE: ./src/@common/core/AppIconButton/index.js
var AppIconButton = __webpack_require__(37808);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/@common/utility/FormatTime.js
var FormatTime = __webpack_require__(47165);
;// CONCATENATED MODULE: ./src/@common/core/AppWeather/index.js










function AppWeather(props) {
    var url = "https://api.shecodes.io/weather/v1/current?";
    var apikey = "342951afb0fafa28b3f533o92049314t";
    var ref = (0,react.useState)("Huế"), city = ref[0], setCity = ref[1];
    var ref1 = (0,react.useState)(null), weather = ref1[0], setWeather = ref1[1];
    var weatherURL = function(city) {
        var nameCity = city.toUpperCase();
        return "".concat(url, "&query=").concat(nameCity, "&key=").concat(apikey, "&lang=vi&units=metric");
    };
    var getWeather = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(city) {
            var response, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return fetch(weatherURL(city));
                    case 2:
                        response = _ctx.sent;
                        _ctx.next = 5;
                        return response.json();
                    case 5:
                        data = _ctx.sent;
                        setWeather(data);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getWeather(city) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        getWeather(city);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        children: weather ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
            sx: {
                display: "flex",
                alignContent: "center",
                alignItems: "center",
                maxHeight: 20,
                minWidth: 200
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-end",
                        alignContent: "center",
                        py: 2
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h5",
                            color: "text.secondary",
                            sx: {
                                fontSize: {
                                    xl: 13,
                                    lg: 11
                                }
                            },
                            children: "Huế"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            color: "text.secondary",
                            sx: {
                                fontSize: {
                                    xl: 12,
                                    lg: 10
                                },
                                color: function(theme) {
                                    return theme.palette.secondary.mauExtension;
                                },
                                fontWeight: AppEnums/* Fonts.BOLD */.F3.BOLD
                            },
                            children: (0,FormatTime/* getToDay */.Ul)()
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        alignContent: "center",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                            alt: "icon",
                            src: weather.condition.icon_url,
                            sx: {
                                width: 33,
                                height: 33
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                px: 1
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "h5",
                            color: "text.secondary",
                            sx: {
                                fontSize: {
                                    xl: 13,
                                    lg: 12
                                }
                            },
                            children: [
                                Math.round(weather.temperature.feels_like || weather.temperature.current),
                                " ",
                                "\xb0C"
                            ]
                        })
                    ]
                })
            ]
        }) : null
    });
}
AppWeather.propTypes = {};
/* harmony default export */ var core_AppWeather = (AppWeather);

;// CONCATENATED MODULE: ./src/@common/core/AppFastMarquee/index.js






var AppFastMarquee = function(param) {
    var _style = param.style, style = _style === void 0 ? {} : _style, _className = param.className, className = _className === void 0 ? "" : _className, _play = param.play, play = _play === void 0 ? true : _play, _pauseOnHover = param.pauseOnHover, pauseOnHover = _pauseOnHover === void 0 ? false : _pauseOnHover, _pauseOnClick = param.pauseOnClick, pauseOnClick = _pauseOnClick === void 0 ? false : _pauseOnClick, _direction = param.direction, direction = _direction === void 0 ? "left" : _direction, _speed = param.speed, speed = _speed === void 0 ? 20 : _speed, _delay = param.delay, delay = _delay === void 0 ? 0 : _delay, _loop = param.loop, loop = _loop === void 0 ? 0 : _loop, _gradient = param.gradient, gradient = _gradient === void 0 ? true : _gradient, _gradientColor = param.gradientColor, gradientColor = _gradientColor === void 0 ? [
        255,
        255,
        255
    ] : _gradientColor, _gradientWidth = param.gradientWidth, gradientWidth = _gradientWidth === void 0 ? 200 : _gradientWidth, onFinish = param.onFinish, onCycleComplete = param.onCycleComplete, children = param.children;
    // React Hooks
    var ref = (0,react.useState)(0), containerWidth = ref[0], setContainerWidth = ref[1];
    var ref1 = (0,react.useState)(0), marqueeWidth = ref1[0], setMarqueeWidth = ref1[1];
    var ref2 = (0,react.useState)(false), isMounted = ref2[0], setIsMounted = ref2[1];
    var containerRef = (0,react.useRef)(null);
    var marqueeRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (!isMounted) return;
        var calculateWidth = function() {
            if (marqueeRef.current && containerRef.current) {
                setContainerWidth(containerRef.current.getBoundingClientRect().width);
                setMarqueeWidth(marqueeRef.current.getBoundingClientRect().width);
            }
        };
        calculateWidth();
        window.addEventListener("resize", calculateWidth);
        return function() {
            window.removeEventListener("resize", calculateWidth);
        };
    }, [
        isMounted
    ]);
    (0,react.useEffect)(function() {
        setIsMounted(true);
    }, []);
    var rgbaGradientColor = "rgba(".concat(gradientColor[0], ", ").concat(gradientColor[1], ", ").concat(gradientColor[2]);
    var duration = marqueeWidth < containerWidth ? containerWidth / speed : marqueeWidth / speed;
    var _obj, _obj1, _obj2, _obj3;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: !isMounted ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            ref: containerRef,
            style: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, style), (_obj = {}, (0,_define_property/* default */.Z)(_obj, "--pause-on-hover", !play || pauseOnHover ? "paused" : "running"), (0,_define_property/* default */.Z)(_obj, "--pause-on-click", !play || pauseOnHover && !pauseOnClick || pauseOnClick ? "paused" : "running"), _obj)),
            className: className + " marquee-container",
            children: [
                gradient && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, "--gradient-color", "".concat(rgbaGradientColor, ", 1), ").concat(rgbaGradientColor, ", 0)")), (0,_define_property/* default */.Z)(_obj1, "--gradient-width", typeof gradientWidth === "number" ? "".concat(gradientWidth, "px") : gradientWidth), _obj1),
                    className: "overlay"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: marqueeRef,
                    style: (_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, "--play", play ? "running" : "paused"), (0,_define_property/* default */.Z)(_obj2, "--direction", direction === "left" ? "normal" : "reverse"), (0,_define_property/* default */.Z)(_obj2, "--duration", "".concat(duration, "s")), (0,_define_property/* default */.Z)(_obj2, "--delay", "".concat(delay, "s")), (0,_define_property/* default */.Z)(_obj2, "--iteration-count", !!loop ? "".concat(loop) : "infinite"), _obj2),
                    className: "marquee",
                    onAnimationIteration: onCycleComplete,
                    onAnimationEnd: onFinish,
                    children: children
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: (_obj3 = {}, (0,_define_property/* default */.Z)(_obj3, "--play", play ? "running" : "paused"), (0,_define_property/* default */.Z)(_obj3, "--direction", direction === "left" ? "normal" : "reverse"), (0,_define_property/* default */.Z)(_obj3, "--duration", "".concat(duration, "s")), (0,_define_property/* default */.Z)(_obj3, "--delay", "".concat(delay, "s")), (0,_define_property/* default */.Z)(_obj3, "--iteration-count", !!loop ? "".concat(loop) : "infinite"), _obj3),
                    className: "marquee",
                    "aria-hidden": "true",
                    children: children
                })
            ]
        })
    });
};
AppFastMarquee.propTypes = {
    children: (prop_types_default()).any,
    className: (prop_types_default()).string,
    delay: (prop_types_default()).number,
    direction: (prop_types_default()).string,
    gradient: (prop_types_default()).bool,
    gradientColor: (prop_types_default()).array,
    gradientWidth: (prop_types_default()).number,
    loop: (prop_types_default()).number,
    onCycleComplete: (prop_types_default()).any,
    onFinish: (prop_types_default()).any,
    pauseOnClick: (prop_types_default()).bool,
    pauseOnHover: (prop_types_default()).bool,
    play: (prop_types_default()).bool,
    speed: (prop_types_default()).number,
    style: (prop_types_default()).object
};
/* harmony default export */ var core_AppFastMarquee = ((/* unused pure expression or super */ null && (AppFastMarquee)));

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/HorDefault/NotificationBar/index.js














var NotificationBar = function() {
    var isAuthenticated = (0,es/* useSelector */.v9)(function(param) {
        var authentication = param.authentication;
        return authentication.isAuthenticated;
    });
    var listBlog = (0,es/* useSelector */.v9)(function(param) {
        var lawDisseminationApp = param.lawDisseminationApp;
        return lawDisseminationApp.listBlog;
    });
    var activities = (0,es/* useSelector */.v9)(function(param) {
        var activityApp = param.activityApp;
        return activityApp.activitiesClient;
    });
    var layoutClient = (0,es/* useSelector */.v9)(function(param) {
        var layoutClientApp = param.layoutClientApp;
        return layoutClientApp.layoutClientList;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
        lgDown: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
            sx: {
                backgroundColor: function(theme) {
                    return theme.palette.background.paper;
                },
                padding: "2px 0",
                boxShadow: 1,
                borderBottom: "1px solid #e8e8e8",
                filter: Array.isArray(layoutClient) && layoutClient.length > 0 && layoutClient.filter(function(x) {
                    return x.sectionName === AppEnums/* ElementSection.GRAYBACKGROUND */.Pw.GRAYBACKGROUND && x.isDisplay;
                }).length > 0 ? "grayscale(100%)" : "unset"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    width: "100%",
                    maxWidth: {
                        lg: 1420,
                        xl: 1420,
                        sx: 200,
                        sm: 300
                    },
                    mx: "auto",
                    px: {
                        lg: 2,
                        xs: 5
                    },
                    maxHeight: "20vh",
                    display: "flex",
                    alignItems: "center",
                    justifyItems: "flex-start",
                    justifyContent: "space-between"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            pl: {
                                lg: 15
                            },
                            fontWeight: AppEnums/* Fonts.BOLD */.F3.BOLD,
                            "& span": {
                                color: function(theme) {
                                    return theme.palette.primary.main;
                                },
                                textDecoration: "none"
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(core_AppWeather, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        sx: {
                            pl: {
                                lg: 15
                            },
                            display: "flex"
                        },
                        children: [
                            isAuthenticated && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UserInfo, {
                                isView: false,
                                isHome: true,
                                isSticky: false,
                                isClient: true
                            }),
                            isAuthenticated && listBlog && listBlog.find(function(x) {
                                return x.tenDanhMuc === "PHẢN \xc1NH KIẾN NGHỊ";
                            }) && /*#__PURE__*/ (0,jsx_runtime.jsx)(core_AppNotificationsReflect, {})
                        ]
                    }),
                    !isAuthenticated && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            minWidth: "235px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    color: "grey.800"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                    component: "span",
                                    sx: {
                                        "& a": {
                                            color: function(theme) {
                                                return theme.palette.secondary.mauExtension;
                                            },
                                            textDecoration: "none",
                                            cursor: "pointer"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/dang-ky",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                                component: "span",
                                                sx: {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    fontSize: 14,
                                                    fontWeight: AppEnums/* Fonts.MEDIUM */.F3.MEDIUM,
                                                    color: function(theme) {
                                                        return theme.palette.secondary.mauExtension;
                                                    }
                                                },
                                                children: [
                                                    "Đăng k\xfd",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AppIconButton/* default */.Z, {
                                                        "aria-label": "close",
                                                        sx: {
                                                            color: function(theme) {
                                                                return theme.palette.secondary.mauExtension;
                                                            },
                                                            "&:hover": {
                                                                background: "none"
                                                            }
                                                        },
                                                        disableRipple: true,
                                                        disableElevation: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                                            icon: "bx:user-plus",
                                                            sx: {
                                                                fontSize: 20
                                                            }
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    color: "grey.500"
                                },
                                children: "|"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    mx: 2
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                    component: "span",
                                    sx: {
                                        "& a": {
                                            color: function(theme) {
                                                return theme.palette.primary.main;
                                            },
                                            textDecoration: "none",
                                            cursor: "pointer"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/dang-nhap",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                                component: "span",
                                                sx: {
                                                    fontSize: 14,
                                                    alignItems: "center",
                                                    display: "flex",
                                                    fontWeight: AppEnums/* Fonts.MEDIUM */.F3.MEDIUM,
                                                    color: function(theme) {
                                                        return theme.palette.secondary.mauExtension;
                                                    }
                                                },
                                                children: [
                                                    "Đăng nhập",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AppIconButton/* default */.Z, {
                                                        "aria-label": "close",
                                                        sx: {
                                                            color: function(theme) {
                                                                return theme.palette.secondary.mauExtension;
                                                            },
                                                            "&:hover": {
                                                                background: "none"
                                                            }
                                                        },
                                                        disableRipple: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                                            icon: "bx:user",
                                                            sx: {
                                                                fontSize: 20
                                                            }
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var HorDefault_NotificationBar = (NotificationBar);

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/HorDefault/index.js



















var HorDefault = function(param) {
    var children = param.children;
    var ref = (0,LayoutContextProvider/* useLayoutContext */.l5)(), footer = ref.footer, layoutType = ref.layoutType, footerType = ref.footerType;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HorDefault_HorDefaultContainer, {
        className: (0,clsx_m["default"])({
            boxedLayout: layoutType === AppEnums/* LayoutType.BOXED */.ms.BOXED,
            framedLayout: layoutType === AppEnums/* LayoutType.FRAMED */.ms.FRAMED
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HorDefault_HorDefaultWrapper, {
            className: (0,clsx_m["default"])("horDefaultWrapper", {
                appMainFooter: footer && footerType === "fluid",
                appMainFixedFooter: footer && footerType === "fixed"
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HorDefault_AppSidebar, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(core_AppScrollToTop, {
                    smooth: true,
                    color: "#C7262E"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(HorDefault_MainContent, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HorDefault_NotificationBar, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HorDefault_AppBanner, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HorDefault_AppHeader, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AppExtension, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AppContentView/* default */.Z, {
                            children: children
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HorDefault_AppFixedFooter/* default */.Z, {})
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var AppLayout_HorDefault = (HorDefault);
HorDefault.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/HorHeaderFixed/AppFixedFooter/FooterWrapper.js








var HorHeaderFixed_AppFixedFooter_FooterWrapper_FooterWrapper = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            position: "fixed",
            left: 0,
            bottom: 0,
            width: "100%",
            zIndex: 1102,
            boxShadow: "none",
            border: "1px solid #e8e5dd",
            backgroundColor: function(theme) {
                return theme.palette.background.paper;
            },
            backgroundImage: function(theme) {
                return "linear-gradient(".concat((0,colorManipulator/* alpha */.Fq)(theme.palette.common.white, 0.05), ", ").concat((0,colorManipulator/* alpha */.Fq)(theme.palette.common.white, 0.05), ")");
            },
            color: function(theme) {
                return theme.palette.text.primary;
            },
            margin: "0",
            "& .footerContainer": {
                alignItems: "center",
                flexDirection: "row",
                display: "flex",
                padding: {
                    xs: "5px 20px",
                    md: "5px 32px",
                    xl: "10px 32px"
                }
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var HorHeaderFixed_AppFixedFooter_FooterWrapper = (HorHeaderFixed_AppFixedFooter_FooterWrapper_FooterWrapper);
HorHeaderFixed_AppFixedFooter_FooterWrapper_FooterWrapper.propTypes = {
    children: (prop_types_default()).node,
    sidebarHeaderColor: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/HorHeaderFixed/AppFixedFooter/index.js





var HorHeaderFixed_AppFixedFooter_AppFixedFooter = function() {
    var ref = (0,LayoutContextProvider/* useLayoutContext */.l5)(), footer = ref.footer, footerType = ref.footerType;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: footer && footerType === "fixed" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HorHeaderFixed_AppFixedFooter_FooterWrapper, {
            className: "footer fixed-footer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "footerContainer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    children: "Copy right @3si 2022"
                })
            })
        }) : null
    });
};
/* harmony default export */ var HorHeaderFixed_AppFixedFooter = (HorHeaderFixed_AppFixedFooter_AppFixedFooter);

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/HorHeaderFixed/AppHeader/index.js
























var HorHeaderFixed_AppHeader_AppHeader = function() {
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), anchorEl = ref[0], setAnchorEl = ref[1];
    var handleClick = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = (0,SidebarContextProvider/* useSidebarContext */.Sz)(), sidebarMenuSelectedBgColor = ref1.sidebarMenuSelectedBgColor, sidebarMenuSelectedTextColor = ref1.sidebarMenuSelectedTextColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBar/* default */.Z, {
            color: "inherit",
            sx: {
                boxShadow: "none",
                borderBottom: function(theme) {
                    return "solid 1px ".concat(theme.palette.divider);
                },
                backgroundColor: "background.paper",
                width: {
                    xs: "100%"
                }
            },
            className: "app-bar",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Toolbar/* default */.Z, {
                sx: {
                    boxSizing: "border-box",
                    minHeight: {
                        xs: 56,
                        sm: 70
                    },
                    px: {
                        xs: 0
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    sx: {
                        width: "100%",
                        maxWidth: {
                            lg: 1140,
                            xl: 1420
                        },
                        mx: "auto",
                        px: 5,
                        display: "flex",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                            lgUp: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                                sx: {
                                    marginRight: function(theme) {
                                        return theme.spacing(2);
                                    },
                                    color: "text.secondary"
                                },
                                edge: "start",
                                className: "menu-btn",
                                color: "inherit",
                                "aria-label": "open drawer",
                                onClick: function() {
                                    return dispatch((0,actions/* toggleNavCollapsed */.xd)());
                                },
                                size: "large",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                                    sx: {
                                        width: 35,
                                        height: 35
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                mr: 2,
                                "& .app-logo": {
                                    pl: 0
                                },
                                "& .logo-text": {
                                    display: {
                                        xs: "none",
                                        sm: "block"
                                    }
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLogo/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                            lgDown: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    ml: 5,
                                    "& .navbarNav": {
                                        background: "#2596be",
                                        display: "flex",
                                        padding: 0,
                                        mx: {
                                            xs: -4,
                                            lg: -5
                                        },
                                        marginRight: -16
                                    },
                                    "& .navItem": {
                                        width: "auto",
                                        cursor: "pointer",
                                        px: {
                                            xs: 4,
                                            lg: 5
                                        },
                                        py: 1,
                                        borderRadius: 1,
                                        "&.active": {
                                            color: sidebarMenuSelectedTextColor,
                                            backgroundColor: (0,colorManipulator/* alpha */.Fq)(sidebarMenuSelectedBgColor, 0.8),
                                            "& .navLinkIcon": {
                                                color: function(theme) {
                                                    return theme.palette.secondary.main;
                                                }
                                            }
                                        }
                                    },
                                    "& .navLinkIcon": {
                                        mr: 2.5,
                                        color: function(theme) {
                                            return theme.palette.common.white;
                                        },
                                        fontSize: 20
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_HorizontalNav, {})
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                flexGrow: 1
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                minHeight: 40,
                                position: "relative",
                                display: {
                                    xs: "none",
                                    sm: "block"
                                },
                                "& .searchRoot": {
                                    position: {
                                        xs: "absolute",
                                        sm: "relative"
                                    },
                                    right: {
                                        xs: 0,
                                        sm: "auto"
                                    },
                                    top: {
                                        xs: 0,
                                        sm: "auto"
                                    }
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppSearchBar/* default */.Z, {
                                iconPosition: "right",
                                placeholder: "Search…"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                ml: 4
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLngSwitcher/* default */.Z, {
                                iconOnly: true,
                                tooltipPosition: "bottom"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                            sx: {
                                ml: 4,
                                display: "flex",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                                    smDown: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                        sx: {
                                            position: "relative",
                                            display: "flex",
                                            alignItems: "center",
                                            marginLeft: -2,
                                            marginRight: -2
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                                sx: {
                                                    px: 1.85
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppNotifications/* default */.Z, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                                sx: {
                                                    px: 1.85
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppMessages/* default */.Z, {})
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                    sx: {
                                        ml: {
                                            sm: 4
                                        },
                                        mr: {
                                            xs: 4,
                                            sm: 0
                                        },
                                        "& .user-info-view": {
                                            p: 0
                                        },
                                        "& .user-info": {
                                            display: "none"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UserInfo, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                                    smUp: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        sx: {
                                            position: "relative",
                                            display: "flex",
                                            alignItems: "center",
                                            marginLeft: -2,
                                            marginRight: -2
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                            sx: {
                                                px: 1.85
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppTooltip/* default */.Z, {
                                                title: "More",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                                                    sx: {
                                                        borderRadius: "50%",
                                                        width: 40,
                                                        height: 40,
                                                        color: function(theme) {
                                                            return theme.palette.text.secondary;
                                                        },
                                                        backgroundColor: function(theme) {
                                                            return theme.palette.background.default;
                                                        },
                                                        border: 1,
                                                        borderColor: "transparent",
                                                        "&:hover, &:focus": {
                                                            color: function(theme) {
                                                                return theme.palette.text.primary;
                                                            },
                                                            backgroundColor: function(theme) {
                                                                return (0,colorManipulator/* alpha */.Fq)(theme.palette.background.default, 0.9);
                                                            },
                                                            borderColor: function(theme) {
                                                                return (0,colorManipulator/* alpha */.Fq)(theme.palette.text.secondary, 0.25);
                                                            }
                                                        }
                                                    },
                                                    onClick: handleClick,
                                                    size: "large",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreVert/* default */.Z, {})
                                                })
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu_Menu/* default */.Z, {
                                    id: "simple-menu",
                                    anchorEl: anchorEl,
                                    keepMounted: true,
                                    open: Boolean(anchorEl),
                                    onClose: handleClose,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppNotifications/* default */.Z, {
                                                isMenu: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppMessages/* default */.Z, {
                                                isMenu: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                            children: "Setting"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var HorHeaderFixed_AppHeader = (HorHeaderFixed_AppHeader_AppHeader);

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/HorHeaderFixed/AppSidebar/StandardSidebarWrapper.js







var HorHeaderFixed_AppSidebar_StandardSidebarWrapper_StandardSidebarWrapper = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            width: 280,
            display: "flex",
            flexDirection: "column",
            transition: "all 0.5s ease",
            position: "relative",
            top: 0,
            left: 0,
            zIndex: 1101,
            "& .app-sidebar": {
                position: "relative",
                top: "auto",
                left: "auto",
                width: "100%",
                borderRight: "0 none"
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var HorHeaderFixed_AppSidebar_StandardSidebarWrapper = (HorHeaderFixed_AppSidebar_StandardSidebarWrapper_StandardSidebarWrapper);
HorHeaderFixed_AppSidebar_StandardSidebarWrapper_StandardSidebarWrapper.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/HorHeaderFixed/AppSidebar/index.js













var HorHeaderFixed_AppSidebar_AppSidebar = function(props) {
    var dispatch = (0,es/* useDispatch */.I0)();
    var navCollapsed = (0,es/* useSelector */.v9)(function(param) {
        var settings = param.settings;
        return settings.navCollapsed;
    });
    var sidebarTextColor = (0,SidebarContextProvider/* useSidebarContext */.Sz)().sidebarTextColor;
    var handleToggleDrawer = function() {
        dispatch((0,actions/* toggleNavCollapsedHide */.Eh)());
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer_Drawer/* default */.ZP, {
            anchor: props.position,
            open: navCollapsed,
            onClose: function() {
                return handleToggleDrawer();
            },
            classes: {
                root: (0,clsx_m["default"])(props.variant),
                paper: (0,clsx_m["default"])(props.variant)
            },
            style: {
                position: "absolute"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HorHeaderFixed_AppSidebar_StandardSidebarWrapper, {
                className: "standard-sidebar",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_MainSidebar, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UserInfo, {
                            color: sidebarTextColor
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(core_AppScrollbar/* default */.Z, {
                            sx: {
                                py: 2,
                                height: "calc(100vh - 70px) !important"
                            },
                            scrollToTop: false,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_VerticalNav, {})
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var HorHeaderFixed_AppSidebar = (HorHeaderFixed_AppSidebar_AppSidebar);
HorHeaderFixed_AppSidebar_AppSidebar.defaultProps = {
    variant: "",
    position: "left"
};
HorHeaderFixed_AppSidebar_AppSidebar.propTypes = {
    position: (prop_types_default()).string,
    variant: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/HorHeaderFixed/HorHeaderFixedWrapper.js







var HorHeaderFixedWrapper = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            flex: 1,
            display: "flex",
            flexDirection: "row",
            position: "relative",
            backgroundColor: function(theme) {
                return theme.palette.background.default;
            },
            "&.appMainFixedFooter": {
                pb: {
                    xs: 12,
                    xl: 14.5
                }
            },
            "& .customizerOption": {
                top: 210
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var HorHeaderFixed_HorHeaderFixedWrapper = (HorHeaderFixedWrapper);
HorHeaderFixedWrapper.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/HorHeaderFixed/MainContent.js







var HorHeaderFixed_MainContent_MainContent = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            flex: 1,
            display: "flex",
            width: "100%",
            flexDirection: "column",
            position: "relative",
            transition: "all 0.5s ease",
            "& .app-content, & .footerContainer": {
                px: 5,
                width: "100%",
                maxWidth: {
                    lg: 1140,
                    xl: 1420
                },
                mx: "auto"
            }
        },
        className: "mainContent"
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var HorHeaderFixed_MainContent = (HorHeaderFixed_MainContent_MainContent);
HorHeaderFixed_MainContent_MainContent.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/HorHeaderFixed/HorHeaderFixedContainer.js







var HorHeaderFixedContainer = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            position: "relative",
            backgroundColor: function(theme) {
                return theme.palette.background.default;
            },
            pt: {
                xs: 14,
                sm: 17.5
            },
            "&.boxedLayout": {
                maxWidth: {
                    xl: 1480
                },
                mx: {
                    xl: "auto"
                },
                boxShadow: "none",
                borderLeft: "1px solid #e8e5dd",
                borderRight: "1px solid #e8e5dd",
                pt: {
                    xl: 0
                },
                "& .app-bar": {
                    position: {
                        xl: "sticky"
                    }
                },
                "& .mainContent": {
                    position: {
                        xl: "static"
                    }
                },
                "& .fixed-footer": {
                    position: {
                        xl: "sticky"
                    }
                },
                "& .appMainFixedFooter": {
                    pb: {
                        xl: 0
                    }
                }
            },
            "&.framedLayout": {
                padding: {
                    xl: 5
                },
                backgroundColor: function(theme) {
                    return theme.palette.primary.main;
                },
                "& .horHeaderFixedWrapper": {
                    borderRadius: {
                        xl: 3
                    }
                },
                "& .app-bar": {
                    borderTopLeftRadius: {
                        xl: 12
                    },
                    borderTopRightRadius: {
                        xl: 12
                    },
                    overflow: "hidden",
                    position: {
                        xl: "sticky"
                    }
                },
                "& .footer": {
                    borderBottomLeftRadius: {
                        xl: 12
                    },
                    borderBottomRightRadius: {
                        xl: 12
                    }
                },
                "& .mainContent": {
                    position: {
                        xl: "static"
                    }
                },
                "& .fixed-footer": {
                    position: {
                        xl: "sticky"
                    }
                },
                "& .appMainFixedFooter": {
                    pb: {
                        xl: 0
                    }
                }
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var HorHeaderFixed_HorHeaderFixedContainer = (HorHeaderFixedContainer);
HorHeaderFixedContainer.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/HorHeaderFixed/index.js














var HorHeaderFixed = function(param) {
    var children = param.children;
    var ref = (0,LayoutContextProvider/* useLayoutContext */.l5)(), footer = ref.footer, layoutType = ref.layoutType, footerType = ref.footerType;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HorHeaderFixed_HorHeaderFixedContainer, {
        className: (0,clsx_m["default"])({
            boxedLayout: layoutType === AppEnums/* LayoutType.BOXED */.ms.BOXED,
            framedLayout: layoutType === AppEnums/* LayoutType.FRAMED */.ms.FRAMED
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HorHeaderFixed_HorHeaderFixedWrapper, {
            className: (0,clsx_m["default"])("horHeaderFixedWrapper", {
                appMainFooter: footer && footerType === "fluid",
                appMainFixedFooter: footer && footerType === "fixed"
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HorHeaderFixed_AppSidebar, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(HorHeaderFixed_MainContent, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HorHeaderFixed_AppHeader, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AppContentView/* default */.Z, {
                            children: children
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HorHeaderFixed_AppFixedFooter, {})
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var AppLayout_HorHeaderFixed = (HorHeaderFixed);
HorHeaderFixed.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/HorDarkLayout/AppFixedFooter/FooterWrapper.js








var HorDarkLayout_AppFixedFooter_FooterWrapper_FooterWrapper = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            position: "fixed",
            left: 0,
            bottom: 0,
            width: "100%",
            zIndex: 1102,
            boxShadow: "none",
            border: "1px solid #e8e5dd",
            backgroundColor: function(theme) {
                return theme.palette.background.paper;
            },
            backgroundImage: function(theme) {
                return "linear-gradient(".concat((0,colorManipulator/* alpha */.Fq)(theme.palette.common.white, 0.05), ", ").concat((0,colorManipulator/* alpha */.Fq)(theme.palette.common.white, 0.05), ")");
            },
            color: function(theme) {
                return theme.palette.text.primary;
            },
            margin: "0",
            "& .footerContainer": {
                alignItems: "center",
                flexDirection: "row",
                display: "flex",
                padding: {
                    xs: "5px 20px",
                    md: "5px 32px",
                    xl: "10px 32px"
                }
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var HorDarkLayout_AppFixedFooter_FooterWrapper = (HorDarkLayout_AppFixedFooter_FooterWrapper_FooterWrapper);
HorDarkLayout_AppFixedFooter_FooterWrapper_FooterWrapper.propTypes = {
    children: (prop_types_default()).node,
    sidebarHeaderColor: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/HorDarkLayout/AppFixedFooter/index.js







var HorDarkLayout_AppFixedFooter_AppFixedFooter = function() {
    var ref = (0,LayoutContextProvider/* useLayoutContext */.l5)(), footer = ref.footer, footerType = ref.footerType;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: footer && footerType === "fixed" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HorDarkLayout_AppFixedFooter_FooterWrapper, {
            className: "footer fixed-footer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "footerContainer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    children: "Copy right @3si 2022"
                })
            })
        }) : null
    });
};
/* harmony default export */ var HorDarkLayout_AppFixedFooter = (HorDarkLayout_AppFixedFooter_AppFixedFooter);

// EXTERNAL MODULE: ./node_modules/@mui/material/Alert/Alert.js + 5 modules
var Alert = __webpack_require__(10214);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(56974);
;// CONCATENATED MODULE: ./src/@common/core/AppLayout/HorDarkLayout/NotificationBar/index.js










var NotificationBar_NotificationBar = function() {
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(true), 2), open = ref[0], setOpen = ref[1];
    var ref1 = (0,SidebarContextProvider/* useSidebarContext */.Sz)(), sidebarBgColor = ref1.sidebarBgColor, sidebarTextColor = ref1.sidebarTextColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
        in: open,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
            sx: {
                borderBottom: function(theme) {
                    return "solid 1px ".concat((0,colorManipulator/* alpha */.Fq)(theme.palette.common.black, 0.15));
                },
                padding: "2px 0",
                backgroundColor: sidebarBgColor,
                color: sidebarTextColor
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    width: "100%",
                    maxWidth: {
                        lg: 1140,
                        xl: 1420
                    },
                    mx: "auto",
                    px: 5
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                    sx: {
                        backgroundColor: "transparent !important",
                        padding: 0,
                        textAlign: "center",
                        color: "inherit",
                        "& .MuiAlert-message": {
                            flex: 1
                        },
                        "& .MuiAlert-action": {
                            ml: 2.5
                        }
                    },
                    icon: false,
                    action: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                        "aria-label": "close",
                        color: "inherit",
                        size: "small",
                        onClick: function() {
                            setOpen(false);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                            fontSize: "inherit"
                        })
                    }),
                    children: "đ\xe2y l\xe0 th\xf4ng b\xe1o"
                })
            })
        })
    });
};
/* harmony default export */ var HorDarkLayout_NotificationBar = (NotificationBar_NotificationBar);

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/HorDarkLayout/AppHeader/HeaderNavWrapper.js






var HeaderNavWrapper_HeaderNavWrapper = function(param) {
    var children = param.children;
    var ref = (0,SidebarContextProvider/* useSidebarContext */.Sz)(), sidebarBgColor = ref.sidebarBgColor, sidebarTextColor = ref.sidebarTextColor, sidebarMenuSelectedBgColor = ref.sidebarMenuSelectedBgColor, sidebarMenuSelectedTextColor = ref.sidebarMenuSelectedTextColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        sx: {
            backgroundColor: sidebarBgColor,
            color: sidebarTextColor,
            py: 2.5,
            "& .navbarNav": {
                display: "flex",
                padding: 0,
                justifyContent: "center"
            },
            "& .navItem": {
                width: "auto",
                cursor: "pointer",
                py: 1,
                px: {
                    xs: 4,
                    lg: 5
                },
                borderRadius: 1,
                "&.active": {
                    color: sidebarMenuSelectedTextColor,
                    backgroundColor: (0,colorManipulator/* alpha */.Fq)(sidebarMenuSelectedBgColor, 0.8),
                    "& .navLinkIcon": {
                        color: function(theme) {
                            return theme.palette.secondary.main;
                        }
                    }
                }
            },
            "& .navLinkIcon": {
                mr: 2.5,
                color: function(theme) {
                    return theme.palette.common.white;
                },
                fontSize: 20
            }
        },
        children: children
    });
};
/* harmony default export */ var HorDarkLayout_AppHeader_HeaderNavWrapper = (HeaderNavWrapper_HeaderNavWrapper);
HeaderNavWrapper_HeaderNavWrapper.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/HorDarkLayout/AppHeader/index.js


























var HorDarkLayout_AppHeader_AppHeader = function() {
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), anchorEl = ref[0], setAnchorEl = ref[1];
    var ref1 = (0,SidebarContextProvider/* useSidebarContext */.Sz)(), sidebarBgColor = ref1.sidebarBgColor, sidebarTextColor = ref1.sidebarTextColor;
    var handleClick = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppBar/* default */.Z, {
            position: "relative",
            color: "inherit",
            sx: {
                boxShadow: "none",
                width: "100%"
            },
            className: "app-bar",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HorDarkLayout_NotificationBar, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                    lgDown: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HorDarkLayout_AppHeader_HeaderNavWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                width: "100%",
                                maxWidth: {
                                    lg: 1140,
                                    xl: 1436
                                },
                                mx: "auto",
                                px: 5
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_HorizontalNav, {})
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var HorDarkLayout_AppHeader = (HorDarkLayout_AppHeader_AppHeader);

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/HorDarkLayout/AppSidebar/StandardSidebarWrapper.js







var HorDarkLayout_AppSidebar_StandardSidebarWrapper_StandardSidebarWrapper = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            width: 280,
            display: "flex",
            flexDirection: "column",
            transition: "all 0.5s ease",
            position: "relative",
            top: 0,
            left: 0,
            zIndex: 1101,
            "& .app-sidebar": {
                position: "relative",
                top: "auto",
                left: "auto",
                width: "100%",
                borderRight: "0 none"
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var HorDarkLayout_AppSidebar_StandardSidebarWrapper = (HorDarkLayout_AppSidebar_StandardSidebarWrapper_StandardSidebarWrapper);
HorDarkLayout_AppSidebar_StandardSidebarWrapper_StandardSidebarWrapper.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/HorDarkLayout/AppSidebar/index.js













var HorDarkLayout_AppSidebar_AppSidebar = function(props) {
    var dispatch = (0,es/* useDispatch */.I0)();
    var navCollapsed = (0,es/* useSelector */.v9)(function(param) {
        var settings = param.settings;
        return settings.navCollapsed;
    });
    var sidebarTextColor = (0,SidebarContextProvider/* useSidebarContext */.Sz)().sidebarTextColor;
    var handleToggleDrawer = function() {
        dispatch((0,actions/* toggleNavCollapsedHide */.Eh)());
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer_Drawer/* default */.ZP, {
            anchor: props.position,
            open: navCollapsed,
            onClose: function() {
                return handleToggleDrawer();
            },
            classes: {
                root: (0,clsx_m["default"])(props.variant),
                paper: (0,clsx_m["default"])(props.variant)
            },
            style: {
                position: "absolute"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HorDarkLayout_AppSidebar_StandardSidebarWrapper, {
                className: "standard-sidebar",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_MainSidebar, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UserInfo, {
                            color: sidebarTextColor
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(core_AppScrollbar/* default */.Z, {
                            sx: {
                                py: 2,
                                height: "calc(100vh - 70px) !important"
                            },
                            scrollToTop: false,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_VerticalNav, {})
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var HorDarkLayout_AppSidebar = (HorDarkLayout_AppSidebar_AppSidebar);
HorDarkLayout_AppSidebar_AppSidebar.defaultProps = {
    variant: "",
    position: "left"
};
HorDarkLayout_AppSidebar_AppSidebar.propTypes = {
    position: (prop_types_default()).string,
    variant: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/HorDarkLayout/HorDarkWrapper.js







var HorDarkWrapper = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            flex: 1,
            display: "flex",
            flexDirection: "row",
            position: "relative",
            backgroundColor: function(theme) {
                return theme.palette.background.default;
            },
            "&.appMainFixedFooter": {
                pb: {
                    xs: 12,
                    xl: 14.5
                }
            },
            "& .customizerOption": {
                top: 210
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var HorDarkLayout_HorDarkWrapper = (HorDarkWrapper);
HorDarkWrapper.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/HorDarkLayout/MainContent.js







var HorDarkLayout_MainContent_MainContent = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            flex: 1,
            display: "flex",
            width: "100%",
            flexDirection: "column",
            position: "relative",
            transition: "all 0.5s ease",
            "& .app-content, & .footerContainer": {
                px: 5,
                width: "100%",
                maxWidth: {
                    lg: 1140,
                    xl: 1420
                },
                mx: "auto"
            }
        },
        className: "mainContent"
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var HorDarkLayout_MainContent = (HorDarkLayout_MainContent_MainContent);
HorDarkLayout_MainContent_MainContent.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/HorDarkLayout/HorDarkContainer.js







var HorDarkContainer = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            position: "relative",
            backgroundColor: function(theme) {
                return theme.palette.background.default;
            },
            "&.boxedLayout": {
                maxWidth: {
                    xl: 1480
                },
                mx: {
                    xl: "auto"
                },
                boxShadow: "none",
                borderLeft: "1px solid #e8e5dd",
                borderRight: "1px solid #e8e5dd",
                pt: {
                    xl: 0
                },
                "& .mainContent": {
                    position: {
                        xl: "static"
                    }
                },
                "& .fixed-footer": {
                    position: {
                        xl: "sticky"
                    }
                },
                "& .appMainFixedFooter": {
                    pb: {
                        xl: 0
                    }
                }
            },
            "&.framedLayout": {
                padding: {
                    xl: 5
                },
                backgroundColor: function(theme) {
                    return theme.palette.primary.main;
                },
                "& .horDarkWrapper": {
                    borderRadius: {
                        xl: 3
                    }
                },
                "& .app-bar": {
                    borderTopLeftRadius: {
                        xl: 12
                    },
                    borderTopRightRadius: {
                        xl: 12
                    },
                    overflow: "hidden"
                },
                "& .footer": {
                    borderBottomLeftRadius: {
                        xl: 12
                    },
                    borderBottomRightRadius: {
                        xl: 12
                    }
                },
                "& .mainContent": {
                    position: {
                        xl: "static"
                    }
                },
                "& .fixed-footer": {
                    position: {
                        xl: "sticky"
                    }
                },
                "& .appMainFixedFooter": {
                    pb: {
                        xl: 0
                    }
                }
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var HorDarkLayout_HorDarkContainer = (HorDarkContainer);
HorDarkContainer.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/HorDarkLayout/index.js














var HorDarkLayout = function(param) {
    var children = param.children;
    var ref = (0,LayoutContextProvider/* useLayoutContext */.l5)(), footer = ref.footer, layoutType = ref.layoutType, footerType = ref.footerType;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HorDarkLayout_HorDarkContainer, {
        className: (0,clsx_m["default"])({
            boxedLayout: layoutType === AppEnums/* LayoutType.BOXED */.ms.BOXED,
            framedLayout: layoutType === AppEnums/* LayoutType.FRAMED */.ms.FRAMED
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HorDarkLayout_HorDarkWrapper, {
            className: (0,clsx_m["default"])("horDarkWrapper", {
                appMainFooter: footer && footerType === "fluid",
                appMainFixedFooter: footer && footerType === "fixed"
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HorDarkLayout_AppSidebar, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(HorDarkLayout_MainContent, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HorDarkLayout_AppHeader, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AppContentView/* default */.Z, {
                            children: children
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HorDarkLayout_AppFixedFooter, {})
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var AppLayout_HorDarkLayout = (HorDarkLayout);
HorDarkLayout.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/UserHeader/AppSidebar/UserHeaderSidebarWrapper.js







var UserHeaderSidebarWrapper = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            width: 280,
            display: "flex",
            flexDirection: "column",
            transition: "all 0.5s ease",
            position: {
                xs: "relative",
                lg: "fixed"
            },
            top: {
                xs: 0,
                lg: 71
            },
            left: 0,
            zIndex: 1101,
            "& .app-sidebar": {
                position: "relative",
                top: "auto",
                left: "auto",
                width: "100%"
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var AppSidebar_UserHeaderSidebarWrapper = (UserHeaderSidebarWrapper);
UserHeaderSidebarWrapper.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/UserHeader/AppSidebar/index.js













var UserHeader_AppSidebar_AppSidebar = function(props) {
    var dispatch = (0,es/* useDispatch */.I0)();
    var navCollapsed = (0,es/* useSelector */.v9)(function(param) {
        var settings = param.settings;
        return settings.navCollapsed;
    });
    var ref = (0,LayoutContextProvider/* useLayoutContext */.l5)(), footer = ref.footer, footerType = ref.footerType;
    var handleToggleDrawer = function() {
        dispatch((0,actions/* toggleNavCollapsedHide */.Eh)());
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                xlUp: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer_Drawer/* default */.ZP, {
                    anchor: props.position,
                    open: navCollapsed,
                    onClose: function() {
                        return handleToggleDrawer();
                    },
                    classes: {
                        root: (0,clsx_m["default"])(props.variant),
                        paper: (0,clsx_m["default"])(props.variant)
                    },
                    style: {
                        position: "absolute"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppSidebar_UserHeaderSidebarWrapper, {
                        className: "user-header-sidebar",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MainSidebar, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(core_AppScrollbar/* default */.Z, {
                                sx: {
                                    py: 2
                                },
                                scrollToTop: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_VerticalNav, {})
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                lgDown: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppSidebar_UserHeaderSidebarWrapper, {
                    className: "user-header-sidebar",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MainSidebar, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(core_AppScrollbar/* default */.Z, {
                            className: (0,clsx_m["default"])({
                                "has-footer-fixed": footer && footerType === "fixed"
                            }),
                            sx: {
                                py: 2,
                                height: "calc(100vh - 71px) !important",
                                "&.has-footer-fixed": {
                                    height: {
                                        xs: "calc(100vh - 119px) !important",
                                        xl: "calc(100vh - 131px) !important"
                                    }
                                }
                            },
                            scrollToTop: false,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_VerticalNav, {})
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var UserHeader_AppSidebar = (UserHeader_AppSidebar_AppSidebar);
UserHeader_AppSidebar_AppSidebar.defaultProps = {
    variant: "",
    position: "left"
};
UserHeader_AppSidebar_AppSidebar.propTypes = {
    position: (prop_types_default()).string,
    variant: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/UserHeader/AppHeader/index.js
























var UserHeader_AppHeader_AppHeader = function() {
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), anchorEl = ref[0], setAnchorEl = ref[1];
    var messages = (0,useIntl/* default */.Z)().messages;
    var handleClick = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBar/* default */.Z, {
        color: "inherit",
        sx: {
            boxShadow: "none",
            borderBottom: function(theme) {
                return "1px solid ".concat(theme.palette.divider);
            },
            backgroundColor: "background.paper",
            transition: "width 0.5s ease",
            width: "100%"
        },
        className: "app-bar",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Toolbar/* default */.Z, {
            sx: {
                boxSizing: "border-box",
                minHeight: {
                    xs: 56,
                    sm: 70
                },
                paddingLeft: {
                    xs: 2.5,
                    md: 5
                },
                paddingRight: {
                    xs: 2.5,
                    md: 5
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                    lgUp: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                        sx: {
                            color: "text.secondary"
                        },
                        edge: "start",
                        className: "menu-btn",
                        color: "inherit",
                        "aria-label": "open drawer",
                        onClick: function() {
                            return dispatch((0,actions/* toggleNavCollapsed */.xd)());
                        },
                        size: "large",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                            sx: {
                                width: 35,
                                height: 35
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/admin",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            "& .logo-text": {
                                display: {
                                    xs: "none",
                                    sm: "block"
                                }
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLogo/* default */.Z, {})
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        flexGrow: 1
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        minHeight: 40,
                        position: "relative",
                        display: {
                            xs: "none",
                            sm: "block"
                        },
                        "& .searchRoot": {
                            position: {
                                xs: "absolute",
                                sm: "relative"
                            },
                            right: {
                                xs: 0,
                                sm: "auto"
                            },
                            top: {
                                xs: 0,
                                sm: "auto"
                            }
                        }
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        ml: 4
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    sx: {
                        ml: 4,
                        display: "flex",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                            smDown: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                sx: {
                                    position: "relative",
                                    display: "flex",
                                    alignItems: "center",
                                    marginLeft: -2,
                                    marginRight: -2
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        sx: {
                                            px: 1.85
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        sx: {
                                            px: 1.85
                                        }
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                ml: {
                                    sm: 4
                                },
                                mr: {
                                    xs: 4,
                                    sm: 0
                                },
                                minWidth: {
                                    md: 220
                                },
                                "& .user-info-view": {
                                    p: 0
                                },
                                "& .user-info": {
                                    display: {
                                        xs: "none",
                                        md: "block"
                                    }
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UserInfo, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                            smUp: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    position: "relative",
                                    display: "flex",
                                    alignItems: "center",
                                    marginLeft: -2,
                                    marginRight: -2
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                    sx: {
                                        px: 1.85
                                    }
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var UserHeader_AppHeader = (UserHeader_AppHeader_AppHeader);

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/UserHeader/UserHeaderWrapper.js







var UserHeaderWrapper = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            flex: 1,
            display: "flex",
            flexDirection: "column",
            position: "relative",
            backgroundColor: function(theme) {
                return theme.palette.background.default;
            },
            paddingTop: {
                xs: 14,
                sm: 17.5
            },
            "& .mainContent": {
                display: "flex",
                flexDirection: "column",
                position: "relative",
                width: {
                    xs: "100%",
                    lg: "calc(100% - 280px)"
                },
                transition: "all 0.5s ease",
                ml: {
                    lg: "280px"
                }
            },
            "&.appMainFixedFooter": {
                pb: {
                    xs: 12,
                    xl: 14.5
                }
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var UserHeader_UserHeaderWrapper = (UserHeaderWrapper);
UserHeaderWrapper.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/UserHeader/AppFixedFooter/FooterWrapper.js








var UserHeader_AppFixedFooter_FooterWrapper_FooterWrapper = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            position: "fixed",
            left: 0,
            bottom: 0,
            width: "100%",
            zIndex: 1102,
            boxShadow: "none",
            border: "1px solid #e8e5dd",
            backgroundColor: function(theme) {
                return theme.palette.background.paper;
            },
            backgroundImage: function(theme) {
                return "linear-gradient(".concat((0,colorManipulator/* alpha */.Fq)(theme.palette.common.white, 0.05), ", ").concat((0,colorManipulator/* alpha */.Fq)(theme.palette.common.white, 0.05), ")");
            },
            color: function(theme) {
                return theme.palette.text.primary;
            },
            margin: "0",
            "& .footerContainer": {
                alignItems: "center",
                flexDirection: "row",
                display: "flex",
                padding: {
                    xs: "5px 20px",
                    md: "5px 32px",
                    xl: "10px 32px"
                }
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var UserHeader_AppFixedFooter_FooterWrapper = (UserHeader_AppFixedFooter_FooterWrapper_FooterWrapper);
UserHeader_AppFixedFooter_FooterWrapper_FooterWrapper.propTypes = {
    children: (prop_types_default()).node,
    sidebarHeaderColor: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/UserHeader/AppFixedFooter/index.js





var UserHeader_AppFixedFooter_AppFixedFooter = function() {
    var ref = (0,LayoutContextProvider/* useLayoutContext */.l5)(), footer = ref.footer, footerType = ref.footerType;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: footer && footerType === "fixed" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(UserHeader_AppFixedFooter_FooterWrapper, {
            className: "footer fixed-footer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "footerContainer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    children: "Copy right @3si 2022"
                })
            })
        }) : null
    });
};
/* harmony default export */ var UserHeader_AppFixedFooter = (UserHeader_AppFixedFooter_AppFixedFooter);

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/UserHeader/UserHeaderContainer.js







var UserHeaderContainer = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            position: "relative",
            backgroundColor: function(theme) {
                return theme.palette.background.default;
            },
            "&.boxedLayout": {
                maxWidth: {
                    xl: 1480
                },
                mx: {
                    xl: "auto"
                },
                boxShadow: "none",
                borderLeft: "1px solid #e8e5dd",
                borderRight: "1px solid #e8e5dd",
                flexDirection: {
                    xl: "column"
                },
                "& .userHeaderWrapper": {
                    pt: {
                        xl: 0
                    }
                },
                "& .user-header-sidebar": {
                    position: {
                        xl: "sticky"
                    },
                    height: {
                        xl: "100%"
                    },
                    "& [data-simplebar]": {
                        height: {
                            xl: "calc(100vh - 71px) !important"
                        }
                    }
                },
                "& .app-bar": {
                    position: {
                        xl: "sticky"
                    },
                    width: {
                        xl: "100%"
                    }
                },
                "& .mainContent": {
                    position: {
                        xl: "static"
                    },
                    ml: {
                        xl: 0
                    },
                    width: {
                        xl: "100%"
                    },
                    flexDirection: {
                        xl: "row"
                    },
                    flexWrap: {
                        xl: "wrap"
                    }
                },
                "& .fixed-footer": {
                    position: {
                        xl: "sticky"
                    }
                },
                "& .appMainFixedFooter": {
                    pb: {
                        xl: 0
                    },
                    "& .user-header-sidebar": {
                        "& [data-simplebar]": {
                            height: {
                                xl: "calc(100vh - 131px) !important"
                            }
                        }
                    }
                }
            },
            "&.framedLayout": {
                padding: {
                    xl: 5
                },
                backgroundColor: function(theme) {
                    return theme.palette.primary.main;
                },
                "& .userHeaderWrapper": {
                    borderRadius: {
                        xl: 3
                    },
                    pt: {
                        xl: 0
                    }
                },
                "& .user-header-sidebar": {
                    position: {
                        xl: "sticky"
                    },
                    height: {
                        xl: "100%"
                    },
                    borderBottomLeftRadius: {
                        xl: 12
                    },
                    overflow: {
                        xl: "hidden"
                    },
                    "& [data-simplebar]": {
                        height: {
                            xl: "calc(100vh - 100px) !important"
                        }
                    }
                },
                "& .app-bar": {
                    position: {
                        xl: "sticky"
                    },
                    width: {
                        xl: "100%"
                    },
                    borderTopLeftRadius: {
                        xl: 12
                    },
                    borderTopRightRadius: {
                        xl: 12
                    }
                },
                "& .footer": {
                    borderBottomRightRadius: {
                        xl: 12
                    }
                },
                "& .mainContent": {
                    position: {
                        xl: "static"
                    },
                    ml: {
                        xl: 0
                    },
                    width: {
                        xl: "100%"
                    },
                    flexDirection: {
                        xl: "row"
                    },
                    flexWrap: {
                        xl: "wrap"
                    }
                },
                "& .fixed-footer": {
                    position: {
                        xl: "sticky"
                    }
                },
                "& .appMainFixedFooter": {
                    pb: {
                        xl: 0
                    },
                    "& .footer": {
                        borderBottomLeftRadius: {
                            xl: 12
                        }
                    },
                    "& .user-header-sidebar": {
                        "& [data-simplebar]": {
                            height: {
                                xl: "calc(100vh - 151px) !important"
                            }
                        }
                    }
                }
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var UserHeader_UserHeaderContainer = (UserHeaderContainer);
UserHeaderContainer.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/UserHeader/index.js













var UserHeader = function(param) {
    var children = param.children;
    var ref = (0,LayoutContextProvider/* useLayoutContext */.l5)(), footer = ref.footer, layoutType = ref.layoutType, footerType = ref.footerType;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserHeader_UserHeaderContainer, {
        className: (0,clsx_m["default"])({
            boxedLayout: layoutType === AppEnums/* LayoutType.BOXED */.ms.BOXED,
            framedLayout: layoutType === AppEnums/* LayoutType.FRAMED */.ms.FRAMED
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserHeader_UserHeaderWrapper, {
            className: (0,clsx_m["default"])("userHeaderWrapper", {
                appMainFooter: footer && footerType === "fluid",
                appMainFixedFooter: footer && footerType === "fixed"
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UserHeader_AppHeader, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    className: "mainContent",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UserHeader_AppSidebar, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(_common/* AppContentView */.PD, {
                            children: children
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UserHeader_AppFixedFooter, {})
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var AppLayout_UserHeader = (UserHeader);
UserHeader.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/UserMiniHeader/AppSidebar/UserMiniHeaderSidebarWrapper.js







var UserMiniHeaderSidebarWrapper = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            width: 280,
            display: "flex",
            flexDirection: "column",
            transition: "all 0.5s ease",
            position: {
                xs: "relative",
                lg: "fixed"
            },
            top: {
                xs: 0,
                lg: 71
            },
            left: 0,
            zIndex: 1101,
            "& .app-sidebar": {
                position: "relative",
                top: "auto",
                left: "auto",
                width: "100%"
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var AppSidebar_UserMiniHeaderSidebarWrapper = (UserMiniHeaderSidebarWrapper);
UserMiniHeaderSidebarWrapper.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/UserMiniHeader/AppSidebar/index.js













var UserMiniHeader_AppSidebar_AppSidebar = function(props) {
    var dispatch = (0,es/* useDispatch */.I0)();
    var navCollapsed = (0,es/* useSelector */.v9)(function(param) {
        var settings = param.settings;
        return settings.navCollapsed;
    });
    var ref = (0,LayoutContextProvider/* useLayoutContext */.l5)(), footer = ref.footer, footerType = ref.footerType;
    var handleToggleDrawer = function() {
        dispatch((0,actions/* toggleNavCollapsedHide */.Eh)());
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                xlUp: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer_Drawer/* default */.ZP, {
                    anchor: props.position,
                    open: navCollapsed,
                    onClose: function() {
                        return handleToggleDrawer();
                    },
                    classes: {
                        root: (0,clsx_m["default"])(props.variant),
                        paper: (0,clsx_m["default"])(props.variant)
                    },
                    style: {
                        position: "absolute"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppSidebar_UserMiniHeaderSidebarWrapper, {
                        className: "user-mini-header-sidebar",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MainSidebar, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(core_AppScrollbar/* default */.Z, {
                                sx: {
                                    py: 2
                                },
                                scrollToTop: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_VerticalNav, {})
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                lgDown: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppSidebar_UserMiniHeaderSidebarWrapper, {
                    className: "user-mini-header-sidebar",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MainSidebar, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(core_AppScrollbar/* default */.Z, {
                            className: (0,clsx_m["default"])({
                                "has-footer-fixed": footer && footerType === "fixed"
                            }),
                            sx: {
                                py: 2,
                                height: "calc(100vh - 71px) !important",
                                "&.has-footer-fixed": {
                                    height: {
                                        xs: "calc(100vh - 119px) !important",
                                        xl: "calc(100vh - 131px) !important"
                                    }
                                }
                            },
                            scrollToTop: false,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_VerticalNav, {})
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var UserMiniHeader_AppSidebar = (UserMiniHeader_AppSidebar_AppSidebar);
UserMiniHeader_AppSidebar_AppSidebar.defaultProps = {
    variant: "",
    position: "left"
};
UserMiniHeader_AppSidebar_AppSidebar.propTypes = {
    position: (prop_types_default()).string,
    variant: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/UserMiniHeader/AppHeader/index.js






















var UserMiniHeader_AppHeader_AppHeader = function() {
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), anchorEl = ref[0], setAnchorEl = ref[1];
    var handleClick = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBar/* default */.Z, {
        color: "inherit",
        sx: {
            boxShadow: "none",
            borderBottom: function(theme) {
                return "1px solid ".concat(theme.palette.divider);
            },
            backgroundColor: "background.paper",
            transition: "width 0.5s ease",
            width: "100%"
        },
        className: "app-bar",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Toolbar/* default */.Z, {
            sx: {
                boxSizing: "border-box",
                minHeight: {
                    xs: 56,
                    sm: 70
                },
                paddingLeft: {
                    xs: 2.5,
                    md: 5
                },
                paddingRight: {
                    xs: 2.5,
                    md: 5
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                    lgUp: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                        sx: {
                            color: "text.secondary"
                        },
                        edge: "start",
                        className: "menu-btn",
                        color: "inherit",
                        "aria-label": "open drawer",
                        onClick: function() {
                            return dispatch((0,actions/* toggleNavCollapsed */.xd)());
                        },
                        size: "large",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                            sx: {
                                width: 35,
                                height: 35
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        "& .logo-text": {
                            display: {
                                xs: "none",
                                sm: "block"
                            }
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLogo/* default */.Z, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        flexGrow: 1
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        minHeight: 40,
                        position: "relative",
                        display: {
                            xs: "none",
                            sm: "block"
                        },
                        "& .searchRoot": {
                            position: {
                                xs: "absolute",
                                sm: "relative"
                            },
                            right: {
                                xs: 0,
                                sm: "auto"
                            },
                            top: {
                                xs: 0,
                                sm: "auto"
                            }
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppSearchBar/* default */.Z, {
                        iconPosition: "right",
                        placeholder: "Search…"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        ml: 4
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLngSwitcher/* default */.Z, {
                        iconOnly: true,
                        tooltipPosition: "bottom"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    sx: {
                        ml: 4,
                        display: "flex",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                            smDown: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                sx: {
                                    position: "relative",
                                    display: "flex",
                                    alignItems: "center",
                                    marginLeft: -2,
                                    marginRight: -2
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        sx: {
                                            px: 1.85
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppNotifications/* default */.Z, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        sx: {
                                            px: 1.85
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppMessages/* default */.Z, {})
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                ml: {
                                    sm: 4
                                },
                                mr: {
                                    xs: 4,
                                    sm: 0
                                },
                                minWidth: {
                                    md: 220
                                },
                                "& .user-info-view": {
                                    p: 0
                                },
                                "& .user-info": {
                                    display: {
                                        xs: "none",
                                        md: "block"
                                    }
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UserInfo, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                            smUp: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    position: "relative",
                                    display: "flex",
                                    alignItems: "center",
                                    marginLeft: -2,
                                    marginRight: -2
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                    sx: {
                                        px: 1.85
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppTooltip/* default */.Z, {
                                        title: "More",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                                            sx: {
                                                borderRadius: "50%",
                                                width: 40,
                                                height: 40,
                                                color: function(theme) {
                                                    return theme.palette.text.secondary;
                                                },
                                                backgroundColor: function(theme) {
                                                    return theme.palette.background.default;
                                                },
                                                border: 1,
                                                borderColor: "transparent",
                                                "&:hover, &:focus": {
                                                    color: function(theme) {
                                                        return theme.palette.text.primary;
                                                    },
                                                    backgroundColor: function(theme) {
                                                        return (0,colorManipulator/* alpha */.Fq)(theme.palette.background.default, 0.9);
                                                    },
                                                    borderColor: function(theme) {
                                                        return (0,colorManipulator/* alpha */.Fq)(theme.palette.text.secondary, 0.25);
                                                    }
                                                }
                                            },
                                            onClick: handleClick,
                                            size: "large",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreVert/* default */.Z, {})
                                        })
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu_Menu/* default */.Z, {
                            id: "simple-menu",
                            anchorEl: anchorEl,
                            keepMounted: true,
                            open: Boolean(anchorEl),
                            onClose: handleClose,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppNotifications/* default */.Z, {
                                        isMenu: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppMessages/* default */.Z, {
                                        isMenu: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                    children: "Setting"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var UserMiniHeader_AppHeader = (UserMiniHeader_AppHeader_AppHeader);

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/UserMiniHeader/UserMiniHeaderWrapper.js







var UserMiniHeaderWrapper = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            flex: 1,
            display: "flex",
            flexDirection: "column",
            position: "relative",
            backgroundColor: function(theme) {
                return theme.palette.background.default;
            },
            paddingTop: {
                xs: 14,
                sm: 17.5
            },
            "& .mainContent": {
                display: "flex",
                flexDirection: "column",
                position: "relative",
                width: {
                    xs: "100%",
                    lg: "calc(100% - 280px)"
                },
                transition: "all 0.5s ease",
                ml: {
                    lg: "280px"
                }
            },
            "&.mini-sidebar-collapsed": {
                "& .mainContent": {
                    width: {
                        lg: "calc(100% - 64px)"
                    },
                    ml: {
                        lg: "64px"
                    }
                },
                "& .user-mini-header-sidebar:not(:hover)": {
                    width: {
                        lg: 64
                    },
                    "& .nav-item-header, & .nav-item-content, & .menu-badge, & .collapse-children, & .nav-item-icon-arrow-btn": {
                        display: "none"
                    },
                    "& .nav-item-icon": {
                        mr: 0,
                        ml: 0.5
                    }
                },
                "& .menu-vertical-item": {
                    pl: 3,
                    "&.rounded-menu": {
                        mx: 2,
                        pl: 3,
                        borderRadius: 1
                    },
                    "&.rounded-menu-reverse": {
                        mx: 2,
                        pl: 3,
                        borderRadius: 1
                    },
                    "&.standard-menu": {
                        mx: 2,
                        width: "calc(100% - 16px)",
                        pl: 3,
                        borderRadius: 1,
                        "&.active:after": {
                            backgroundColor: "transparent"
                        }
                    },
                    "&.curved-menu": {
                        mx: 2,
                        borderRadius: 1,
                        "&:before, &:after": {
                            display: "none"
                        }
                    }
                },
                "& .menu-vertical-collapse": {
                    pl: 3,
                    mx: 2,
                    width: "calc(100% - 16px)"
                }
            },
            "&.appMainFixedFooter": {
                pb: {
                    xs: 12,
                    xl: 14.5
                }
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var UserMiniHeader_UserMiniHeaderWrapper = (UserMiniHeaderWrapper);
UserMiniHeaderWrapper.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/UserMiniHeader/AppFixedFooter/FooterWrapper.js








var UserMiniHeader_AppFixedFooter_FooterWrapper_FooterWrapper = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            position: "fixed",
            left: 0,
            bottom: 0,
            width: "100%",
            zIndex: 1102,
            boxShadow: "none",
            border: "1px solid #e8e5dd",
            backgroundColor: function(theme) {
                return theme.palette.background.paper;
            },
            backgroundImage: function(theme) {
                return "linear-gradient(".concat((0,colorManipulator/* alpha */.Fq)(theme.palette.common.white, 0.05), ", ").concat((0,colorManipulator/* alpha */.Fq)(theme.palette.common.white, 0.05), ")");
            },
            color: function(theme) {
                return theme.palette.text.primary;
            },
            margin: "0",
            "& .footerContainer": {
                alignItems: "center",
                flexDirection: "row",
                display: "flex",
                padding: {
                    xs: "5px 20px",
                    md: "5px 32px",
                    xl: "10px 32px"
                }
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var UserMiniHeader_AppFixedFooter_FooterWrapper = (UserMiniHeader_AppFixedFooter_FooterWrapper_FooterWrapper);
UserMiniHeader_AppFixedFooter_FooterWrapper_FooterWrapper.propTypes = {
    children: (prop_types_default()).node,
    sidebarHeaderColor: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/UserMiniHeader/AppFixedFooter/index.js





var UserMiniHeader_AppFixedFooter_AppFixedFooter = function() {
    var ref = (0,LayoutContextProvider/* useLayoutContext */.l5)(), footer = ref.footer, footerType = ref.footerType;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: footer && footerType === "fixed" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(UserMiniHeader_AppFixedFooter_FooterWrapper, {
            className: "footer fixed-footer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "footerContainer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    children: "Copy right @3si 2022"
                })
            })
        }) : null
    });
};
/* harmony default export */ var UserMiniHeader_AppFixedFooter = (UserMiniHeader_AppFixedFooter_AppFixedFooter);

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/UserMiniHeader/UserMiniHeaderContainer.js







var UserMiniHeaderContainer = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: {
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            position: "relative",
            backgroundColor: function(theme) {
                return theme.palette.background.default;
            },
            "&.boxedLayout": {
                maxWidth: {
                    xl: 1480
                },
                mx: {
                    xl: "auto"
                },
                boxShadow: "none",
                borderLeft: "1px solid #e8e5dd",
                borderRight: "1px solid #e8e5dd",
                flexDirection: {
                    xl: "column"
                },
                "& .user-mini-header-sidebar": {
                    position: {
                        xl: "sticky"
                    },
                    height: {
                        xl: "100%"
                    },
                    "& [data-simplebar]": {
                        height: {
                            xl: "calc(100vh - 71px) !important"
                        }
                    }
                },
                "& .mini-sidebar-collapsed": {
                    pt: {
                        xl: 0
                    }
                },
                "& .app-bar": {
                    position: {
                        xl: "sticky"
                    },
                    width: {
                        xl: "100%"
                    }
                },
                "& .mainContent": {
                    position: {
                        xl: "static"
                    },
                    ml: {
                        xl: 0
                    },
                    width: {
                        xl: "100%"
                    },
                    flexDirection: {
                        xl: "row"
                    },
                    flexWrap: {
                        xl: "wrap"
                    }
                },
                "& .fixed-footer": {
                    position: {
                        xl: "sticky"
                    }
                },
                "& .appMainFixedFooter": {
                    pb: {
                        xl: 0
                    },
                    "& .user-mini-header-sidebar": {
                        "& [data-simplebar]": {
                            height: {
                                xl: "calc(100vh - 131px) !important"
                            }
                        }
                    }
                }
            },
            "&.framedLayout": {
                padding: {
                    xl: 5
                },
                backgroundColor: function(theme) {
                    return theme.palette.primary.main;
                },
                "& .mini-sidebar-collapsed": {
                    borderRadius: {
                        xl: 3
                    },
                    pt: {
                        xl: 0
                    }
                },
                "& .user-mini-header-sidebar": {
                    position: {
                        xl: "sticky"
                    },
                    height: {
                        xl: "100%"
                    },
                    borderBottomLeftRadius: {
                        xl: 12
                    },
                    overflow: {
                        xl: "hidden"
                    },
                    "& [data-simplebar]": {
                        height: {
                            xl: "calc(100vh - 91px) !important"
                        }
                    }
                },
                "& .app-bar": {
                    position: {
                        xl: "sticky"
                    },
                    width: {
                        xl: "100%"
                    },
                    borderTopLeftRadius: {
                        xl: 12
                    },
                    borderTopRightRadius: {
                        xl: 12
                    }
                },
                "& .footer": {
                    borderBottomRightRadius: {
                        xl: 12
                    }
                },
                "& .mainContent": {
                    position: {
                        xl: "static"
                    },
                    ml: {
                        xl: 0
                    },
                    width: {
                        xl: "100%"
                    },
                    flexDirection: {
                        xl: "row"
                    },
                    flexWrap: {
                        xl: "wrap"
                    }
                },
                "& .fixed-footer": {
                    position: {
                        xl: "sticky"
                    }
                },
                "& .appMainFixedFooter": {
                    pb: {
                        xl: 0
                    },
                    "& .footer": {
                        borderBottomLeftRadius: {
                            xl: 12
                        }
                    },
                    "& .user-mini-header-sidebar": {
                        "& [data-simplebar]": {
                            height: {
                                xl: "calc(100vh - 131px) !important"
                            }
                        }
                    }
                }
            }
        }
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var UserMiniHeader_UserMiniHeaderContainer = (UserMiniHeaderContainer);
UserMiniHeaderContainer.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/UserMiniHeader/index.js














var UserMiniHeader = function(param) {
    var children = param.children;
    var ref = (0,LayoutContextProvider/* useLayoutContext */.l5)(), footer = ref.footer, layoutType = ref.layoutType, footerType = ref.footerType;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserMiniHeader_UserMiniHeaderContainer, {
        className: (0,clsx_m["default"])({
            boxedLayout: layoutType === AppEnums/* LayoutType.BOXED */.ms.BOXED,
            framedLayout: layoutType === AppEnums/* LayoutType.FRAMED */.ms.FRAMED
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserMiniHeader_UserMiniHeaderWrapper, {
            className: (0,clsx_m["default"])("mini-sidebar-collapsed", {
                appMainFooter: footer && footerType === "fluid",
                appMainFixedFooter: footer && footerType === "fixed"
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UserMiniHeader_AppHeader, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    className: "mainContent",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UserMiniHeader_AppSidebar, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(_common/* AppContentView */.PD, {
                            children: children
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UserMiniHeader_AppFixedFooter, {})
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var AppLayout_UserMiniHeader = (UserMiniHeader);
UserMiniHeader.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/@common/core/AppLayout/Layouts.js













var _obj;
var Layouts = (_obj = {}, (0,_define_property/* default */.Z)(_obj, AppEnums/* NavStyle.DEFAULT */.Dt.DEFAULT, AppLayout_DefaultLayout), (0,_define_property/* default */.Z)(_obj, AppEnums/* NavStyle.BIT_BUCKET */.Dt.BIT_BUCKET, AppLayout_BitBucket), (0,_define_property/* default */.Z)(_obj, AppEnums/* NavStyle.STANDARD */.Dt.STANDARD, AppLayout_Standard), (0,_define_property/* default */.Z)(_obj, AppEnums/* NavStyle.DRAWER */.Dt.DRAWER, AppLayout_DrawerLayout), (0,_define_property/* default */.Z)(_obj, AppEnums/* NavStyle.MINI */.Dt.MINI, AppLayout_MiniSidebar), (0,_define_property/* default */.Z)(_obj, AppEnums/* NavStyle.MINI_SIDEBAR_TOGGLE */.Dt.MINI_SIDEBAR_TOGGLE, AppLayout_MiniSidebarToggle), (0,_define_property/* default */.Z)(_obj, AppEnums/* NavStyle.HEADER_USER */.Dt.HEADER_USER, AppLayout_UserHeader), (0,_define_property/* default */.Z)(_obj, AppEnums/* NavStyle.HEADER_USER_MINI */.Dt.HEADER_USER_MINI, AppLayout_UserMiniHeader), (0,_define_property/* default */.Z)(_obj, AppEnums/* NavStyle.H_DEFAULT */.Dt.H_DEFAULT, AppLayout_HorDefault), (0,_define_property/* default */.Z)(_obj, AppEnums/* NavStyle.HOR_HEADER_FIXED */.Dt.HOR_HEADER_FIXED, AppLayout_HorHeaderFixed), (0,_define_property/* default */.Z)(_obj, AppEnums/* NavStyle.HOR_DARK_LAYOUT */.Dt.HOR_DARK_LAYOUT, AppLayout_HorDarkLayout), _obj);
/* harmony default export */ var AppLayout_Layouts = (Layouts);


/***/ }),

/***/ 59500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12307);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _common_core_AppMuiImage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29220);






var AppLogo = function(props) {
    var height = props.height, width = props.width, src = props.src;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
        href: "/",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            sx: {
                padding: 1,
                display: "flex",
                flexDirection: "row",
                cursor: "pointer",
                alignItems: "center",
                justifyContent: "center"
            },
            className: "app-logo",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_core_AppMuiImage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                src: src,
                height: height,
                width: width,
                errorIcon: true
            })
        })
    });
};
AppLogo.propTypes = {
    height: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),
    width: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),
    src: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (AppLogo);
AppLogo.defaultProps = {
    height: 120,
    width: 150,
    src: "/assets/images/logo-cong-an.png"
};


/***/ }),

/***/ 29220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AppMuiImage; }
});

// UNUSED EXPORTS: Image

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(81209);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(50894);
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(83274);
;// CONCATENATED MODULE: ./src/@common/core/AppMuiImage/Image.js










var BrokenImageIcon = (0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
    d: "M21 5v6.59l-2.29-2.3c-.39-.39-1.03-.39-1.42 0L14 12.59 10.71 9.3a.9959.9959 0 0 0-1.41 0L6 12.59 3 9.58V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2zm-3 6.42 3 3.01V19c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-6.58l2.29 2.29c.39.39 1.02.39 1.41 0l3.3-3.3 3.29 3.29c.39.39 1.02.39 1.41 0l3.3-3.28z"
}), "BrokenImageIcon");
var Img = (0,styled/* default */.ZP)("img")({
    "@keyframes materialize": {
        "0%": {
            filter: "saturate(20%) contrast(50%) brightness(120%)"
        },
        "75%": {
            filter: "saturate(60%) contrast(100%) brightness(100%)"
        },
        "100%": {
            filter: "saturate(100%) contrast(100%) brightness(100%)"
        }
    }
});
function Image(props) {
    var handleLoad = function handleLoad() {
        setLoaded(true);
        setError(false);
        if (Boolean(onLoadProp)) onLoadProp();
    };
    var handleError = function handleError() {
        setError(true);
        setLoaded(false);
        if (Boolean(onErrorProp)) onErrorProp();
    };
    var src = props.src, alt = props.alt, height = props.height, width = props.width, position = props.position, fit = props.fit, style = props.style, className = props.className, showLoading = props.showLoading, errorIcon = props.errorIcon, shift = props.shift, distance = props.distance, shiftDuration = props.shiftDuration, bgColor = props.bgColor, wrapperStyle = props.wrapperStyle, iconWrapperStyle = props.iconWrapperStyle, wrapperClassName = props.wrapperClassName, iconWrapperClassName = props.iconWrapperClassName, duration = props.duration, easing = props.easing, ref = props.ref, onLoadProp = props.onLoad, onErrorProp = props.onError, rest = (0,_object_without_properties/* default */.Z)(props, [
        "src",
        "alt",
        "height",
        "width",
        "position",
        "fit",
        "style",
        "className",
        "showLoading",
        "errorIcon",
        "shift",
        "distance",
        "shiftDuration",
        "bgColor",
        "wrapperStyle",
        "iconWrapperStyle",
        "wrapperClassName",
        "iconWrapperClassName",
        "duration",
        "easing",
        "ref",
        "onLoad",
        "onError"
    ]);
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), loaded = ref1[0], setLoaded = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), error = ref2[0], setError = ref2[1];
    var shiftStyles = (0,_define_property/* default */.Z)({}, shift, loaded ? 0 : distance);
    var styles = {
        root: (0,_object_spread/* default */.Z)({
            width: width,
            height: height,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: bgColor
        }, wrapperStyle),
        image: (0,_object_spread/* default */.Z)({
            position: position,
            width: "100%",
            height: "100%",
            objectFit: fit,
            transitionProperty: "".concat(Boolean(shift) ? "".concat(shift, ", ") : "", "opacity"),
            transitionDuration: "".concat(Boolean(shift) ? "".concat(shiftDuration || duration * 0.3, "ms, ") : "").concat(duration / 2, "ms"),
            transitionTimingFunction: easing,
            opacity: loaded ? 1 : 0,
            animation: loaded ? "materialize ".concat(duration, "ms 1 ").concat(easing) : ""
        }, Boolean(shift) && shiftStyles, style),
        icons: (0,_object_spread/* default */.Z)({
            width: "100%",
            marginLeft: "-100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            opacity: loaded ? 0 : 1
        }, iconWrapperStyle)
    };
    var showErrorIcon = typeof errorIcon !== "boolean" && errorIcon || /*#__PURE__*/ (0,jsx_runtime.jsx)(BrokenImageIcon, {
        style: {
            fontSize: 56,
            color: "#bdbdbd"
        }
    }) // MUI grey[400]
    ;
    var loadingIndicator = typeof showLoading !== "boolean" && showLoading || /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
        size: 56,
        thickness: 6
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: styles.root,
        className: "mui-image-wrapper ".concat(wrapperClassName),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Img, (0,_object_spread/* default */.Z)({
                src: src,
                alt: alt,
                style: styles.image,
                className: "mui-image-img ".concat(className),
                onLoad: handleLoad,
                onError: handleError,
                ref: ref
            }, rest)),
            (Boolean(showLoading) || Boolean(errorIcon)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: styles.icons,
                className: "mui-image-iconWrapper ".concat(iconWrapperClassName),
                children: [
                    Boolean(errorIcon) && error && showErrorIcon,
                    Boolean(showLoading) && !error && !loaded && loadingIndicator
                ]
            })
        ]
    });
};
Image.defaultProps = {
    alt: "",
    height: "100%",
    width: "100%",
    position: "relative",
    fit: "cover",
    showLoading: false,
    errorIcon: true,
    shift: false,
    distance: 100,
    shiftDuration: null,
    bgColor: "inherit",
    duration: 3000,
    easing: "cubic-bezier(0.7, 0, 0.6, 1)",
    className: "",
    wrapperClassName: "",
    iconWrapperClassName: "",
    ref: null
};
Image.propTypes = {
    src: (prop_types_default()).string.isRequired,
    alt: (prop_types_default()).string,
    height: prop_types_default().oneOfType([
        (prop_types_default()).number,
        (prop_types_default()).string
    ]),
    width: prop_types_default().oneOfType([
        (prop_types_default()).number,
        (prop_types_default()).string
    ]),
    style: (prop_types_default()).object,
    className: (prop_types_default()).string,
    showLoading: prop_types_default().oneOfType([
        (prop_types_default()).bool,
        (prop_types_default()).node
    ]),
    errorIcon: prop_types_default().oneOfType([
        (prop_types_default()).bool,
        (prop_types_default()).node
    ]),
    shift: prop_types_default().oneOf([
        false,
        null,
        "top",
        "bottom",
        "left",
        "right"
    ]),
    distance: prop_types_default().oneOfType([
        (prop_types_default()).number,
        (prop_types_default()).string
    ]),
    shiftDuration: (prop_types_default()).number,
    bgColor: (prop_types_default()).string,
    wrapperStyle: (prop_types_default()).object,
    iconWrapperStyle: (prop_types_default()).object,
    wrapperClassName: (prop_types_default()).string,
    iconWrapperClassName: (prop_types_default()).string,
    duration: (prop_types_default()).number,
    easing: (prop_types_default()).string,
    onLoad: (prop_types_default()).func,
    onError: (prop_types_default()).func,
    ref: (prop_types_default()).object,
    position: prop_types_default().oneOf([
        "static",
        "relative",
        "absolute",
        "fixed",
        "sticky",
        "inherit",
        "initial",
        "revert",
        "unset", 
    ]),
    fit: prop_types_default().oneOf([
        "contain",
        "cover",
        "fill",
        "none",
        "scale-down",
        "inherit",
        "initial",
        "revert",
        "unset", 
    ])
};

;// CONCATENATED MODULE: ./src/@common/core/AppMuiImage/index.js

/* harmony default export */ var AppMuiImage = (Image);



/***/ }),

/***/ 47165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ul": function() { return /* binding */ getToDay; }
/* harmony export */ });
/* unused harmony exports fDate, fDateTime, fTimestamp, fDateTimeSuffix, fToNow */
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12797);
/* harmony import */ var date_fns_locale_vi__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34215);


// ----------------------------------------------------------------------
function fDate(date) {
    return format(new Date(date), "dd MMMM yyyy");
}
function fDateTime(date) {
    return format(new Date(date), "dd MMM yyyy p");
}
function fTimestamp(date) {
    return getTime(new Date(date));
}
function fDateTimeSuffix(date) {
    return format(new Date(date), "dd/MM/yyyy hh:mm p");
}
function fToNow(date) {
    return formatDistanceToNow(new Date(date), {
        addSuffix: true
    });
}
function getToDay() {
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(Date.now(), "EEEE, dd/MM/yyyy", {
        locale: date_fns_locale_vi__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
    });
}


/***/ }),

/***/ 31691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ asyncComponent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/@common/core/AppSkeleton/MailDetailSkeleton.js





var MailDetailSkeleton = function(props) {
    return /*#__PURE__*/ _jsxs(ContentLoader, _object_spread_props(_object_spread({
        speed: 2,
        backgroundColor: "#f3f3f3",
        height: 600,
        foregroundColor: "#ecebeb"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                x: "100",
                y: "35",
                rx: "3",
                ry: "3",
                width: "188",
                height: "12"
            }),
            /*#__PURE__*/ _jsx("rect", {
                x: "100",
                y: "55",
                rx: "3",
                ry: "3",
                width: "152",
                height: "10"
            }),
            /*#__PURE__*/ _jsx("rect", {
                x: "105",
                y: "106",
                rx: "3",
                ry: "3",
                width: "510",
                height: "8"
            }),
            /*#__PURE__*/ _jsx("rect", {
                x: "105",
                y: "132",
                rx: "3",
                ry: "3",
                width: "480",
                height: "8"
            }),
            /*#__PURE__*/ _jsx("rect", {
                x: "105",
                y: "158",
                rx: "3",
                ry: "3",
                width: "510",
                height: "8"
            }),
            /*#__PURE__*/ _jsx("rect", {
                x: "105",
                y: "178",
                rx: "3",
                ry: "3",
                width: "478",
                height: "8"
            }),
            /*#__PURE__*/ _jsx("rect", {
                x: "105",
                y: "198",
                rx: "3",
                ry: "3",
                width: "510",
                height: "8"
            }),
            /*#__PURE__*/ _jsx("rect", {
                x: "105",
                y: "218",
                rx: "3",
                ry: "3",
                width: "478",
                height: "8"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "50",
                cy: "50",
                r: "25"
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/@common/index.js + 23 modules
var _common = __webpack_require__(84247);
;// CONCATENATED MODULE: ./src/@common/utility/asyncComponent.js





function asyncComponent(importComponent, isHome) {
    return dynamic_default()(importComponent, {
        // loading: () => (!!isHome ? <MailDetailSkeleton /> : <AppLoader />),
        loading: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(_common/* AppLoader */.QP, {});
        },
        ssr: false
    });
};


/***/ }),

/***/ 10988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "YS": function() { return /* binding */ onGetCustomerList; },
  "Yw": function() { return /* binding */ onGetDataFooter; },
  "FN": function() { return /* binding */ onUpdateSelectedCustomer; }
});

// EXTERNAL MODULE: ./src/@common/services/auth/jwt-auth/index.js
var jwt_auth = __webpack_require__(91253);
// EXTERNAL MODULE: ./src/@common/utility/helper/FormHelper.js
var FormHelper = __webpack_require__(95283);
// EXTERNAL MODULE: ./src/@common/utility/helper/ObjectToFormData.js + 1 modules
var ObjectToFormData = __webpack_require__(73948);
// EXTERNAL MODULE: ./src/@common/utility/helper/Utils.js + 8 modules
var Utils = __webpack_require__(7883);
// EXTERNAL MODULE: ./src/shared/constants/ActionTypes.js
var ActionTypes = __webpack_require__(91799);
;// CONCATENATED MODULE: ./src/shared/constants/api-url/customer/index.js
var URL_CUSTOMER_GET_LIST = "/customer/list";
var URL_CUSTOMER_GET_DETAIL = "/customer/get";
var URL_CUSTOMER_UPDATE = "/customer/cap-nhat";
var URL_GET_DATA_FOOTER = "/common/thong-tin-customer";

// EXTERNAL MODULE: ./src/shared/constants/UrlApis.js
var UrlApis = __webpack_require__(4278);
;// CONCATENATED MODULE: ./src/redux/actions/Customer.js








var onGetCustomerList = function() {
    jwt_auth/* default.defaults.baseURL */.ZP.defaults.baseURL = "".concat(UrlApis/* API_CAT_DANHMUC */.lR);
    var messages = (0,Utils/* appIntl */.Qr)().messages;
    return function(dispatch) {
        dispatch({
            type: ActionTypes.FETCH_START
        });
        jwt_auth/* default.get */.ZP.get(URL_CUSTOMER_GET_LIST).then(function(data) {
            if (data.data.statusCode === 200) {
                var response = data.data;
                dispatch({
                    type: ActionTypes.FETCH_SUCCESS
                });
                dispatch({
                    type: ActionTypes.GET_CUSTOMER_LIST,
                    payload: response
                });
            } else {
                dispatch({
                    type: ActionTypes.FETCH_ERROR,
                    payload: messages["message.somethingWentWrong"]
                });
            }
        }).catch(function(error) {
            console.error(error.message);
        });
    };
};
var onUpdateSelectedCustomer = function(customer, onToggle) {
    jwt_auth/* default.defaults.baseURL */.ZP.defaults.baseURL = "".concat(UrlApis/* API_CAT_DANHMUC */.lR);
    var messages = (0,Utils/* appIntl */.Qr)().messages;
    var formData = (0,ObjectToFormData/* default */.Z)(customer);
    return function(dispatch) {
        dispatch({
            type: ActionTypes.FETCH_START
        });
        jwt_auth/* default.post */.ZP.post(URL_CUSTOMER_UPDATE, formData).then(function(data) {
            if (data.data.statusCode === 200) {
                dispatch({
                    type: ActionTypes.FETCH_SUCCESS
                });
                dispatch(onGetCustomerList());
                dispatch({
                    type: ActionTypes.SHOW_MESSAGE,
                    payload: messages["message.customerUpdated"]
                });
                onToggle(false);
            } else {
                (0,FormHelper/* formErrorBE */.n)(data, dispatch, onToggle);
            }
        }).catch(function(error) {
            (0,FormHelper/* formErrorBE */.n)(error, dispatch, onToggle);
        });
    };
};
var onGetDataFooter = function() {
    jwt_auth/* default.defaults.baseURL */.ZP.defaults.baseURL = "".concat(UrlApis/* API_CAT */.yN);
    return function(dispatch) {
        var url = "".concat(URL_GET_DATA_FOOTER);
        jwt_auth/* default.get */.ZP.get(url).then(function(data) {
            if (data.data.statusCode === 200) {
                var response = data.data;
                dispatch({
                    type: ActionTypes.GET_DATA_FOOTER,
                    payload: response
                });
            } else {
                dispatch({
                    type: ActionTypes.GET_DATA_FOOTER_FAIL
                });
            }
        }).catch(function(error) {
            dispatch({
                type: ActionTypes.GET_DATA_FOOTER_FAIL
            });
        });
    };
};


/***/ }),

/***/ 28278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y4": function() { return /* binding */ onAnswerQuestion; },
  "Fd": function() { return /* binding */ onCreateQuestion; },
  "p$": function() { return /* binding */ onGetDetailQuestion; },
  "kL": function() { return /* binding */ onGetListCapHCByField; },
  "ic": function() { return /* binding */ onGetListQuestionField; },
  "ZN": function() { return /* binding */ onGetMostViewQuestion; },
  "PS": function() { return /* binding */ onGetQuestionList; },
  "F9": function() { return /* binding */ onGetQuestionNeedProcess; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./src/@common/services/auth/jwt-auth/index.js
var jwt_auth = __webpack_require__(91253);
// EXTERNAL MODULE: ./src/@common/utility/helper/Utils.js + 8 modules
var Utils = __webpack_require__(7883);
// EXTERNAL MODULE: ./src/shared/constants/ActionTypes.js
var ActionTypes = __webpack_require__(91799);
;// CONCATENATED MODULE: ./src/shared/constants/api-url/question/index.js
var URL_QUESTION_GET_LIST = "cau-hoi/list";
var URL_QUESTION_DETAIL = "cau-hoi/get";
var URL_QUESTION_MOST_VIEW = "cau-hoi/xem-nhieu-nhat";
var URL_QUESTION_CREATE = "cau-hoi/gui";
var URL_QUESTION_APPROVE = "cau-hoi/duyet";
var URL_QUESTION_ANSWER = "tra-loi/gui";
var URL_QUESTION_FIELD = "common/dropdown-linh-vuc";
var URL_QUESTION_CAP_HC_BY_FIELD = "cau-hoi/cap-hanh-chinh";
var URL_QUESTION_NEED_PROCESS = "cau-hoi/xu-ly";

// EXTERNAL MODULE: ./src/shared/constants/UrlApis.js
var UrlApis = __webpack_require__(4278);
;// CONCATENATED MODULE: ./src/redux/actions/guess/Question.js






jwt_auth/* default.defaults.baseURL */.ZP.defaults.baseURL = "".concat(UrlApis/* API_CAT_TTHC */.aF);
var onGetQuestionList = function(dataFilter) {
    var messages = (0,Utils/* appIntl */.Qr)().messages;
    jwt_auth/* default.defaults.baseURL */.ZP.defaults.baseURL = "".concat(UrlApis/* API_CAT_TTHC */.aF);
    return function(dispatch) {
        dispatch({
            type: ActionTypes.GET_QUESTION_CLIENT
        });
        var url = "".concat(URL_QUESTION_GET_LIST, "?").concat((0,Utils/* buildQueryString */.Ie)((0,Utils/* parseParams */.rz)((0,_object_spread/* default */.Z)({}, dataFilter))));
        jwt_auth/* default.get */.ZP.get(url).then(function(data) {
            if (data.data.statusCode === 200) {
                dispatch({
                    type: ActionTypes.FETCH_SUCCESS
                });
                dispatch({
                    type: ActionTypes.GET_QUESTION_LIST,
                    payload: data.data
                });
            } else {
                dispatch({
                    type: ActionTypes.GET_QUESTION_CLIENT_FAIL
                });
            }
        }).catch(function(error) {
            dispatch({
                type: ActionTypes.GET_QUESTION_CLIENT_FAIL
            });
        });
    };
};
var onGetListQuestionField = function() {
    var messages = (0,Utils/* appIntl */.Qr)().messages;
    jwt_auth/* default.defaults.baseURL */.ZP.defaults.baseURL = "".concat(UrlApis/* API_CAT_TTHC */.aF);
    return function(dispatch) {
        dispatch({
            type: ActionTypes.FETCH_START
        });
        jwt_auth/* default.get */.ZP.get(URL_QUESTION_FIELD).then(function(data) {
            if (data.data.statusCode === 200) {
                dispatch({
                    type: ActionTypes.FETCH_SUCCESS
                });
                dispatch({
                    type: ActionTypes.QUESTION_GET_FIELD,
                    payload: data.data
                });
            } else {
                dispatch({
                    type: ActionTypes.GET_QUESTION_FIELD_CLIENT_FAIL
                });
            }
        }).catch(function(error) {
            dispatch({
                type: ActionTypes.GET_QUESTION_FIELD_CLIENT_FAIL
            });
        });
    };
};
var onGetListCapHCByField = function(value) {
    var messages = (0,Utils/* appIntl */.Qr)().messages;
    jwt_auth/* default.defaults.baseURL */.ZP.defaults.baseURL = "".concat(UrlApis/* API_CAT_TTHC */.aF);
    return function(dispatch) {
        dispatch({
            type: ActionTypes.FETCH_START
        });
        jwt_auth/* default.get */.ZP.get("".concat(URL_QUESTION_CAP_HC_BY_FIELD, "?LinhVucId=").concat(value)).then(function(data) {
            if (data.data.statusCode === 200) {
                dispatch({
                    type: ActionTypes.FETCH_SUCCESS
                });
                dispatch({
                    type: ActionTypes.QUESTION_GET_CAP_HC_BY_FIELD,
                    payload: data.data
                });
            } else {
                dispatch({
                    type: ActionTypes.QUESTION_GET_CAP_HC_CLIENT_FAIL
                });
            }
        }).catch(function(error) {
            dispatch({
                type: ActionTypes.QUESTION_GET_CAP_HC_CLIENT_FAIL
            });
        });
    };
};
var onCreateQuestion = function(field, dataFilter, router) {
    var messages = (0,Utils/* appIntl */.Qr)().messages;
    jwt_auth/* default.defaults.baseURL */.ZP.defaults.baseURL = "".concat(UrlApis/* API_CAT_TTHC */.aF);
    return function(dispatch) {
        dispatch({
            type: ActionTypes.SEND_QUESTION
        });
        dispatch({
            type: ActionTypes.FETCH_START
        });
        jwt_auth/* default.post */.ZP.post(URL_QUESTION_CREATE, field).then(function(data) {
            if (data.data.statusCode === 200) {
                dispatch({
                    type: ActionTypes.SHOW_MESSAGE,
                    payload: messages["message.questionCreated"]
                });
                dispatch({
                    type: ActionTypes.FETCH_SUCCESS
                });
                dispatch({
                    type: ActionTypes.SENT_QUESTION
                });
                if (!field.continueCreate) {
                    router.push("/hoi-dap");
                    dispatch(onGetQuestionList(dataFilter));
                }
            } else {
                dispatch({
                    type: ActionTypes.SENT_QUESTION
                });
                dispatch({
                    type: ActionTypes.FETCH_ERROR,
                    payload: data.data.message
                });
            }
        }).catch(function(error) {
            dispatch({
                type: ActionTypes.SENT_QUESTION
            });
            console.error(error.message);
        });
    };
};
var onGetMostViewQuestion = function() {
    var messages = (0,Utils/* appIntl */.Qr)().messages;
    jwt_auth/* default.defaults.baseURL */.ZP.defaults.baseURL = "".concat(UrlApis/* API_CAT_TTHC */.aF);
    return function(dispatch) {
        dispatch({
            type: ActionTypes.FETCH_START
        });
        jwt_auth/* default.get */.ZP.get(URL_QUESTION_MOST_VIEW).then(function(data) {
            if (data.data.statusCode === 200) {
                dispatch({
                    type: ActionTypes.FETCH_SUCCESS
                });
                dispatch({
                    type: ActionTypes.GET_MOST_VIEW,
                    payload: data.data
                });
            } else {
                dispatch({
                    type: ActionTypes.GET_CLIENT_MOST_VIEW_FIELD
                });
            }
        }).catch(function(error) {
            dispatch({
                type: ActionTypes.GET_CLIENT_MOST_VIEW_FIELD
            });
        });
    };
};
var onGetDetailQuestion = function(slug, router) {
    jwt_auth/* default.defaults.baseURL */.ZP.defaults.baseURL = "".concat(UrlApis/* API_CAT_TTHC */.aF);
    var url = "".concat(URL_QUESTION_DETAIL, "?Slug=").concat(slug);
    return function(dispatch) {
        dispatch({
            type: ActionTypes.GET_QUESTION_DETAIL_CLIENT
        });
        jwt_auth/* default.get */.ZP.get(url).then(function(data) {
            if (data.data.statusCode === 200) {
                dispatch({
                    type: ActionTypes.GET_QUESTION_DETAIL,
                    payload: data.data
                });
            } else if (data.data.statusCode === 404) {
                router.push("/404");
            } else {
                dispatch({
                    type: ActionTypes.GET_QUESTION_DETAIL_CLIENT_FAIL
                });
            }
        }).catch(function(error) {
            dispatch({
                type: ActionTypes.GET_QUESTION_DETAIL_CLIENT_FAIL
            });
        // if (error.response.status === 404) {
        //   router.push('/404');
        // }
        });
    };
};
var onAnswerQuestion = function(field, handleCloseTraLoi, slug, router) {
    var messages = (0,Utils/* appIntl */.Qr)().messages;
    jwt_auth/* default.defaults.baseURL */.ZP.defaults.baseURL = "".concat(UrlApis/* API_CAT_TTHC */.aF);
    return function(dispatch) {
        dispatch({
            type: ActionTypes.QUESTION_ANSWER
        });
        dispatch({
            type: ActionTypes.FETCH_START
        });
        jwt_auth/* default.post */.ZP.post(URL_QUESTION_ANSWER, field).then(function(data) {
            if (data.data.statusCode === 200) {
                dispatch({
                    type: ActionTypes.FETCH_SUCCESS
                });
                handleCloseTraLoi();
                dispatch(onGetDetailQuestion(slug, router));
                dispatch({
                    type: ActionTypes.QUESTION_ANSWERED
                });
                dispatch({
                    type: ActionTypes.SHOW_MESSAGE,
                    payload: messages["message.questionAnswered"]
                });
            } else {
                dispatch({
                    type: ActionTypes.QUESTION_ANSWERED
                });
                dispatch({
                    type: ActionTypes.FETCH_ERROR,
                    payload: data.message
                });
            }
        }).catch(function(error) {
            console.error(error);
            dispatch({
                type: ActionTypes.QUESTION_ANSWERED
            });
        });
    };
};
var onGetQuestionNeedProcess = function(dataFilter) {
    var messages = (0,Utils/* appIntl */.Qr)().messages;
    jwt_auth/* default.defaults.baseURL */.ZP.defaults.baseURL = "".concat(UrlApis/* API_CAT_TTHC */.aF);
    return function(dispatch) {
        dispatch({
            type: ActionTypes.GET_QUESTION_NEED_PROCESS_CLIENT
        });
        var url = "".concat(URL_QUESTION_NEED_PROCESS, "?").concat((0,Utils/* buildQueryString */.Ie)((0,Utils/* parseParams */.rz)((0,_object_spread/* default */.Z)({}, dataFilter))));
        jwt_auth/* default.post */.ZP.post(url).then(function(data) {
            if (data.data.statusCode === 200) {
                dispatch({
                    type: ActionTypes.FETCH_SUCCESS
                });
                dispatch({
                    type: ActionTypes.GET_QUESTION_NEED_PROCESS,
                    payload: data.data
                });
            } else {
                dispatch({
                    type: ActionTypes.GET_QUESTION_NEED_PROCESS_FAIL
                });
            }
        }).catch(function(error) {
            dispatch({
                type: ActionTypes.GET_QUESTION_NEED_PROCESS_FAIL
            });
        });
    };
};


/***/ })

}]);